{
  "data": {
    "blog": {
      "apply_plan_settings": "https://www.planfred.com/de/blog/einstellungen-von-letztem-plan-uebernehmen",
      "daily_upload_alert": "https://www.planfred.com/de/blog/upload-melder-taeglich-und-rechtsklick-menue",
      "enhanced_manuals": "https://www.planfred.com/de/blog/planfred-aktualisiert-die-anleitungen",
      "features_2021": "https://www.planfred.com/de/blog/das-war-2021-in-features",
      "task_location": "https://www.planfred.com/de/blog/tasks-noch-praeziser-direkt-am-plan-verorten",
      "tasks_is_here": "https://www.planfred.com/de/blog/planfred-tasks-ist-da",
      "top_categories": "https://www.planfred.com/de/blog/obergruppen-projekte-in-bauteile-aufgliedern"
    },
    "email_support": "support{'@'}planfred.com",
    "pf_links": {
      "blog_features": "https://www.planfred.com/de/blog/?category=features",
      "clipboard": "https://www.planfred.com/de/anleitungen/#Zwischenablage%20–%20Mehrere%20Pläne%20oder%20Dokumente%20anlegen",
      "faq": "https://www.planfred.com/de/haeufig-gestellte-fragen/",
      "faq_project_transfer": "https://www.planfred.com/de/anleitungen/#Projektübertragung%20–%20Projekteigentümer%20ändern",
      "impressum": "https://www.planfred.com/de/impressum-agb-gmbh/",
      "in_app_support": "https://calendly.com/planfred/in-app-support-de",
      "manual_approvals": "https://www.planfred.com/de/anleitungen/#Freigabe/Pr%C3%BCfung%20von%20Pl%C3%A4nen%20und%20Dokumenten",
      "manual_compare_indexes": "https://www.planfred.com/de/anleitungen/#Planindizes%20vergleichen",
      "manual_project_transfer": "https://www.planfred.com/de/anleitungen/#Projekt%C3%BCbertragung%20%E2%80%93%20Projekteigent%C3%BCmer%20%C3%A4ndern",
      "manual_tips": "https://www.planfred.com/de/anleitungen/",
      "manual_update_plans": "https://www.planfred.com/de/anleitungen/#Mehrere%20Pl%C3%A4ne%20automatisch%20aktualisieren",
      "personal_support": "https://www.planfred.com/de/kontakt/",
      "planfred_app_registration": "https://app.planfred.com/registration",
      "planfred_website": "https://www.planfred.com",
      "privacy_policy": "https://www.planfred.com/de/datenschutz/",
      "your_project_in_5_steps": "https://www.planfred.com/hilfe/ihr-projekt-in-wenigen-schritten-organisiert",
      "your_project_in_5_steps_documents": "https://www.planfred.com/hilfe/ihr-projekt-in-wenigen-schritten-organisiert/#neues-dokument-anlegen-dokument-erstmalig-hochladen",
      "your_project_in_5_steps_participants": "https://www.planfred.com/hilfe/ihr-projekt-in-wenigen-schritten-organisiert#beteiligte-zum-projekt-einladen-berechtigungen",
      "your_project_in_5_steps_plans": "https://www.planfred.com/hilfe/ihr-projekt-in-wenigen-schritten-organisiert/#neuen-plan-anlegen-plan-erstmalig-hochladen"
    },
    "phone_number": "+43 1 9974470-1"
  },
  "enterprise": {
    "apg_planserver": {
      "accountActivationTerms": {
        "account_page_download_headline": "Revers zur Nutzung der Datenplattform",
        "checkboxLabel": "Ich bestätige, dass ich die Anweisungen des Revers zur Nutzung der Datenplattform PLANFRED i.d.g.F. gelesen habe und dass diese eingehalten werden.",
        "download_specifications": "Revers herunterladen",
        "download_terms_file_path": "/static/img/email/apgplanserverat/APG_UAW_Planverwaltung-REVERS_2021-07-21.pdf",
        "error_message": "Stimmen Sie den Vorgaben zu."
      },
      "monthly_project_overview_report": {
        "can_approve_revisions": "Plan-Prüfberechtigung",
        "company": "Firma",
        "email": "E-Mail (Benutzerkonto)",
        "email_subject": "APG-Planserver Projektübersicht",
        "email_title": "APG-Planserver",
        "from": "{appName} Projekt-Beteiligten-Report",
        "last_project_access": "Letzter Projektzugriff",
        "monthly_project_overview": "Monatliche Projektübersicht",
        "monthly_report_title": "APG-Planfred-Monatsreport",
        "name": "Name",
        "participants_list_title": "APG-Planfred-Beteiligtenliste",
        "permission": "Berechtigung",
        "phone": "Tel. Nr.",
        "project_admin_at_project": "Projekt-Administrator bei Projekt",
        "project_admins": "Projekt-Administratoren",
        "project_owner": "Projekteigentümer",
        "project_owner_at_project": "Projekteigentümer bei Projekt",
        "project_participant_at_project": "Projekt-Beteiligter bei Projekt",
        "project_participant_silent_at_project": "Beteiligter ohne Login bei Projekt",
        "project_participants": "Projekt-Beteiligte",
        "project_participants_silent": "Beteiligte ohne Login",
        "project_title": "Projekttitel",
        "projects_list_title": "APG-Planfred-Projektliste",
        "roles": "Rolle"
      },
      "password_rules": {
        "has_cap_char": "… einen Großbuchstaben enthalten",
        "has_low_char": "… einen Kleinbuchstaben enthalten",
        "has_number": "… eine Nummer enthalten",
        "has_special_char": "… ein Sonderzeichen enthalten",
        "is_gt_11": "… 10 Zeichen lang sein",
        "your_password": "Ihr Passwort muss mindestens …"
      }
    },
    "klg_planserver": {
      "accountActivationTerms": {
        "account_page_download_headline": "Vorgaben des KLG Planservers",
        "checkboxLabel": "Ich stimme den Vorgaben des KLG Planservers zu.",
        "download_specifications": "Vorgaben herunterladen",
        "download_terms_file_path": "/static/img/email/klgplanserverde/Vorgaben_klg-planserver.de_Version_2.pdf",
        "error_message": "Stimmen Sie den Vorgaben zu."
      }
    }
  },
  "feature": {
    "company_dashboard": {
      "send_to_additional_admins": "An weitere Administratoren senden",
      "title": "Unternehmensverwaltung",
      "hint": "Zentrale Verwaltung aller Projekte und Benutzerkonten der Domain <strong>{domain}</strong>.",
      "projects_tab": "Projekte",
      "users_tab": "Benutzerkonten",
      "no_projects": "Keine Projekte gefunden.",
      "no_users": "Keine Benutzer gefunden.",
      "loading": "Laden...",
      "load_error": "Fehler beim Laden der Daten.",
      "project_title": "Projektname",
      "owner_name": "Eigentümer",
      "owner_company": "Eigentümer-Firma",
      "participant": "Beteiligte",
      "project_created": "Erstellt",
      "take_ownership": "Eigentümer werden",
      "take_ownership_title": "Projekteigentümerschaft übernehmen?",
      "take_ownership_confirm": "Eigentümerschaft übernehmen",
      "take_ownership_confirm_message": "Soll die Eigentümerschaft des Projekts „<strong>{projectTitle}</strong>“ wirklich von <strong>{currentOwnerName} ({currentOwnerEmail})</strong> übernommen werden?",
      "take_ownership_error": "Fehler beim Übernehmen der Eigentümerschaft.",
      "take_all_project_ownership": "Alle Projekte als Eigentümer übernehmen",
      "take_all_project_ownership_question": "Soll die Eigentümerschaft wirklich für alle untenstehenden Projekte übernommen werden?",
      "take_all_project_ownership_confirm": "Eigentümerschaft für alle Projekte übernehmen",
      "ownership_taken_by_you": "Eigentum übernommen",
      "user_email": "E-Mail",
      "user_name": "Name",
      "user_company": "Unternehmen",
      "user_last_login": "Letzter Login",
      "user_last_login_never": "Nie",
      "user_active": "Aktiv",
      "user_status": "Status",
      "user_status_active": "Aktiviert",
      "user_status_inactive": "Deaktiviert",
      "disable_user": "Benutzerkonto deaktivieren",
      "deactivate_user": "Benutzer deaktivieren",
      "enable_user": "Benutzerkonto aktivieren",
      "enable_title": "Benutzerkonto aktivieren?",
      "enable_confirm": "Aktivieren bestätigen",
      "enable_confirm_message": "Soll das Konto von <strong>{userName} ({userEmail})</strong> wirklich aktiviert werden?",
      "disable_users_preview": "Hiermit werden die ausgewählten Benutzerkonten deaktiviert.",
      "disable_title": "Benutzerkonto deaktivieren?",
      "disable_confirm": "Deaktivieren bestätigen",
      "disable_confirm_message": "Soll das Konto von <strong>{userName} ({userEmail})</strong> wirklich deaktiviert werden?",
      "disable_owner_warning": "Dieser Benutzer ist Eigentümer eines oder mehrerer Projekte. Bitte Eigentümerschaft übernehmen, bevor das Konto deaktiviert wird.",
      "user_delete": "Benutzer aus Projekten löschen",
      "users_delete": "Benutzer aus Projekten löschen",
      "user_disable": "Ausgewählten Benutzer deaktivieren",
      "users_disable": "Ausgewählte Benutzer deaktivieren",
      "user_enable": "Ausgewählten Benutzer aktivieren",
      "users_enable": "Ausgewählte Benutzer aktivieren",
      "user_take_ownership": "Eigentümerschaft der Projekte des ausgewählten Benutzers übernehmen",
      "users_take_ownership": "Eigentümerschaft der Projekte der ausgewählten Benutzer übernehmen",
      "users_selected_status": "{selectedCount} von {totalCount} ausgewählt",
      "cannot_update_user": "Dieser Benutzer kann nicht geändert werden",
      "cannot_update_users": "{filteredCount} von {totalCount} Benutzer können nicht geändert werden",
      "trash_participants_from_projects": "Beteiligte aus Projekten löschen",
      "trash_user": "Benutzer löschen",
      "trash_one_user": "1 Benutzer löschen",
      "trash_x_users": "{counter} Benutzer löschen",
      "update_one_user": "1 Benutzer aktualisieren",
      "update_x_users": "{counter} Benutzer aktualisieren",
      "enable_one_user": "1 Benutzer aktivieren",
      "enable_x_users": "{counter} Benutzer aktivieren",
      "disable_one_user": "1 Benutzer deaktivieren",
      "disable_x_users": "{counter} Benutzer deaktivieren",
      "delete_users_preview": "Ausgewählte Benutzer als Beteiligte aus ihren Projekten löschen.",
      "delete_users_error": "Fehler beim Löschen der Beteiligten aus Projekten. Bitte versuchen Sie es erneut.",
      "delete_user_no_projects": "Für diesen Benutzer wird keine Projektbeteiligung entfernt.",
      "delete_user_no_project_participation_warning": "Dieser Benutzer ist in keinem Projekt beteiligt.",
      "delete_user_not_project_participant_warning": "Dieser Benutzer ist in diesem Projekt nicht beteiligt.",
      "trash_participants_skipped_projects_label": "Folgende Projekte werden übersprungen:",
      "cannot_delete_own_account": "Sie können sich nicht selbst aus Projekten löschen.",
      "cannot_disable_own_account": "Sie können Ihr eigenes Konto nicht deaktivieren.",
      "cannot_take_ownership_own_account": "Sie können nicht die Eigentümerschaft Ihrer eigenen Projekte übernehmen.",
      "trash_project_owner_warning": "Projekteigentümer können nicht aus ihren Projekten gelöscht werden.",
      "delete_disabled_participant_warning": "Deaktivierte Beteiligte können nicht geändert werden.",
      "delete_disabled_user_warning": "Deaktivierte Benutzer können nicht geändert werden.",
      "enable_active_user_warning": "Aktive Benutzer können nicht geändert werden.",
      "delete_user_excluded_projects_warning": "Sie haben keinen Eigentümer- oder Administratorzugriff auf dieses Projekt.",
      "take_ownership_selected_preview": "Übernehmen Sie den Besitz der Projekte der ausgewählten Benutzer.",
      "take_ownership_selected_projects_label": "Besitz von {count} Projekt(en) übernehmen",
      "take_ownership_user": "Eigentümerschaft übernehmen",
      "take_ownership_one_user": "Eigentümerschaft von 1 Benutzer übernehmen",
      "take_ownership_x_users": "Eigentümerschaft von {counter} Benutzern übernehmen",
      "take_ownership_no_projects": "Für die ausgewählten Benutzer wurden keine eigenen Projekte gefunden.",
      "take_ownership_load_error": "Eigene Projekte konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "remove_from_project_btn": "Beteiligten löschen",
      "remove_from_project_title": "Beteiligten aus Projekt löschen?",
      "remove_from_project_confirm": "Löschen bestätigen",
      "remove_from_project_confirm_message": "Möchten Sie <strong>{userName} ({userEmail})</strong> wirklich als beteiligte Person aus dem Projekt „<strong>{projectTitle}</strong>“ löschen?",
      "remove_from_project_error": "Fehler beim Löschen des Benutzers aus dem Projekt.",
      "trash_from_all_projects_btn": "Aus allen Projekten löschen",
      "trash_from_all_projects_question": "Möchten Sie <strong>{userName} ({userEmail})</strong> wirklich als beteiligte Person aus allen Projekten löschen?",
      "trash_from_all_projects_confirm": "Aus allen Projekten löschen",
      "toggle_enabled_error": "Fehler beim Aktualisieren des Kontostatus.",
      "cancel": "Abbrechen",
      "owner_email": "Eigentümer E-Mail",
      "no_project_access": "Kein Projektzugriff",
      "domain": "Domain",
      "view_projects_btn": "Teilnehmende Projekte",
      "view_projects_role_label": "Rolle",
      "notify_owners_btn": "Projekt-Admins kontaktieren",
      "notify_owners_message": "Betreffende Projekt-Administratoren per E-Mail kontaktieren",
      "notify_owners_create_message": "Nachricht erstellen",
      "notify_owners_title": "Projekt-Admins kontaktieren",
      "notify_owners_loading": "Projekte werden geladen...",
      "notify_owners_load_error": "Projekte konnten nicht geladen werden. Bitte erneut versuchen.",
      "notify_owners_no_projects": "Es sind keine Eigentümer oder Administratoren verfügbar, die für die Projekte dieses Benutzers benachrichtigt werden könnten.",
      "notify_owners_subject_label": "Betreff",
      "notify_owners_projects_label": "Empfänger auswählen",
      "notify_owners_confirm": "Benachrichtigungen senden",
      "notify_owners_submit_error": "Fehler beim Senden der Benachrichtigungen. Bitte erneut versuchen.",
      "user_account_participating_projects_headline": "Interne Projektbeteiligungen",
      "external_projects_headline": "Externe Projektbeteiligungen",
      "user_account_participating_projects_empty": "Keine internen Projektbeteiligungen",
      "notify_owners_subject_prefix": "{userEmail} –",
      "notify_owners_default_subject_suffix": "Projektbeteiligung – Änderung",
      "notify_owners_successfully_sent_to_one": "Benachrichtigung erfolgreich versendet an:",
      "notify_owners_successfully_sent_to_many": "Benachrichtigungen erfolgreich versendet an:",
      "notify_owners_delivery_failed_to_one": "Der Versand an folgenden Empfänger ist fehlgeschlagen:",
      "notify_owners_delivery_failed_to_many": "Der Versand an folgende Empfänger ist fehlgeschlagen:",
      "external_projects_info_single": "Es gibt 1 Beteiligung an Projekten externer Unternehmen",
      "external_projects_info_multiple": "Es gibt mehrere Beteiligungen an Projekten externer Unternehmen",
      "external_projects_none": "Keine externen Projektbeteiligungen"
    },
    "account": {
      "billing_data": {
        "active_subscription_until": "Aktives Abonnement bis {subscriptionEndDate} – wird automatisch verlängert",
        "add_credit_card_data": "Geben Sie Inhaber und Kreditkartennummer ein.",
        "add_new_credit_card": "Neue Kreditkarte hinzufügen",
        "additional_invoice_information": "Zusatzinformationen zur Rechnungslegung:",
        "address": "Adresse",
        "billing_address": "Rechnungsanschrift",
        "city": "Ort/Stadt",
        "company": "Firmenname",
        "country": "Land",
        "credit_card": "Kreditkarte",
        "credit_card_could_not_get_verified": "Die Kreditkarte konnte nicht verifiziert werden – versuchen Sie eine andere Karte.",
        "edit_subscription": "Paketeinstellungen ändern",
        "error": {
          "city_required": "Geben Sie einen Ort/Stadt ein.",
          "company_required": "Geben Sie eine Firma ein.",
          "country_required": "Geben Sie ein Land ein.",
          "email_invalid": "Geben Sie eine gültige E-Mail-Adresse ein.",
          "email_required": "Geben Sie eine E-Mail-Adresse ein.",
          "plan_not_allowed_for_user": "Bitte wählen Sie ein entsprechendes Paket aus.",
          "save_error": "Speichern fehlgeschlagen!",
          "street_required": "Geben Sie eine Straße ein.",
          "uid_required": "Geben Sie eine UID ein.",
          "zip_required": "Geben Sie eine Postleitzahl ein."
        },
        "existing_credit_card": "Vorhandene Kreditkarte: •••• •••• •••• {last4}",
        "invoice_recipient": "E-Mail Rechnungsempfänger",
        "no_company_name": "Geben Sie einen Firmennamen ein.",
        "no_payment_method_defined_yet": "Noch keine Zahlungsmethode definiert",
        "payment_method": "Zahlungsmethode",
        "payment_method_creation_server_error": "Es gab einen Fehler beim Speichern Ihrer Zahlungsmethode. Kontaktieren Sie unseren Support",
        "payment_method_owner": "Inhaber",
        "save_subscription": "Paketeinstellungen speichern",
        "sepa": "SEPA-Lastschrift",
        "street": "Straße",
        "uid": "UID-Nummer",
        "uid_not_valid": "Ihre UID-Nummer ist nicht valide. Überprüfen Sie die Daten oder kontaktieren Sie unseren Support, falls Sie die UID-Nummer auf der Rechnung hinterlegt haben möchten.",
        "zip": "PLZ"
      },
      "company_wide_account": {
        "info": "Ihr Benutzerkonto wird automatisch über das Firmen-Paket <strong>{'@'}{domain}</strong> abgerechnet.",
        "support_link": "Bei Fragen wenden Sie sich an <a href=\"mailto:buchhaltung{'@'}planfred.com?subject=Anfrage Abrechnung Firmen-Paket: {'@'}{domain}\">buchhaltung{'@'}planfred.com</a>."
      },
      "delete_account": {
        "account_cannot_be_deleted": "Ihr Benutzerkonto kann noch nicht gelöscht werden!",
        "close_account_deletion": "Löschvorgang schließen",
        "delete_account": "Benutzerkonto löschen",
        "delete_account_forever": "Benutzerkonto unwiderruflich löschen",
        "delete_error": "Löschen fehlgeschlagen!",
        "enter_delete_to_confirm": "Bestätigen Sie den Löschvorgang durch Eingabe des Wortes „delete“",
        "goto_project_settings": "Projekteinstellungen",
        "header_can_not_delete_account": "Ihr Benutzerkonto kann noch nicht gelöscht werden",
        "leave_projects_participating": "Ausgewählte Projekte verlassen",
        "project_cancellation_request_sent": "Die ausgewählten Projekteigentümer wurden benachrichtigt. Sobald Sie von einem Projekt entfernt wurden, wird dieses in dieser Liste nicht mehr angezeigt.",
        "projects_owning_view_header": "Sie haben noch eigene Projekte",
        "projects_owning_view_message": "Archivieren und löschen Sie Ihre eigenen Projekte in den jeweiligen Projekteinstellungen.",
        "projects_participating_view_header": "Sie sind noch bei Projekten beteiligt",
        "projects_participating_view_message": "Wählen Sie alle Projekte aus die Sie verlassen möchten, damit wir die jeweiligen Projekteigentümer benachrichtigen können.",
        "send_error": "Senden fehlgeschlagen!",
        "to_projectlist": "Zur Projektliste",
        "warning_delete_projects": "Bevor Sie Ihr Benutzerkonto löschen können müssen Sie Ihre eigenen Projekte löschen!"
      },
      "plan_selection": {
        "approval_system": "Freigabe-System",
        "backup_app": "Backup-App",
        "billing_method": {
          "annually": "Jährliche Zahlung",
          "annually_hint": "1 Monat gratis bei jährlicher Zahlung",
          "monthly": "Monatliche Zahlung"
        },
        "cancel_plan": "Plan kündigen",
        "cancel_plan_message_label": "Helfen Sie uns Planfred zu verbessern:",
        "cancel_unsubscribe": "Kündigung zurückziehen",
        "document_vault": "Dokumenten-Zugriffsberechtigung",
        "documents": "Dokumente",
        "email_support": "E-Mail-Support",
        "fair_use_text": "Es gilt eine „Fair Use“-Nutzung als vereinbart – bei Extremnutzung über 1 Terabyte behalten wir uns eine individuelle Tarifanpassung vor.",
        "free": {
          "for_free": "KOSTENLOS",
          "free": "free",
          "no_own_projects": "0 eigene Projekte, NUR Projektbeteiligungen",
          "price": "€ 0"
        },
        "in_app_support": "InApp-Beratung mit Screensharing",
        "is_enterprise_contract": "Dieser Server ist ein Enterprise Vertrag.",
        "maxi": {
          "maxi": "Maxi",
          "price_per_month": "€ 235",
          "price_per_year": "€ 2.585"
        },
        "message_testphase_end": "Sie können ihre Projekte danach nahtlos weiterführen!",
        "midi": {
          "midi": "Midi",
          "price_per_month": "€ 75",
          "price_per_year": " € 825",
          "storage_space_v1": "30 GB Speicherplatz",
          "storage_space_v2": "30 GB Speicherplatz"
        },
        "mini": {
          "mini": "Mini",
          "price_per_month": "€ 25",
          "price_per_year": "€ 275",
          "projects": "1 Projekt",
          "storage_space_v1": "5 GB Speicherplatz",
          "storage_space_v2": "5 GB Speicherplatz"
        },
        "no_comment": "Keine Angabe",
        "not_selectable": "Nicht wählbar",
        "not_suitable": "Für mich ungeeignet",
        "online_course": "Online-Schulung",
        "package_selection": "Paketauswahl",
        "per_month": "pro Monat",
        "per_year": "pro Jahr",
        "personal_consultant": "Persönlicher Ansprechpartner mit 20 Jahren Bauprojekt-Erfahrung",
        "phone_support": "Telefon-Support <nobr>für alle Beteiligten</nobr>",
        "photolog": "Fotodokumentation",
        "plans": "Pläne",
        "please_contact_support_message": "Bei Vertragsfragen wenden Sie sich an buchhaltung{'@'}planfred.com",
        "prime": {
          "price_per_month": "€ 385",
          "price_per_year": "€ 4.235",
          "prime": "Prime"
        },
        "project_completed": "Projekt abgeschlossen",
        "project_support": "Unterstützung bei Projektorganisation",
        "tasks": "Tasks",
        "tax": "Alle Preise verstehen sich zuzüglich der gesetzlichen Umsatzsteuer.",
        "trial_period_ended": "Ihre Planfred-Testphase endete {date}!",
        "trial_period_ends": "Ihre Planfred-Testphase endet {date}!",
        "unlimited_admin": "Admins unbegrenzt",
        "unlimited_projects": "Projekte unbegrenzt",
        "unlimited_storage": "Speicherplatz unbegrenzt<sup>1)</sup>",
        "unlimited_user": "Beteiligte unbegrenzt",
        "unsubscribe_button_anually": "Paket kündigen",
        "unsubscribe_button_monthly": "Paket kündigen mit {unsubscribeDate}",
        "unsubscribe_message_annually": "Sie haben ihr Paket gekündigt – unser Support wird Sie demnächst kontaktieren!",
        "unsubscribe_message_monthly": "Sie haben ihr Paket mit dem Stichtag {unsubscribeDate} gekündigt!"
      },
      "projects_participating": {
        "info_unlimited": "Projektbeteiligungen sind unbegrenzt und kostenlos.",
        "project_count": "Projektanzahl",
        "projects_participating": "Projektbeteiligungen"
      },
      "projects_user": {
        "midi_storage_15": "Sie haben die Speichergrenze von 15 GB überschritten",
        "midi_storage_25": "Sie haben die Speichergrenze von 25 GB überschritten",
        "midi_storage_30": "Sie haben die Speichergrenze von 30 GB überschritten",
        "mini_projects": "In ihrem Mini-Paket ist nur ein Projekt inkludiert.",
        "mini_storage_1": "Sie haben die Speichergrenze von 1 GB überschritten",
        "mini_storage_5": "Sie haben die Speichergrenze von 5 GB überschritten",
        "mini_storage_projects": "Sie haben die Speichergrenze von 1 GB überschritten und mehr als ein Projekt",
        "my_projects": "eigene Projekte",
        "of": "von",
        "project_count": "Projektanzahl",
        "projects_participated": "Projekt-Beteiligungen",
        "projects_user_title": "Eigene Projekte",
        "to_projectlist": "zur Projektliste",
        "upgrade_package": "Paket jetzt upgraden",
        "upgrade_title": "Paket-Upgrade empfohlen",
        "used_storage": "Speicherverbrauch"
      },
      "switch_language": "Sprache wechseln",
      "title": "Benutzerkonto",
      "trial_period_banner": {
        "choose_plan": "Paket auswählen",
        "continue_working_if_plan_selected": "Wenn Sie PLANFRED beauftragen möchten, wählen Sie das gewünschte Paket (MINI, MIDI, MAXI oder PRIME) aus. So können Sie nahtlos an Ihren Projekten weiterarbeiten.",
        "extend_test_phase": "Testphase verlängern?",
        "trial_period_ended": "Ihre PLANFRED-Testphase endete {date}!",
        "trial_period_ends": "Ihre PLANFRED-Testphase endet {date}!"
      },
      "user_data": {
        "change_user_company": "Unternehmen ändern",
        "change_user_data": "Benutzerdaten ändern",
        "change_user_name": "Name ändern",
        "company": "Unternehmen",
        "company_placeholder": "Bau GmbH",
        "email": "E-Mail-Adresse",
        "email_placeholder": "alex.schmid{'@'}bau-gmbh.com",
        "error": {
          "company_required": "Geben Sie eine Firma ein.",
          "email_cant_be_changed": "Die E-Mail-Adresse kann nicht geändert werden!",
          "first_name_required": "Geben Sie einen Vornamen ein.",
          "last_name_required": "Geben Sie einen Nachnamen ein.",
          "save_error": "Speichern fehlgeschlagen!"
        },
        "first_name": "Vorname",
        "first_name_placeholder": "Alex",
        "last_name": "Nachname",
        "last_name_placeholder": "Schmid",
        "name": "Name",
        "user_account": "Benutzerkonto",
        "user_data": "Benutzerdaten"
      },
      "user_security": {
        "change_password": "Passwort ändern",
        "error": {
          "password_required": "Geben Sie ein Passwort ein",
          "recovery_code_required": "Geben Sie Ihren Wiederherstellungsschlüssel ein.",
          "save_error": "Speichern fehlgeschlagen!",
          "save_error_old_password_invalid": "Ihr aktuelles Passwort ist ungütlig.",
          "two_factor_code_required": "Geben Sie Ihren Authentifizierungscode ein."
        },
        "new_password_label": "Neues Passwort:",
        "old_password_label": "Aktuelles Passwort:",
        "password_label": "Passwort:",
        "security": "Kontosicherheit"
      },
      "user_signature": {
        "allowed_upload_file_types": "Es werden nur .jpeg, .jpg, und .png Dateien unterstützt.",
        "change_signature": "Change signature",
        "create_signature": "Signaturvorlage erstellen",
        "file_upload_error": "Es gab einen Fehler beim Hochladen der Datei – versuchen Sie es erneut.",
        "image_file_size_upload_error": "Signatur-Bilder dürfen maximal 100kb groß sein damit Ihre E-Mails weiterhin schnell geladen werden.",
        "info_signature_image": "Fügen Sie Ihr Logo in Ihre Signatur ein (Dateityp .jpg oder .png, max. 100Kb). Klicken Sie dazu oben auf die Büroklammer.",
        "signature": "Signatur"
      },
      "user_two_factor_authentication": {
        "disable": "2-Faktor-Authentifizierung deaktivieren",
        "label": "2-Faktor-Authentifizierung",
        "message_activated": "Sie haben die 2-Faktor-Authentifizierung aktiviert.",
        "message_deactivated": "Sie haben die 2-Faktor-Authentifizierung deaktiviert.",
        "off": "Off",
        "on": "On",
        "password_invalid": "Password ungültig",
        "provide_password": "Geben Sie Ihr Passwort ein",
        "request": "2-Faktor-Authentifizierung aktivieren",
        "disable_warning_projects_require_2fa": "Sie sind an Projekten beteiligt, die eine 2-Faktor-Authentifizierung erfordern. Wenn Sie diese deaktivieren, verlieren Sie den Zugang zu diesen Projekten:"
      }
    },
    "activities": {
      "activities_loading": "Aktivitäten werden geladen ...",
      "activity_detail": "Aktivitäten-Detail",
      "category_selector": {
        "all": "Alle",
        "approval": "Prüfung",
        "category": "Kategorie",
        "downloads": "Download",
        "other": "Andere",
        "photos": "Fotos",
        "receive": "Empfang",
        "sent": "Versand",
        "tasks": "Tasks",
        "uploads": "Upload"
      },
      "filter_participant_role": "Filter \"Beteiligter/Rolle\"",
      "index": "Index",
      "list_header_description": "Beschreibung",
      "list_header_time": "Zeitpunkt",
      "list_header_type": "Art",
      "loading": "Lädt …",
      "loading_error": "FEHLER",
      "no_activities_for_participant_message": "Aktuell gibt es keine Aktivitäten der jeweiligen Beteiligten.",
      "no_activities_found": "Es liegen im gewählten Zeitraum keine Aktivitäten vor.",
      "no_activities_found_with_filter": "Mit den aktuellen Filtereinstellungen konnten in diesem Zeitraum keine Aktivitäten gefunden werden.",
      "participant_role": "Beteiligte/Rollen",
      "plans_documents": "Pläne/Dokumente",
      "print": {
        "activities_list": "Aktivitäten",
        "amount": "Anzahl:",
        "categories": "Kategorien:",
        "category": "Kategorie:",
        "date_from_to": "{startDate} - {endDate}",
        "multiple_activities": "{activitiesLength} Aktivitäten",
        "one_activity": "1 Aktivität",
        "participant": "Beteiligte:",
        "period": "Zeitraum:",
        "print_overlay_is_being_prepared": "Ihr Aktivitätenausdruck wird vorbereitet … {renderedItemsLength} / {allItemsLength}",
        "role": "Rolle:"
      },
      "print_list": "Aktivitätenliste drucken",
      "range_picker": {
        "period": "Zeitraum",
        "project_start": "Projektstart",
        "today": "Heute",
        "x_days": "{x} Tage"
      },
      "render_error": "Diese Aktivität kann nicht angezeigt werden.",
      "renderer": {
        "get_approval_comment_attachment": {
          "has_downloaded": "{participant} hat im Plan {planLink} den Kommentaranhang {attachmentName} geladen.",
          "has_downloaded_first_download": "{participant} hat im Plan {planLink} den Kommentaranhang {attachmentName} erstmals geladen.",
          "has_downloaded_latest_download": "{participant} hat im Plan {planLink} den Kommentaranhang {attachmentName} letztmals geladen."
        },
        "get_document_approval_comment_attachment": {
          "has_downloaded": "{participant} hat im Dokument {documentLink} den Kommentaranhang {attachmentName} geladen.",
          "has_downloaded_first_download": "{participant} hat im Dokument {documentLink} den Kommentaranhang {attachmentName} erstmals geladen.",
          "has_downloaded_latest_download": "{participant} hat im Dokument {documentLink} den Kommentaranhang {attachmentName} letztmals geladen."
        },
        "get_document_revision": {
          "has_downloaded": "{participant} hat die Datei {fileName} von Dokument {documentLink} geladen.",
          "has_downloaded_first_download": "{participant} hat die Datei {fileName} von Dokument {documentLink} erstmals geladen.",
          "has_downloaded_latest_download": "{participant} hat die Datei {fileName} von Dokument {documentLink} letztmals geladen."
        },
        "get_plan_revision_dwg": {
          "has_downloaded_plan": "{participant} hat die CAD-Datei {fileName} des Plans {planLink} geladen.",
          "has_downloaded_plan_first_download": "{participant} hat die CAD-Datei {fileName} des Plans {planLink} erstmals geladen.",
          "has_downloaded_plan_latest_download": "{participant} hat die CAD-Datei {fileName} des Plans {planLink} letztmals geladen."
        },
        "get_plan_revision_pdf": {
          "has_downloaded_plan": "{participant} hat die Druck-Datei {fileName} des Plans {planLink} geladen.",
          "has_downloaded_plan_first_download": "{participant} hat die Druck-Datei {fileName} des Plans {planLink} erstmals geladen.",
          "has_downloaded_plan_latest_download": "{participant} hat die Druck-Datei {fileName} des Plans {planLink} letztmals geladen."
        },
        "patch_document_author": {
          "has_changed_author": "{participant} hat den Verfasser des Dokuments {documentLink} von {authorParticipantOld} auf {authorParticipantNew} geändert."
        },
        "patch_document_permission": {
          "administrators": "Administratoren",
          "creator": "Verfasser",
          "has_changed_from_public_to_restricted": "{participant} hat die Zugriffsberechtigung des Dokuments {documentLink} von ÖFFENTLICH auf nur SICHTBAR für {restrictedParticipants} geändert.",
          "has_changed_from_restricted_to_public": "{participant} hat die Zugriffsberechtigung des Dokuments {documentLink} von nur SICHTBAR für {restrictedParticipants} auf ÖFFENTLICH geändert.",
          "has_changed_from_restricted_to_restricted": "{participant} hat die Zugriffsberechtigung des Dokuments {documentLink} von nur SICHTBAR für {restrictedParticipantsOld} auf nur SICHTBAR für {restrictedParticipantsNew} geändert."
        },
        "patch_document_permission_download_link": {
          "has_disabled": "{changerParticipant} hat den Downloadlink von {targetParticipant} für {documentLink} deaktiviert.",
          "has_enabled": "{changerParticipant} hat den Downloadlink von {targetParticipant} für {documentLink} aktiviert."
        },
        "patch_document_revision_approval": {
          "approval_cancelled": "Diese Dokumentenprüfung wurde zurückgezogen.",
          "approval_done": "Diese Dokumentenprüfung ist abgeschlossen.",
          "approval_not_done": "Diese Dokumentenprüfung ist noch nicht abgeschlossen!",
          "has_changed_approval": "{participant} hat für die Revision {documentLinkRevision} in Dokument {documentLink} die Prüfung geändert.",
          "revision_approved": "Diese Dokumentenversion ist freigegeben!",
          "revision_not_approved": "Diese Dokumentenversion ist NICHT freigegeben!"
        },
        "patch_document_revision_approval_date": {
          "has_changed_approval_date": "{participant} hat für die Revision {documentLinkRevision} in Dokument {documentLink} die Prüffrist von {oldApprovalDate} auf {newApprovalDate} geändert.",
          "has_changed_approval_date_short": "{participant} hat die Prüffrist von {oldApprovalDate} auf {newApprovalDate} geändert.",
          "has_introduced_approval_date": "{participant} hat für die Revision {documentLinkRevision} in Dokument {documentLink} die Prüffrist {newApprovalDate} nachträglich gesetzt.",
          "has_introduced_approval_date_short": "{participant} hat die Prüffrist {newApprovalDate} nachträglich gesetzt.",
          "has_removed_approval_date": "{participant} hat für die Revision {documentLinkRevision} in Dokument {documentLink} die Prüffrist entfernt.",
          "has_removed_approval_date_short": "{participant} hat die Prüffrist entfernt."
        },
        "patch_document_top_categories_enabled": {
          "has_disabled_top_categories": "{participant} hat Dokumenten Obergruppen deaktiviert.",
          "has_enabled_top_categories": "{participant} hat Dokumenten Obergruppen aktiviert."
        },
        "patch_document_top_category": {
          "has_changed_category": "{participant} hat die Obergruppe bei {documentLink} von {oldCategory} auf {newCategory} geändert."
        },
        "patch_document_trash": {
          "has_deleted_document": "{participant} hat das Dokument {documentLink} gelöscht.",
          "has_restored_document": "{participant} hat das Dokument {documentLink} wiederhergestellt."
        },
        "patch_documents_tagging_restricted_for_users": {
          "has_disabled_documents_tagging_restricted_for_users": "{participant} hat Projekt-Beteiligten das Recht Dokumenten-Tags zu erstellen erteilt.",
          "has_enabled_documents_tagging_restricted_for_users": "{participant} hat Projekt-Beteiligten das Recht Dokumenten-Tags zu erstellen entzogen."
        },
        "patch_photo_album": {
          "has_changed_album": "{participant} hat das Album des Fotos {photoLink} von {oldAlbum} auf {newAlbum} geändert."
        },
        "patch_photo_author": {
          "has_changed_author": "{participant} hat den Verfasser des Fotos {photoLink} von {authorParticipantOld} auf {authorParticipantNew} geändert."
        },
        "patch_photo_description": {
          "has_changed_description": "{participant} hat die Beschreibung des Fotos {photoLink} geändert.",
          "has_added_description": "{participant} hat eine Beschreibung zum Foto {photoLink} hinzugefügt.",
          "has_removed_description": "{participant} hat die Beschreibung des Fotos {photoLink} entfernt."
        },
        "patch_photo_file": {
          "has_updated_file": "{participant} hat das Foto {photoLink} markiert."
        },
        "patch_photo_location": {
          "has_changed_location": "{participant} hat folgende Verortungs-Eigenschaften am Foto {photoLink} geändert:",
          "has_introduced_location": "{participant} hat zum Foto {photoLink} eine Verortung hinzugefügt.",
          "has_removed_location": "{participant} hat die Verortung des Fotos {photoLink} entfernt."
        },
        "patch_photo_location_pin_position": {
          "has_changed_position": "{participant} hat die Position des Pins {pinId} im Foto {photoLink} geändert."
        },
        "patch_photo_title": {
          "has_changed_title": "{participant} hat den Titel des Fotos {photoLink} von „{oldTitle}“ auf „{newTitle}“ geändert.",
          "has_introduced_title": "{participant} hat dem Foto {photoLink} den Titel „{newTitle}“ gegeben.",
          "has_removed_title": "{participant} hat den Titel des Fotos {photoLink} entfernt."
        },
        "patch_photo_trashed": {
          "has_deleted_photo": "{participant} hat das Foto {photoLink} GELÖSCHT.",
          "has_restored_photo": "{participant} hat das Foto {photoLink} WIEDERHERGESTELLT."
        },
        "patch_plan_author": {
          "has_changed_author": "{participant} hat den Planverfasser des Plans {planLink} von {authorParticipantOld} auf {authorParticipantNew} geändert."
        },
        "patch_plan_revision_approval": {
          "approval_cancelled": "Diese Planprüfung wurde zurückgezogen.",
          "approval_done": "Diese Planprüfung ist abgeschlossen.",
          "approval_not_done": "Diese Planprüfung ist noch nicht abgeschlossen!",
          "has_changed_approval": "{participant} hat für die Revision {planLinkRevision} in Plan {planLink} die Prüfung geändert.",
          "revision_approved": "Dieser Plan-Index ist freigegeben!",
          "revision_not_approved": "Dieser Plan-Index ist NICHT freigegeben!"
        },
        "patch_plan_revision_approval_date": {
          "has_changed_approval_date": "{participant} hat für die Revision {planLinkRevision} in Plan {planLink} die Prüffrist von {oldApprovalDate} auf {newApprovalDate} geändert.",
          "has_changed_approval_date_short": "{participant} hat die Prüffrist von {oldApprovalDate} auf {newApprovalDate} geändert.",
          "has_introduced_approval_date": "{participant} hat für die Revision {planLinkRevision} in Plan {planLink} die Prüffrist {newApprovalDate} nachträglich gesetzt.",
          "has_introduced_approval_date_short": "{participant} hat die Prüffrist {newApprovalDate} nachträglich gesetzt.",
          "has_removed_approval_date": "{participant} hat für die Revision {planLinkRevision} in Plan {planLink} die Prüffrist entfernt.",
          "has_removed_approval_date_short": "{participant} hat die Prüffrist entfernt."
        },
        "patch_plan_top_categories_enabled": {
          "has_disabled_top_categories": "{participant} hat Plan Obergruppen deaktiviert.",
          "has_enabled_top_categories": "{participant} hat Plan Obergruppen aktiviert."
        },
        "patch_plan_top_category": {
          "has_changed_category": "{participant} hat die Obergruppe bei {planLink} von {oldCategory} auf {newCategory} geändert."
        },
        "patch_plan_trash": {
          "has_deleted_plan": "{participant} hat den Plan {planLink} gelöscht.",
          "has_restored_plan": "{participant} hat den Plan {planLink} wiederhergestellt."
        },
        "patch_plans_tagging_restricted_for_users": {
          "has_disabled_plans_tagging_restricted_for_users": "{participant} hat Projekt-Beteiligten das Recht Plan-Tags zu erstellen erteilt.",
          "has_enabled_plans_tagging_restricted_for_users": "{participant} hat Projekt-Beteiligten das Recht Plan-Tags zu erstellen entzogen."
        },
        "patch_project_two_factor_auth_required": {
          "enabled": "{participant} hat die 2-Faktor-Authentifizierung für dieses Projekt aktiviert.",
          "disabled": "{participant} hat die 2-Faktor-Authentifizierung für dieses Projekt deaktiviert."
        },
        "patch_project_location_is_enabled": {
          "disabled_location_property": "{participant} hat die Verortung „{locationLabel}“ deaktiviert.",
          "enabled_location_property": "{participant} hat die Verortung „{locationLabel}“ aktiviert."
        },
        "patch_project_location_label": {
          "did_rename": "{participant} hat im Projekt den Namen der Verortung „{oldLocationLabel}“ auf „{newLocationLabel}“ geändert."
        },
        "patch_task_assignee_user_id": {
          "has_changed_assignee": "{participant} hat den Task {taskLink} an {newAssigneeParticipant} übertragen.",
          "has_changed_assignee_to_unknown": "{participant} hat den Task {taskLink} an jemand anderen übertragen."
        },
        "patch_task_comment_files": {
          "has_deleted_files": "{participant} hat in einem Kommentar im Task {taskLink} alle Dateien entfernt.",
          "has_updated_files": "{participant} hat in einem Kommentar im Task {taskLink} die Dateien geändert."
        },
        "patch_task_comment_message": {
          "has_changed_comment": "{participant} hat einen Kommentar im Task {taskLink} geändert."
        },
        "patch_task_description": {
          "has_changed_description": "{participant} hat die Beschreibung des Tasks {taskLink} geändert.",
          "has_added_description": "{participant} hat dem Task {taskLink} eine Beschreibung hinzugefügt.",
          "has_removed_description": "{participant} hat die Beschreibung des Tasks {taskLink} entfernt."
        },
        "patch_task_due_date": {
          "has_changed_date": "{participant} hat die Frist des Tasks {taskLink} von {oldDueDate} auf {newDueDate} geändert.",
          "has_introduced_date": "{participant} hat die Frist des Tasks {taskLink} auf {newDueDate} gesetzt.",
          "has_removed_date": "{participant} hat die Frist des Tasks {taskLink} entfernt."
        },
        "patch_task_files": {
          "has_deleted_files": "{participant} hat im Task {taskLink} alle Dateien entfernt.",
          "has_deleted_files_task_detail_page": "Alle Dateien entfernt von {participant}.",
          "has_updated_files": "{participant} hat im Task {taskLink} die Dateien geändert."
        },
        "patch_task_location": {
          "has_changed_location": "{participant} hat folgende Verortungs-Eigenschaften am Task {taskLink} geändert:",
          "has_introduced_location": "{participant} hat zum Tasks {taskLink} eine Verortung hinzugefügt.",
          "has_removed_location": "{participant} hat die Verortung des Tasks {taskLink} entfernt."
        },
        "patch_task_location_pin_position": {
          "has_changed_position": "{participant} hat die Position des Pins {pinId} im Task {taskLink} geändert."
        },
        "patch_task_title": {
          "has_changed_title": "{participant} hat den Titel des Tasks {taskLink} von „{oldTitle}“ auf „{newTitle}“ geändert.",
          "has_introduced_title": "{participant} hat dem Task {taskLink} den Titel „{newTitle}“ gegeben.",
          "has_removed_title": "{participant} hat den Titel des Tasks {taskLink} entfernt."
        },
        "patch_task_trashed": {
          "has_deleted_task": "{participant} hat den Task {taskLink} GELÖSCHT.",
          "has_restored_task": "{participant} hat den Task {taskLink} WIEDERHERGESTELLT."
        },
        "patch_task_type": {
          "has_changed_type": "{participant} hat die Kategorie des Tasks {taskLink} von {oldType} auf {newType} geändert."
        },
        "post_approval": {
          "has_requested_approval": "{participant} hat für die Revision {planLinkRevision} in Plan {planLink} eine Prüfung angefordert."
        },
        "post_approval_comment": {
          "has_added_correction": "{participant} hat an die Prüfung in Revision {planLinkRevision} in Plan {planLink} einen Kommentar angehängt."
        },
        "post_document": {
          "has_created_document": "{participant} hat das Dokument {documentLink} angelegt.",
          "has_created_document_via_import": "{participant} hat das Dokument {documentLink} via Import angelegt."
        },
        "post_document_approval": {
          "has_requested_approval": "{participant} hat für die Version {documentLinkRevision} in Dokument {documentLink} eine Prüfung angefordert."
        },
        "post_document_approval_comment": {
          "has_added_correction": "{participant} hat an die Prüfung in Version {documentLinkRevision} in Dokument {documentLink} einen Kommentar angehängt."
        },
        "post_document_revision": {
          "has_uploaded_index": "{participant} hat die neue Dokumenten-Version {documentLink} hochgeladen.",
          "has_uploaded_index_via_import": "{participant} hat die neue Dokumenten-Version {documentLink} via Import hochgeladen."
        },
        "post_document_tag": {
          "has_changed_tags": "{participant} hat die Tags des Dokuments {documentLink} geändert: {diff}"
        },
        "post_photo": {
          "has_created_photo": "{participant} hat das Foto {photoLink} angelegt."
        },
        "post_photo_tag": {
          "has_changed_tags": "{participant} hat die Tags des Fotos {photoLink} geändert: {diff}"
        },
        "post_plan": {
          "has_created_plan": "{participant} hat den Plan {planLink} angelegt.",
          "has_created_plan_via_import": "{participant} hat den Plan {planLink} via Import angelegt."
        },
        "post_plan_revision": {
          "has_uploaded_index": "{participant} hat den neuen Plan-Index {planLink} hochgeladen.",
          "has_uploaded_index_via_import": "{participant} hat den neuen Plan-Index {planLink} via Import hochgeladen."
        },
        "post_plan_tag": {
          "has_changed_tags": "{participant} hat die Tags des Plans {planLink} geändert: {diff}"
        },
        "post_project": {
          "has_created_project": "{participant} hat dieses Projekt erstellt."
        },
        "post_project_invitation": {
          "added": "{changerParticipant} hat {addedParticipant} zum Projekt hinzugefügt.",
          "added_participant": "{changerParticipant} hat {addedParticipant} als Beteiligten mit Projektzugang hinzugefügt.",
          "added_participant_admin": "{changerParticipant} hat {addedParticipant} als Admin hinzugefügt.",
          "added_participant_silent": "{changerParticipant} hat {addedParticipant} als externen Beteiligten ohne Projektzugang hinzugefügt."
        },
        "post_task_comment": {
          "has_added_comment": "{participant} hat zum Task {taskLink} einen Kommentar hinzugefügt.",
          "has_added_comment_and_changed_state": "{participant} hat zum Task {taskLink} einen Kommentar hinzugefügt und den Status von „{stateOld}“ auf „{stateNew}“ geändert."
        },
        "post_task_published": {
          "has_published_task": "{participant} hat den Task {taskLink} VERÖFFENTLICHT. Hinweis: Automatische E-Mail-Benachrichtigung an den Zuständigen zur vollen Stunde."
        },
        "post_task_tag": {
          "has_changed_tags": "{participant} hat die Tags des Tasks {taskLink} geändert: {diff}"
        },
        "put_approve_document_revision": {
          "approval_not_done": "Diese Prüfung ist noch nicht abgeschlossen!",
          "has_approved": "{participant} hat das Dokument {documentLink} freigegeben.",
          "has_rejected": "{participant} hat das Dokument {documentLink} kommentiert.",
          "revision_approved": "Diese Dokumentenversion ist freigegeben!",
          "revision_not_approved": "Diese Dokumentenversion ist NICHT freigegeben!"
        },
        "put_approve_plan_revision": {
          "approval_not_done": "Diese Prüfung ist noch nicht abgeschlossen!",
          "has_approved": "{participant} hat den Plan {planLink} freigegeben.",
          "has_rejected": "{participant} hat den Plan {planLink} kommentiert.",
          "revision_approved": "Dieser Plan-Index ist freigegeben!",
          "revision_not_approved": "Dieser Plan-Index ist NICHT freigegeben!"
        },
        "put_document_name": {
          "has_changed_name": "{participant} hat das Dokument {oldDocumentName} auf {documentLink} umbenannt.",
          "has_changed_name_by_planfred_migration": "PLANFRED hat im Zuge einer Datenmigration das Dokument {oldDocumentName} auf {documentLink} umbenannt. Eine Dokumentennummer kann von nun an im Projekt nur einmal vergeben werden."
        },
        "put_document_phase": {
          "has_changed_phase": "{participant} hat den Dokumentenordner bei {documentLink} von {oldPhasetag} auf {newPhasetag} geändert."
        },
        "put_participant_address": {
          "has_changed_address": "{changerParticipant} hat die Adresse des Beteiligten {targetParticipant} auf {newAddress}  geändert.",
          "has_removed_address": "{changerParticipant} hat die Adresse des Beteiligten {targetParticipant} gelöscht."
        },
        "put_participant_company": {
          "has_changed_company": "{changerParticipant} hat die Firma des Beteiligten {targetParticipant} auf {newCompany} geändert."
        },
        "put_participant_name": {
          "has_changed_name": "{changerParticipant} hat den Namen des Beteiligten {targetParticipant} geändert."
        },
        "put_participant_phone": {
          "has_changed_phone": "{changerParticipant} hat die Telefonnummer des Beteiligten {targetParticipant} auf {newPhone} geändert.",
          "has_removed_phone": "{changerParticipant} hat die Telefonnummer des Beteiligten {targetParticipant} gelöscht."
        },
        "put_participant_role": {
          "has_changed_role": "{changerParticipant} hat die Rolle des Beteiligten {targetParticipant} auf {newRole} geändert.",
          "has_removed_role": "{changerParticipant} hat die Rolle des Beteiligten {targetParticipant} gelöscht."
        },
        "put_participant_update_alert_status": {
          "activated": "{changerParticipant} hat den Upload-Melder des Beteiligten {targetParticipant} in diesem Projekt aktiviert (Intervall: {interval}).",
          "changed_interval": "{changerParticipant} hat das Intervall des Upload-Melders des Beteiligten {targetParticipant} in diesem Projekt von {oldInterval} auf {newInterval} geändert.",
          "deactivated": "{changerParticipant} hat den Upload-Melder des Beteiligten {targetParticipant} in diesem Projekt deaktiviert.",
          "self_activated": "{changerParticipant} hat den eigenen Upload-Melder in diesem Projekt aktiviert (Intervall: {interval}).",
          "self_changed_interval": "{changerParticipant} hat das Intervall des eigenen Upload-Melders in diesem Projekt von {oldInterval} auf {newInterval} geändert.",
          "self_deactivated": "{changerParticipant} hat den eigenen Upload-Melder in diesem Projekt deaktiviert."
        },
        "put_plan_name": {
          "has_changed_name": "{participant} hat den Plan {oldPlanName} auf {planLink} umbenannt.",
          "has_changed_name_by_planfred_migration": "PLANFRED hat im Zuge einer Datenmigration den Plan {oldPlanName} auf {planLink} umbenannt. Eine Plannummer kann im Projekt nur einmal vergeben werden."
        },
        "put_plan_phase": {
          "has_changed_phase": "{participant} hat den Planordner bei {planLink} von {oldPhasetag} auf {newPhasetag} geändert."
        },
        "patch_company_take_ownership": {
          "has_taken_ownership": "{newOwner} hat als Unternehmensadministrator die Eigentümerschaft dieses Projekts von {previousOwner} übernommen."
        },
        "put_project_ownership_accept": {
          "has_accepted_transfer": "{newParticipant} hat die Übertragung des Projekts von {oldParticipant} angenommen und ist nun der neue Projekteigentümer."
        },
        "put_project_participant_can_approve_revisions": {
          "has_disabled": "{changerParticipant} hat {targetParticipant} das Recht zur Planprüfung entzogen.",
          "has_enabled": "{changerParticipant} hat {targetParticipant} das Recht zur Planprüfung erteilt."
        },
        "put_project_participant_enabled": {
          "has_disabled": "{changerParticipant} hat {targetParticipant} für dieses Projekt gesperrt.",
          "has_enabled": "{changerParticipant} hat {targetParticipant} für dieses Projekt entsperrt."
        },
        "put_project_participant_permission": {
          "has_changed_permission_to_admin": "{changerParticipant} hat den Beteiligten-Status von {targetParticipant} auf Projekt-Administrator geändert.",
          "has_changed_permission_to_participant": "{changerParticipant} hat den Beteiligten-Status von {targetParticipant} auf Projekt-Beteiligter geändert.",
          "has_changed_permission_to_silent": "{changerParticipant} hat den Beteiligten-Status von {targetParticipant} auf Beteiligter ohne Login geändert."
        },
        "put_project_title": {
          "has_changed_title": "{participant} hat den Projekttitel auf {projectTitle} geändert."
        },
        "send_mixed": {
          "documents": {
            "document": "das Dokument {documentLinks}",
            "documents": "{documentCountLink}",
            "print_documents": "die Dokumente {documentLinks}",
            "x_documents": "{documentCount} Dokumente"
          },
          "plans": {
            "plan": "den Plan {planLinks}",
            "plan_pdf": "nur die Druck-Datei des Plans {planLinks}",
            "plans": "{planCountLink}",
            "plans_pdf": "nur die Druck-Dateien von {planCountLinkDative}",
            "print_plans": "die Pläne {planLinks}",
            "print_plans_pdf": "nur die Druck-Dateien der Pläne {planLinks}",
            "x_plans": "{planCount} Pläne",
            "x_plans_dative": "{planCount} Plänen"
          },
          "sent_documents_to_person": "{senderParticipant} hat {documentsTranslation} an folgende Person versendet: {receiverParticipants}",
          "sent_documents_to_persons": "{senderParticipant} hat {documentsTranslation} an folgende Personen versendet: {receiverParticipants}",
          "sent_plans_and_documents_to_person": "{senderParticipant} hat {plansTranslation} und {documentsTranslation} an folgende Person versendet: {receiverParticipants}",
          "sent_plans_and_documents_to_persons": "{senderParticipant} hat {plansTranslation} und {documentsTranslation} an folgende Personen versendet: {receiverParticipants}",
          "sent_plans_to_person": "{senderParticipant} hat {plansTranslation} an folgende Person versendet: {receiverParticipants}",
          "sent_plans_to_persons": "{senderParticipant} hat {plansTranslation} an folgende Personen versendet: {receiverParticipants}"
        },
        "send_revision_doc": {
          "print_sent_documents_to_person": "{senderParticipant} hat die Dokumente {documentLinks} an folgende Person versendet: {receiverParticipants}",
          "print_sent_documents_to_persons": "{senderParticipant} hat die Dokumente {documentLinks} an folgende Personen versendet: {receiverParticipants}",
          "sent_document_to_person": "{senderParticipant} hat das Dokument {documentLinks} an folgende Person versendet: {receiverParticipants}",
          "sent_document_to_persons": "{senderParticipant} hat das Dokument {documentLinks} an folgende Personen versendet: {receiverParticipants}",
          "sent_documents_to_person": "{senderParticipant} hat {documentCountLink} an folgende Person versendet: {receiverParticipants}",
          "sent_documents_to_persons": "{senderParticipant} hat {documentCountLink} an folgende Personen versendet: {receiverParticipants}",
          "x_documents": "{documentCount} Dokumente"
        },
        "send_revision_plan": {
          "print_sent_plans_pdf_to_person": "{senderParticipant} hat nur die Druck-Dateien der Pläne {planLinks} an folgende Person versendet: {receiverParticipants}",
          "print_sent_plans_pdf_to_persons": "{senderParticipant} hat nur die Druck-Dateien der Pläne {planLinks} an folgende Personen versendet: {receiverParticipants}",
          "print_sent_plans_to_person": "{senderParticipant} hat die Pläne {planLinks} an folgende Person versendet: {receiverParticipants}",
          "print_sent_plans_to_persons": "{senderParticipant} hat die Pläne {planLinks} an folgende Personen versendet: {receiverParticipants}",
          "sent_plan_pdf_to_person": "{senderParticipant} hat nur die Druck-Datei des Plans {planLinks} an folgende Person versendet: {receiverParticipants}",
          "sent_plan_pdf_to_persons": "{senderParticipant} hat nur die Druck-Datei des Plans {planLinks} an folgende Personen versendet: {receiverParticipants}",
          "sent_plan_to_person": "{senderParticipant} hat den Plan {planLinks} an folgende Person versendet: {receiverParticipants}",
          "sent_plan_to_persons": "{senderParticipant} hat den Plan {planLinks} an folgende Personen versendet: {receiverParticipants}",
          "sent_plans_pdf_to_person": "{senderParticipant} hat nur die Druck-Dateien von {planCountLinkDative} an folgende Person versendet: {receiverParticipants}",
          "sent_plans_pdf_to_persons": "{senderParticipant} hat nur die Druck-Dateien von {planCountLinkDative} an folgende Personen versendet: {receiverParticipants}",
          "sent_plans_to_person": "{senderParticipant} hat {planCountLink} an folgende Person versendet: {receiverParticipants}",
          "sent_plans_to_persons": "{senderParticipant} hat {planCountLink} an folgende Personen versendet: {receiverParticipants}",
          "x_plans": "{planCount} Pläne",
          "x_plans_dative": "{planCount} Plänen"
        },
        "send_project_invitation": {
          "has_invited": "{changerParticipant} hat eine Projekteinladung per E-Mail an {addedParticipant} versendet.",
          "has_reinvited": "{changerParticipant} hat erneut eine Projekteinladung per E-Mail an {addedParticipant} versendet."
        },
        "send_task_reminder": {
          "has_sent_reminder": "{participant} hat eine Erinnerung an {assigneeParticipant} gesendet.",
          "has_sent_reminder_for_task": "{participant} hat eine Erinnerung für den Task {taskLink} an {assigneeParticipant} gesendet."
        }
      },
      "resend": {
        "document": {
          "multiple": "Diese Dokumente senden oder laden",
          "single": "Dieses Dokument senden oder laden"
        },
        "plan": {
          "multiple": "Diese Pläne senden oder laden",
          "single": "Diesen Plan senden oder laden"
        }
      },
      "search_hits_multiple": "{x} Aktivitäten",
      "search_hits_one": "1 Aktivität",
      "send_detail": {
        "activities_load_error": "Der Sende- und Downloadstatus konnte nicht geladen werden",
        "activities_update_error": "Der Sende- und Downloadstatus konnte nicht aktualisiert werden",
        "only_pdf": "Nur DRUCK-DATEIEN gesendet",
        "sent_document_revisions": "Versendete Dokumente:",
        "sent_plan_revisions": "Versendete Pläne:",
        "sent_to": "Versendet an:",
        "show_recipients_list": "Die Empfängerliste wird im E-Mail angezeigt",
        "table_participants": {
          "bounced_message": "Die E-Mail wurde vom Server des Empfängers abgewiesen.",
          "delivered": "Zugestellt",
          "downloaded": "Heruntergeladen",
          "processing": "In Zustellung",
          "send_failed": "Nicht zugestellt",
          "send_failed_message": "Der Versand der E-Mail ist fehlgeschlagen.",
          "status": "Status",
          "undeliverable": "Unzustellbar",
          "unknown": "Unbekannt",
          "unknown_message": "Für diese E-Mail liegt keine Zustellbestätigung vor. Ob sie zugestellt wurde, ist unbekannt."
        },
        "upload": "Upload"
      },
      "sent_message": "Gesendete Nachricht:",
      "sent_message_not_provided": "Keine Nachricht gesendet.",
      "show": "Anzeigen",
      "show_all_activities": "Alle Aktivitäten im gewählten Zeitraum anzeigen",
      "unknown_participant": "PLANFRED",
      "version": "Version"
    },
    "agb": {
      "accept_agb_before_getting_owner": "Bevor Sie Projekteigentümer werden, müssen Sie unsere AGBs und DSGVO bestätigen!",
      "confirm": "bestätigen",
      "confirm_server_error": "Beim Senden der Zustimmung ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "i_accept_terms": "Ich bin mit den allgemeinen Geschäftsbedingungen der PLANFRED GmbH einverstanden",
      "i_read_privacy_policy": "Ich habe die Hinweise zum Datenschutz und Widerrufsrecht zur Kenntnis genommen",
      "jump_to_privacy_policy": "zur Datenschutzerklärung",
      "jump_to_terms": "zu den AGBs",
      "modal": {
        "cancel": "Ich möchte PLANFRED nicht benutzen",
        "dear_user": "Lieber PLANFRED-Nutzer,",
        "dsgvo_image_alt": "Label „DSGVO-konform“",
        "dsgvo_image_path": src/assets/img/badge-eu-dsgvo_de.svg",
        "may_we_have_your_attention": "dürften wir zum Thema DSGVO kurz um Ihre Aufmerksamkeit bitten?",
        "new_dsgvo_since_2018": "Am 25. Mai 2018 ist die europäische Datenschutzgrundverordnung (DSGVO) in Kraft getreten.",
        "planfred_supports_dsgvo_since_ever": "Praktisch unterstützt PLANFRED seit den Anfangstagen deren inhaltliche Grundsätze, vertraglich müssen natürlich auch wir Anpassungen vornehmen.",
        "please_confirm": "Aufgrund der DSGVO haben wir folgende Dokumente datenschutzrechtlich aktualisiert und bitten hiermit diese zu bestätigen:",
        "submit": "Wie gewohnt fortfahren",
        "submit_server_error": "Beim Speichern ist ein Fehler aufgetreteten – versuchen Sie es erneut."
      },
      "please_accept_privacy_policy": "Bestätigen Sie die Hinweise zu unseren Datenschutzbestimmungen",
      "please_accept_terms": "Akzeptieren Sie unsere allgemeinen Geschäftsbedingungen"
    },
    "auth": {
      "app_promotion_text": "PLANFRED gibt's auch als App!",
      "back_to_login": "zurück zum Login",
      "check_spam_folder": "Sollten Sie innerhalb der nächsten zwei Minuten keine E-Mail erhalten haben, überprüfen Sie Ihren Spam-Ordner.",
      "check_your_mailbox": "Überprüfen Sie Ihren Posteingang!",
      "confirm": {
        "error_token_invalid": "Der Aktivierungs-Schlüssel für die E-Mail-Adresse „{email}“ ist ungültig.",
        "error_token_invalid_sent_mail": "Wir haben Ihnen einen neuen Aktivierungs-Link an „{email}“ gesendet.",
        "form": {
          "submit_label": "Passwort erstellen",
          "submit_label_subline": "und Benutzerkonto aktivieren"
        },
        "headline_activate_account": "Benutzerkonto aktivieren",
        "headline_link_expired": "Der Aktivierungs-Link ist ungültig.",
        "subline_new_email": "Neues E-Mail in Ihrem Posteingang!"
      },
      "email_address": "E-Mail-Adresse",
      "error_password_validation": "Ihr Passwort muss mind. 8 Zeichen lang sein!",
      "forgot_password": {
        "enter_email": "Geben Sie einfach Ihre E-Mail-Adresse an, damit wir Ihnen die Anleitung zur Änderung Ihres Passworts zusenden können.",
        "error": "Überprüfen Sie die E-Mail-Adresse und versuchen sie es noch einmal.",
        "form": {
          "email_error_required": "Füllen Sie dieses Feld aus.",
          "submit_label": "Neues Passwort anfordern"
        },
        "headline_forgot_password": "Passwort vergessen?",
        "mail_sent_to_create_pwd": "Wir haben Ihnen die Anleitung zur Änderung Ihres Passworts an „{email}“ gesendet."
      },
      "forgot_password_confirm": {
        "create_your_pwd_here": "Hier können Sie ein neues Passwort für Ihr Benutzerkonto erstellen.",
        "error_token_invalid_sent_mail": "Wir haben Ihnen einen neuen Passwort-Reset-Link an „{email}“ gesendet.",
        "form": {
          "submit_label": "Neues Passwort erstellen"
        },
        "headline_create_pwd": "Neues Passwort erstellen",
        "headline_link_expired": "Der Passwort-Link ist ungültig."
      },
      "login": {
        "demoproject_will_be_opened": "Demo-Server wird geöffnet …",
        "forgot_password": "Passwort vergessen?",
        "form": {
          "general_server_error": "Bei der Anmeldung ist ein Fehler aufgetreten – versuchen Sie es später erneut.",
          "password_label": "Passwort:",
          "submit_error_invalid_credentials_explanation": "Überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort und versuchen Sie es erneut.",
          "submit_error_login_failed": "Login fehlgeschlagen",
          "submit_error_rate_limited": "Zu viele Versuche",
          "submit_error_rate_limited_explanation": "Bitte warten Sie einige Minuten und versuchen Sie es erneut.",
          "submit_error_rate_limited_explanation_minutes": "Bitte warten Sie etwa {minutes} Min. und versuchen Sie es erneut.",
          "submit_label": "Login"
        },
        "headline_login": "Login",
        "need_help": "Sie benötigen Hilfe?",
        "no_account_yet": "Noch kein Benutzerkonto?",
        "no_login_yet": "Noch keine Zugangsdaten?",
        "no_two_factor_device": "Kein 2-Faktor-Gerät vorhanden?",
        "register_for_free": "Jetzt kostenlos registrieren",
        "session_expired_enter_credentials": "Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein um fortfahren zu können.",
        "session_expired_error": "Ihre Sitzung ist abgelaufen!",
        "totp_form": {
          "auth_code_label": "Authentifizierungs-Code:",
          "recovery_code_label": "Wiederherstellungs-Schlüssel:",
          "step1_authapp_recommendation": "Empfohlene Authentifizierungs-Apps: {authy}, {googleauthenticator}",
          "step1_connect_with_authapp": "1. Verbinden Sie Ihr Benutzerkonto mit einer Authentifizierungs-App",
          "step1a_scan_qr_code": "QR-Code mit Authentifizierungs-App einscannen",
          "step1b_copy_paste_code": "Code manuell in Authentifizierungs-App einfügen",
          "step2_enter_authcode": "2. Geben Sie den 6-stelligen Code Ihrer Authentifizierungs-App ein",
          "subline_enter_authcode": "Geben Sie den 6-stelligen Code Ihrer Authentifizierungs-App ein",
          "subline_enter_recoverycode": "Geben Sie den 25-stelligen Wiederherstellungs-Schlüssel ein",
          "submit_error_invalid_totp_explanation": "Geben Sie einen aktuellen Code ein.",
          "submit_error_rate_limited_explanation": "Zu viele Code-Eingaben. Bitte warten Sie einige Minuten und versuchen Sie es erneut.",
          "submit_error_rate_limited_explanation_minutes": "Zu viele Code-Eingaben. Bitte warten Sie etwa {minutes} Min. und versuchen Sie es erneut.",
          "validation_error_6_digits": "Der Code muss aus 6 Ziffern bestehen."
        },
        "use_recovery_code": "Wiederherstellungs-Schlüssel verwenden",
        "use_authenticator_code": "Authentifizierungs-Code verwenden"
      },
      "password": "Passwort",
      "password_input_description_with_email": "Vergeben Sie ein Passwort für {email}",
      "password_input_label": "Passwort (mind. 8 Zeichen)",
      "please_enter_a_password": "Geben Sie ein Passwort ein.",
      "please_enter_a_valid_email_address": "Geben Sie eine valide E-Mail-Adresse ein.",
      "registration": {
        "form": {
          "company_error_required": "Geben Sie eine Firma ein.",
          "company_label": "Firma:",
          "email_error_required": "Geben Sie eine E-Mail-Adresse ein.",
          "first_name_error_required": "Geben Sie Ihren Vornamen ein.",
          "first_name_label": "Vorname:",
          "last_name_error_required": "Geben Sie Ihren Nachnamen ein.",
          "last_name_label": "Nachname:",
          "submit_label": "Unverbindlich registrieren"
        },
        "headline_registration": "Registrierung",
        "no_payment_mandatory": "Keine automatische Zahlungspflicht nach der Testphase!",
        "subline_test_30_days": "Erleben Sie PLANFRED 30 Tage lang kostenlos und garantiert unverbindlich im Live-Betrieb"
      },
      "registration_sent": {
        "back_to_login": "zum Login",
        "check_spam_folder": "Sollten Sie innerhalb der nächsten zwei Minuten keine E-Mail erhalten haben, überprüfen Sie Ihren Spam-Ordner.",
        "headline_registration": "Schön, Sie dabei zu haben!",
        "headline_token_expired": "Aktivierungs-Link abgelaufen!",
        "mail_sent_new_activation_link": "Der verwendete Aktivierungs-Link ist bereits abgelaufen. Wir haben Ihnen eine neue E-Mail an „{email}“ gesendet.",
        "mail_sent_to_create_pwd": "Wir haben Ihnen eine E-Mail an „{email}“ gesendet, um das Passwort für Ihr Benutzerkonto zu erstellen.",
        "subline_new_email": "Neues E-Mail in Ihrem Posteingang!"
      },
      "request_new_password": "Neues Passwort anfordern",
      "server_error": "Es ist ein Fehler aufgetreten. Versuchen Sie es mit einem anderen Browser oder kontaktieren Sie unseren Support",
      "two_step_auth_activation": {
        "totp_invalid": "Der Authentifizierungscode ist ungültig. Geben Sie einen aktuellen Code ein.",
        "validating": "Code wird validiert …"
      }
    },
    "backup_app": {
      "createdDate": "Dieses Projekt-Backup wurde am {DATE} um {TIME} erstellt."
    },
    "banner_browser_update": {
      "alternative_browser": "Als Alternative empfehlen wir:",
      "description": "Um alle Funktionen nutzen zu können aktualisieren Sie Ihren Browser.",
      "download_here": "Hier geht's zum Download:",
      "headline": "Aktualisieren Sie Ihren Browser!"
    },
    "components": {
      "banner_browser_outdated": {
        "browser_is_outdated": "Ihr Internet Explorer ist veraltet und unsicher!",
        "contact_our_support": "Kontaktieren Sie unseren Support",
        "ie_successor": "Nachfolger des Internet Explorers:",
        "in_five_minuted_up_to_date": "In nur 5 Minuten sind Sie wieder am aktuellen Stand.",
        "install_new_browser": "Installieren Sie einen aktuellen Browser um PLANFRED auch in Zukunft problemlos einsetzen zu können.",
        "microsoft_edge": "Microsoft Edge",
        "mozilla_firefox": "Mozilla Firefox",
        "or_use_alternative": "Als Alternative empfehlen wir:",
        "still_problems": "Sie haben bereits upgedated und immer noch Probleme?"
      },
      "banner_demoserver": {
        "create_first_project": "Erstes eigenes Projekt anlegen",
        "daily_reset": "Alle Änderungen werden täglich zurückgesetzt. Sie können sich stattdessen registrieren und gleich im eigenen Projekt arbeiten.",
        "learn_more_about_planfred": "Mehr über PLANFRED",
        "you_are_on_demoserver": "Sie befinden sich in der öffentlichen Demo-App!"
      },
      "base_date_picker": {
        "chosen_date_in_project_timezone": "Gewähltes Datum in Projektzeit: {date}",
        "current_project_time": "Aktuelle Projektzeit: {date}",
        "please_select_start_and_end_date": "Selektieren Sie Start- und Enddatum.",
        "project_timezone_different_than_local_timezone": "Achtung! Ihre lokale Zeit weicht von der Projektzeit ab. Die Anzeige erfolgt in der lokalen Zeit."
      },
      "modal_changelog": {
        "load_error": "Der Änderungsverlauf konnte nicht geladen werden.",
        "retry": "Erneut versuchen"
      },
      "modal_demoserver": {
        "continue_projects_after_trial": "Ihre angelegten Projekte können nach Ablauf der Testphase nahtlos weitergeführt werden.",
        "create_first_project": "Eigenes Projekt anlegen",
        "data_doesnt_get_deleted": "Es werden keine Daten automatisch gelöscht!",
        "free_for_30_days": "30 Tage kostenlos im vollen Funktionsumfang einsetzen",
        "learn_more_about_planfred": "Mehr über PLANFRED",
        "many_satisfied_customers": "Über {counter} zufriedene Anwender profitieren bereits von PLANFRED",
        "no_binding_guaranteed": "Garantiert unverbindlich – KEINE Verpflichtung nach der Testphase",
        "no_installation_required": "Keine Installation, keine Einschulung – sofort einsatzbereit!",
        "start_own_project": "Starten Sie gleich im eigenen Projekt!"
      },
      "modal_two_factor_auth_disabled": {
        "continue_without": "Ohne 2-Faktor-Authentifizierung fortfahren",
        "is_not_active": "Die 2-Faktor-Authentifizierung ist NICHT aktiv.",
        "reactivate": "2-Faktor-Authentifizierung re-aktivieren",
        "server_error": "Die Auswahl konnte nicht gespeichert werden – versuchen Sie es erneut."
      },
      "modal_two_factor_recovery_code": {
        "already_noted_down_recovery_code": "Schlüssel bereits notiert",
        "click_to_copy_code": "Kopieren Sie den Wiederherstellungs-Schlüssel durch Klicken",
        "copied_to_clipboard": "Wiederherstellungs-Schlüssel {recoveryCode} in die Zwischenablage kopiert",
        "copy_before_continue": "Bevor Sie abschließen können, müssen Sie den Wiederherstellungs-Schlüssel kopieren.",
        "copy_or_print_before_continue": "Bevor Sie abschließen können, müssen Sie den Wiederherstellungs-Schlüssel kopieren oder drucken.",
        "copy_recovery_code": "Kopieren",
        "finish": "Abschließen",
        "follow_instructions_if_password_lost": "Falls Sie Ihr Passwort vergessen haben, folgen Sie den Anweisungen unter {forgotPasswordLink}",
        "print_recovery_code": "Drucken",
        "store_recovery_key": "ACHTUNG: Wiederherstellungs-Schlüssel sicher aufbewahren!",
        "two_factor_auth_active": "Die 2-Faktor-Authentifizierung ist nun aktiv.",
        "use_recovery_key_is_phone_lost": "Falls Sie den Zugang zur Ihrem 2-Faktor-Authentifizierungsgerät (zB. Smartphone) verlieren,<br>können Sie sich NUR mithilfe des folgenden Wiederherstellungs-Schlüssels wieder bei PLANFRED anmelden."
      },
      "signature_edit": {
        "create_signature_template": "Signaturvorlage erstellen",
        "edit_header_label": "Signaturvorlage editieren:",
        "edit_signature_template": "Signaturvorlage editieren",
        "save_and_apply": "speichern",
        "server_error": "Beim Speichern der Signatur ist ein Fehler aufgetreten – versuchen Sie es erneut"
      },
      "text_blocks": {
        "category": {
          "document-approval": {
            "new_textblock_title": "Textbaustein für Dokumenten-Prüfung",
            "textblocks_list_title": "Textbausteine für Dokumenten-Prüfung"
          },
          "document-approval-request": {
            "new_textblock_title": "Textbaustein für Dokumenten-Prüfanforderung",
            "textblocks_list_title": "Textbausteine für Dokumenten-Prüfanforderung"
          },
          "document-revision": {
            "new_textblock_title": "Textbaustein für Dokumenten-Upload",
            "textblocks_list_title": "Textbausteine für Dokumenten-Upload"
          },
          "document-send": {
            "new_textblock_title": "Textbaustein für Dokumenten-Versand",
            "textblocks_list_title": "Textbausteine für Dokumenten-Versand"
          },
          "invite-participant": {
            "new_textblock_title": "Textbaustein für Beteiligten-Einladung",
            "textblocks_list_title": "Textbausteine für Beteiligten-Einladung"
          },
          "mixed-send": {
            "new_textblock_title": "Textbaustein für Versand",
            "textblocks_list_title": "Textbausteine für Versand"
          },
          "photo-description": {
            "new_textblock_title": "Textbaustein für Foto-Beschreibung",
            "textblocks_list_title": "Textbausteine für Foto-Beschreibung"
          },
          "plan-approval": {
            "new_textblock_title": "Textbaustein für Plan-Prüfung",
            "textblocks_list_title": "Textbausteine für Plan-Prüfung"
          },
          "plan-approval-request": {
            "new_textblock_title": "Textbaustein für Plan-Prüfanforderung",
            "textblocks_list_title": "Textbausteine für Plan-Prüfanforderung"
          },
          "plan-revision": {
            "new_textblock_title": "Textbaustein für Plan-Upload",
            "textblocks_list_title": "Textbausteine für Plan-Upload"
          },
          "plan-send": {
            "new_textblock_title": "Textbaustein für Plan-Versand",
            "textblocks_list_title": "Textbausteine für Plan-Versand"
          },
          "task-description": {
            "new_textblock_title": "Textbaustein für Task-Beschreibung",
            "textblocks_list_title": "Textbausteine für Task-Beschreibung"
          },
          "task-new-comment": {
            "new_textblock_title": "Textbaustein für Task-Kommentar",
            "textblocks_list_title": "Textbausteine für Task-Kommentar"
          },
          "task-send": {
            "new_textblock_title": "Textbaustein für Task-Erinnerung",
            "textblocks_list_title": "Textbausteine für Task-Erinnerung"
          }
        },
        "create_text_block": "Neuer Textbaustein",
        "edit_block_abort_btn": "abbrechen",
        "edit_block_delete_btn": "Textbaustein löschen",
        "edit_block_save_btn": "speichern",
        "edit_block_section_title": "Textbaustein ändern",
        "edit_block_title_placeholder": "Name des Textbausteins",
        "error_deleting_textblocks": "Beim Löschen ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "error_loading_textblocks": "Beim Laden der Textbausteine ist ein Fehler aufgetreten.",
        "error_saving_textblocks": "Es ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "form_validation_error_textblocks": "Bitte füllen Sie beide Felder aus.",
        "save_text_block": "neu",
        "textblocks": "Textbausteine",
        "textblocks_empty_list_message": "Keine Textbausteine verfügbar",
        "textblocks_success_message": "Textbaustein wurde erstellt."
      }
    },
    "download": {
      "continue_in_project": "weiter zum Projekt",
      "download_file_type": "{fileType} herunterladen",
      "download_files": "Dateien herunterladen ({fileSize})",
      "download_link_deactivated": "Zugriff per E-Mail ist deaktiviert.",
      "download_not_possible": "Dieser Download ist leider nicht möglich!",
      "download_settings_title": "Download",
      "external_per_email": "Beteiligte ohne Login",
      "file_list": "Datei-Liste",
      "files_not_accessible": "Der Download ist nicht möglich da Sie keinen Zugriff mehr auf die enthaltenen Dateien haben.",
      "folder_original": "Ordner/Original",
      "folder_standard": "Ordner/Standard",
      "folder_with_file_names_prefixed": "Ordnerstruktur mit Dateinamen + vorangestellter Plan-/Dokumentennummer",
      "folder_with_original_file_names": "Ordnerstruktur mit Original-Dateinamen",
      "gdpr_legal_logging_hint": "Downloads werden protokolliert!",
      "getting_uploaded": "({fileSize}) wird hochgeladen …",
      "message_download_link_expired": "Zugriff per E-Mail ist abgelaufen.",
      "only_download_print_file": "Nur DRUCK-DATEI herunterladen",
      "only_download_print_files": "Nur DRUCK-DATEIEN herunterladen",
      "open_file": "{x} öffnen",
      "original_file_names_without_folder": "Original-Dateinamen ohne Ordner",
      "per_email": "Per Versand",
      "percentage_done": "{percentage} %",
      "preview_file_list": "Vorschau „Datei-Liste“",
      "preview_folder_original": "Vorschau „Ordner/Original“",
      "preview_folder_standard": "Vorschau „Ordner/Standard“",
      "select_folder_structure": "Ordnerstruktur auswählen",
      "server_error_download_expired": "Der Download-Link ist bereits älter als 120 Tage.",
      "server_error_download_expired_auth": "Der Download-Link ist abgelaufen.",
      "server_error_not_found": "Der verwendete Download-Link ist ungültig.",
      "server_error_participant_disabled": "Ihnen wurde der Projektzugriff entzogen.",
      "server_error_project_deleted": "Das Projekt wurde vom Projekteigentümer gelöscht.",
      "server_error_unknown": "Es ist ein unbekannter Fehler aufgetreten. Laden Sie die Seite neu."
    },
    "emails": {
      "customer_slogan": "PLANFRED – Pläne immer aktuell!",
      "footer_logo_alt": "PLANFRED Logo – Pläne immer aktuell!",
      "footer_slogan": "Projektraum Bau",
      "privacy_hint": "Hinweise zum Datenschutz und Widerrufsrecht."
    },
    "export": {
      "documents_list": "Dokumentenliste",
      "metadata": {
        "active_filters": "Filter:",
        "address": "Adresse:",
        "date": "Datum:",
        "owner": "Projekteigentümer:",
        "project": "Projekt:"
      },
      "participants_list": "Beteiligtenliste",
      "plans_list": "Planliste",
      "tasks_list": "Taskliste"
    },
    "file_auto_assign": {
      "adapt_plans_or_files_in_clipboard": "Gegebenenfalls bestehende Pläne anpassen oder Dateien in der Zwischenablage ergänzen, bzw. löschen.",
      "add_comment": "Anmerkung hinzufügen",
      "auto_update_plans": "Automatische Planaktualisierung …",
      "auto_update_plans_headline": "Pläne automatisch aktualisieren",
      "cad_file_missing": "CAD Datei fehlt",
      "check_assignment_and_confirm": "Zuordnung kontrollieren und Auswahl bestätigen",
      "check_suggestions_and_confirm": "Vorschläge kontrollieren und Auswahl bestätigen",
      "choose_plans_enter_index_confirm_update": "Pläne auswählen - Index pro Plan eingeben - Aktualisierung bestätigen",
      "detected_plan_name_in_file_name": "Plannummer kommt im Dateinamen vor",
      "detected_similarity_to_file_name": "Ähnlichkeit zum Dateinamen einer Revision festgestellt",
      "detected_similarity_to_plan_name": "Ähnlichkeit zur Plannummer festgestellt",
      "enter_index": "Index eintragen",
      "error_cannot_mix_print_and_dwg_files": "Sofern in der Zwischenablage sowohl DRUCK- als auch CAD- Dateien vorhanden sind, ist eine einzelne Zuweisung von CAD Dateien nicht möglich.",
      "error_could_not_create_revision": "Die Revision konnte nicht angelegt werden. Versuchen Sie es erneut oder kontaktieren Sie unseren Support.",
      "error_could_not_load_suggestions": "Vorschläge konnten nicht geladen werden. Kontaktieren Sie unseren Support.",
      "error_file_is_not_print_or_dwg": "Datei ist keine DRUCK/CAD Datei und kann keinem Plan zugewiesen werden.",
      "error_multiple_dwg_files": "Im Index-Paket befinden sich mehrere, gleichnamige CAD-Dateien. Löschen Sie eines der Duplikate in der Zwischenablage.",
      "error_multiple_index_packages_for_plan": "Keine Verarbeitung möglich, da es zum Plan mehrere passende Index-Pakete gibt.",
      "error_multiple_plans_for_index_package": "Keine Verarbeitung möglich, da das Index-Paket mehreren Plänen zugeordnet werden kann.",
      "error_multiple_print_files": "Im Index-Paket befinden sich mehrere, gleichnamige Druck-Dateien. Löschen Sie eines der Duplikate in der Zwischenablage.",
      "error_no_plan_found_for_files": "Zu diesem Index Paket wurde kein passender Plan gefunden.",
      "feature_hint": "Anleitung „Pläne automatisch aktualisieren“",
      "file_assignment_completed": "Dateizuordnung aus Zwischenablage abgeschlossen",
      "jump_to_inputs": "Zum Eingabefeld",
      "manual_link": "https://www.planfred.com/de/anleitungen/#Mehrere%20Pl%C3%A4ne%20automatisch%20aktualisieren",
      "manual_link_text": "Zur Anleitung „S10 Mehrere Pläne automatisch aktualisieren“",
      "not_assignable": "Nicht zuordenbar",
      "one_plan_without_index": "1 ausgewählter Plan ohne Index!",
      "plan_label_name": "Plannummer / Codierung:",
      "print_file_missing": "DRUCK Datei fehlt",
      "report_problem_for_auto_file_assignment": "Problem bei der automatischen Dateizuordnung melden",
      "select_plan_to_update": "Zum Aktualisieren, muss ein Plan ausgewählt werden.",
      "suggestions": "Vorschläge",
      "suggestions_for_x_of_y_files": "Für {x} von {y} Dateien gibt es Vorschläge.",
      "unique_assignment": "Eindeutige Zuordnung",
      "update_more_plans": "Weitere Pläne aktualisieren",
      "warning_upload_currently_running": "Upload läuft gerade.",
      "which_problem_did_occur": "Welche Probleme sind bei der Zuordnung aufgetreten?",
      "which_problem_did_occur_debug_data_hint": "Daten zur Problembehebung werden an Planfred mit übermittelt.",
      "x_of_y_files_can_be_assigned": "{x} von {y} Dateien können eindeutig zugeordnet werden.",
      "x_of_y_files_without_assignment": "{x} von {y} Dateien können keinem Plan zugeordnet werden.",
      "x_plans_without_index": "{x} ausgewählte Pläne ohne Index!"
    },
    "filter": {
      "delete_search_field": "Suchfeld löschen",
      "messagebox": {
        "multiple_match": "Mit den aktuellen Filtereinstellungen werden nur {filteredItemsLength} von {allItemsLength} {itemTypeDative} aufgelistet.",
        "no_match": "Mit den aktuellen Filtereinstellungen konnten keine {itemType} gefunden werden.",
        "one_match": "Mit den aktuellen Filtereinstellungen wird nur 1 von {allItemsLength} {itemTypeDative} aufgelistet.",
        "reset_filter_settings": "Alle Filtereinstellungen zurücksetzen"
      },
      "no_participants_available_for_documents": "Verfasser werden angezeigt, sobald ein Dokument mit einem Beteiligten als Verfasser hochgeladen wurde.",
      "no_participants_available_for_documents_permission": "Beteiligte werden angezeigt, sobald ein Beteiligter einem Dokument mit Zugriffsberechtigung zugeordnet wurde.",
      "no_participants_available_for_plans": "Verfasser werden angezeigt, sobald ein Plan mit einem Beteiligten als Verfasser hochgeladen wurde.",
      "ownership": {
        "all_projects": "Alle Projekte",
        "all_projects_short": "Alle",
        "owner": "Eigene Projekte",
        "owner_short": "Eigentümer",
        "participant": "Projektbeteiligungen",
        "participant_short": "Beteiligt"
      },
      "roles": {
        "nothing_uploaded_from_role": "Rollen werden nach dem ersten Upload hier angezeigt"
      },
      "roles_and_participants_available_after_approval": "Derzeit gibt es keine offenen Prüfungen.",
      "search": "Suche:",
      "search_hits_x_of_y": "{filteredItemsLength} von {allItemsLength}",
      "show_all": "Alle anzeigen",
      "tags": {
        "no_tags_assigned": "Nur zugewiesene Tags werden hier angezeigt"
      },
      "text_search_placeholder": "Suche: Suchbegriff-A + \"Suchbegriff B\""
    },
    "item": {
      "approval_done": "Prüfung abgeschlossen",
      "approval_status": {
        "approved": "Freigegeben",
        "notrequested": "Keine Anforderung",
        "obsolete": "Prüfung nicht mehr erforderlich",
        "pending": "Prüfung angefordert",
        "pending_short": "Angefordert",
        "rejected": "Kommentiert"
      },
      "author": {
        "document_label_assign_to_other_author": "Dokumentenverfasser ändern:",
        "document_label_author": "Verfasser:",
        "edit_server_error": "Es gab einen Fehler beim Speichern des Verfassers. Verfasser konnte nicht geändert werden.",
        "label_role": "Rolle:",
        "plan_label_assign_to_other_author": "Planverfasser ändern:",
        "plan_label_author": "Planverfasser:"
      },
      "detail": {
        "document_edit": "Dokument bearbeiten",
        "edit_name": "Nummer/Inhalt ändern",
        "edit_permission": "Berechtigungen ändern",
        "edit_phasetag": "Planordner ändern",
        "edit_phasetag_document": "Dokumentenordner ändern",
        "edit_tags": "Tags ändern",
        "edit_top_categories": "Obergruppe ändern",
        "number_content": "Nummer/Inhalt",
        "plan_edit": "Plan bearbeiten"
      },
      "document_mailer": {
        "add_documents": "Dokumente hinzufügen",
        "add_participant": "Empfänger hinzufügen",
        "add_plans": "Pläne hinzufügen",
        "change_documents_selection": "Dokumentenauswahl ändern",
        "change_plans_selection": "Planauswahl ändern",
        "choose_participants": "Beteiligte für neue Versandgruppe auswählen",
        "delete_group": "Gruppe löschen",
        "delivery_failed_for_participant": "Der Versand an folgenden Beteiligten ist fehlgeschlagen:",
        "delivery_failed_for_participants": "Der Versand an folgende Beteiligte ist fehlgeschlagen:",
        "document_default_subject": "1 neues Dokument für Sie",
        "document_successfully_sent_to": "Dokument erfolgreich versendet an:",
        "documents_default_subject": "{number} neue Dokumente für Sie",
        "documents_subject_prefix": "{projectTitle} - Dokumentenversand:",
        "documents_successfully_sent_to": "Dokumente erfolgreich versendet an:",
        "edit_group": "Versandgruppe ändern",
        "edit_recipient": "Empfänger bearbeiten",
        "edit_recipients_list": "Empfängerliste bearbeiten",
        "email_already_exists": "Diese E-Mail-Adresse wird im Projekt bereits verwendet.",
        "email_already_exists_disabled": "Diese E-Mail-Adresse wird im Projekt bereits verwendet, ist jedoch deaktiviert.",
        "headline_recipients_and_settings": " - Empfänger und Einstellungen",
        "new_group": "Versandgruppe erstellen",
        "no_name": "Versandgruppe benennen",
        "no_participants_selected": "Beteiligte auswählen",
        "one_documents": "1 Dokument",
        "one_plans": "1 Plan",
        "participants_locked": "Dieser Beteiligte wurde deaktiviert:",
        "pdf-only-option-active-item-without-cad-file-warning": "Sie haben Pläne ausgewählt welche keine DRUCK Datei enthalten. Die Option 'Zugriff auf DRUCK-DATEIEN beschränken' erfordert dass alle Pläne die Sie senden möchten eine DRUCK Datei enthalten.",
        "plan_default_subject": "1 neuer Plan für Sie",
        "plan_includes_only_print_file": "Der Plan beinhaltet aktuell nur eine DRUCK-DATEI. Die Option 'Nur DRUCK-DATEI senden' schränkt den Download auch bei nachträglich hinzugefügter CAD-DATEI auf die DRUCK-DATEI ein.",
        "plan_successfully_sent_to": "Plan erfolgreich versendet an:",
        "plans_default_subject": "{number} neue Pläne für Sie",
        "plans_includes_only_print_files": "Die Pläne beinhalten nur Druck-Dateien",
        "plans_subject_prefix": "{projectTitle} - Planversand:",
        "plans_successfully_sent_to": "Pläne erfolgreich versendet an:",
        "recipient": "Empfänger",
        "recipients": "Empfänger",
        "recipients_group_title": "Titel:",
        "recipients_list": "Empfänger",
        "recipients_list_label": "Empfänger:",
        "save_time_with_recipient_groups": "Immer die gleichen Empfänger? Sparen Sie mit Versandgruppen viel Zeit!",
        "select_recipients": "Empfänger auswählen",
        "send": "Versand",
        "send_document": "Dokument senden",
        "send_document_to": "Dokument senden an …",
        "send_documents_to": "{count} Dokumente senden an …",
        "send_only_print_file": "Nur DRUCK-DATEI senden",
        "send_only_print_files": "Nur DRUCK-DATEIEN senden",
        "send_plan": "Plan senden",
        "send_plan_to": "Plan senden an …",
        "send_plans_to": "{count} Pläne senden an …",
        "send_to_additional_participants": "An weitere Beteiligte senden",
        "send_to_externals": "An „Beteiligte ohne Login“:",
        "send_to_me": "Sende Kopie immer auch an mich",
        "send_to_me_participant_label": "Kopie an mich",
        "send_to_new_externals": "An weitere Empfänger:",
        "send_to_project_participants": "An Projekt-Beteiligte:",
        "sending_options": "Versandoptionen:",
        "server_error": "Beim Speichern der Anfrage ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "server_error_send": "Es gab einen Fehler beim Versand.",
        "show_disabled_participant": "Deaktivierten Beteiligten anzeigen",
        "show_external_disabled_email": "Deaktivierten 'Beteiligten ohne Login' anzeigen",
        "show_recipients_list": "Empfängerliste im E-Mail anzeigen",
        "subject": "Betreff:",
        "subject_suffix": "Betreff-Endung",
        "tasks_subject_prefix": "{projectTitle} - Taskversand:",
        "to_group": "Versandgruppe",
        "to_groups": "Versandgruppen",
        "warning": "ACHTUNG!",
        "x_documents": "{count} Dokumente",
        "x_plans": "{count} Pläne",
        "you_are_sending_multiple_restricted_items": "Sie senden {count} Dokumente mit eingeschränktem Zugriff!",
        "you_are_sending_one_restricted_item": "Sie senden ein Dokument mit eingeschränktem Zugriff!"
      },
      "document_name": {
        "edit_server_error": "Es gab einen Fehler beim Speichern des Dokumentennamen/Dokumenteninhalt. Dokumentennamen/Dokumenteninhalt konnte nicht geändert werden.",
        "label_content": "Dokumenteninhalt:",
        "label_current_version": "Aktuelle Version:",
        "label_first_index": "Erste Version:",
        "label_first_index_max_char": "Version (max. 6 Zeichen):",
        "label_name": "Dokumentennummer/Codierung:",
        "label_name_long": "Dokumentennummer/Codierung:",
        "label_version": "Version:",
        "placeholder_content": "Dokumenteninhalt",
        "placeholder_index": "Version",
        "placeholder_name": "Dokumentennummer/Codierung",
        "validation_not_available": "Ein Dokument mit dieser Nummer wurde bereits angelegt!",
        "validation_required": "Tragen Sie eine Dokumentennummer/Codierung ein.",
        "validation_update_existing_item": "Aktualisieren Sie das vorhandene Dokument {itemName}"
      },
      "document_not_available": "Dokument nicht verfügbar",
      "document_permission": {
        "access_permission": "Zugriffsberechtigung:",
        "admin_auto_access_hint": "Administrator hat immer Zugriff",
        "choose_participants": "Beteiligte für neue Vorauswahl wählen",
        "delete_group": "Vorauswahl löschen",
        "edit_group": "Beteiligten-Vorauswahl ändern",
        "edit_server_error": "Es gab einen Fehler beim Speichern der Zugriffsberechtigung. Zugriffsberechtigung konnte nicht geändert werden.",
        "grant_these_participants_access": "Diesen Beteiligten Zugriff erteilen:",
        "new_group": "Beteiligten-Vorauswahl erstellen",
        "no_name": "Beteiligten-Vorauswahl benennen",
        "no_participants_selected": "Beteiligte auswählen",
        "only_accessible_for": "Nur sichtbar für:",
        "participant": "Beteiligter",
        "participants": "Beteiligte",
        "public_document": "Öffentliches Dokument",
        "restricted_document": "Sicheres Dokument (Zugriff einschränken)",
        "to_group": "Beteiligten-Vorauswahl"
      },
      "document_permission_filter": {
        "public": "Öffentliche Dokumente",
        "restricted": "Zugriff eingeschränkt"
      },
      "download_link_access_date_label": "Zugriff per E-Mail. Läuft ab am",
      "download_link_access_list_header": "Beteiligte ohne Login mit Zugriff per E-Mail Versand:",
      "edit_server_error_documents_403": "Bitte laden Sie die Seite neu. Sie haben keinen Zugriff mehr auf dieses Dokument",
      "edit_server_error_plans_403": "Bitte laden Sie die Seite neu. Sie haben keinen Zugriff mehr auf diesen Plan",
      "go_to_revision_approval": "… zur Prüfung",
      "item_delete": "{itemType} löschen",
      "item_delete_server_error": "{itemType} konnte nicht gelöscht werden.",
      "item_restore": "{itemType} wiederherstellen",
      "item_restore_name_already_exists": "ACHTUNG: {itemType} „{itemName}“ existiert bereits.",
      "item_restore_server_error": "{itemType} konnte nicht wiederhergestellt werden.",
      "item_restricted_message": "Diesen {itemType} dürfen Sie nicht ändern, da Sie nicht der Rolle des Verfassers angehören!",
      "item_update_label": "{itemType} aktualisieren",
      "maybe_no_permission_to_view_document": "Möglicherweise besitzen Sie keine Berechtigung mehr um das Dokument einzusehen.",
      "maybe_no_permission_to_view_plan": "Möglicherweise besitzen Sie keine Berechtigung mehr um den Plan einzusehen.",
      "multi_action_selection_preview": {
        "documents": {
          "hide": "ausblenden",
          "item_selected": "{count} ausgewähltes Dokument",
          "items_selected": "{count} ausgewählte Dokumente",
          "show": "anzeigen"
        },
        "participant": {
          "hide": "ausblenden",
          "item_selected": "{count} ausgewählter Beteiligter",
          "items_selected": "{count} ausgewählte Beteiligte",
          "show": "anzeigen"
        },
        "users": {
          "hide": "ausblenden",
          "item_selected": "{count} ausgewählte Benutzer",
          "items_selected": "{count} ausgewählte Benutzer",
          "show": "anzeigen"
        },
        "plans": {
          "hide": "ausblenden",
          "item_selected": "{count} ausgewählten Plan",
          "items_selected": "{count} ausgewählte Pläne",
          "show": "anzeigen"
        },
        "tasks": {
          "hide": "ausblenden",
          "item_selected": "{count} ausgewählter Task",
          "items_selected": "{count} ausgewählte Tasks",
          "show": "anzeigen"
        }
      },
      "new": {
        "create_document_in_parallel": "weiteres Dokument parallel anlegen",
        "create_new_document": "Neues Dokument anlegen",
        "create_new_plan": "Neuen Plan anlegen",
        "create_plan_in_parallel": "weiteren Plan parallel anlegen",
        "create_server_error_document": "Beim Speichern des Dokuments ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "create_server_error_plan": "Beim Speichern des Plans ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "created_document": "Dokument '{itemLink}' wurde erstellt.",
        "created_plan": "Plan '{itemLink}' wurde erstellt.",
        "document_description": "Dokumentbeschreibung",
        "document_name_already_exists": "Das Dokument konnte nicht gespeichert werden. Es existiert bereits ein Dokument mit der Nummer '{itemName}'.",
        "enter_a_version": "Bitte geben Sie eine Version an.",
        "enter_an_index": "Tragen Sie einen Index ein.",
        "message_no_approvers_in_project_to_select": "Für diese Option muss mindestens ein Beteiligter die Planprüf-Berechtigung haben!",
        "no_index_comment": "Keine Anmerkung zum Index",
        "plan_description": "Planbeschreibung",
        "plan_name_already_exists": "Der Plan konnte nicht gespeichert werden. Es existiert bereits ein Plan mit der Nummer '{itemName}'.",
        "save_and_create_document": "speichern + weiteres Dokument anlegen",
        "save_and_create_plan": "speichern + weiteren Plan anlegen",
        "select_document_properties": "Dokumenteigenschaften auswählen",
        "select_file": "Datei wählen",
        "select_files": "Dateien wählen",
        "select_plan_properties": "Planeigenschaften auswählen",
        "separate_document_name_and_index": "Dokumentennummer und Version",
        "separate_name_and_index": "Plannummer und Index/Status trennen",
        "use_settings_from_document": "Eingaben vom letzten Dokument",
        "use_settings_from_plan": "Eingaben von letztem Plan",
        "use_settings_from_task": "Eingaben vom letzten Task"
      },
      "new_index": "Neuer Index",
      "new_version": "Neue Version",
      "phasetag": {
        "document_label": "Dokumentenordner:",
        "document_validation_required": "Wählen Sie einen Dokumentenordner aus.",
        "edit_server_error_documents": "Es gab einen Fehler beim Speichern des Dokumentenordners. Dokumentenordner konnte nicht geändert werden.",
        "edit_server_error_plans": "Es gab einen Fehler beim Speichern des Planordners. Planordner konnte nicht geändert werden.",
        "plan_label": "Planordner:",
        "plan_validation_required": "Wählen Sie einen Planordner aus."
      },
      "plan_name": {
        "edit_server_error": "Es gab einen Fehler beim Speichern des Plannamen/Planinhalt. Planname/Planinhalt konnte nicht geändert werden.",
        "label_content": "Planinhalt:",
        "label_current_index": "Aktueller Index:",
        "label_first_index": "Erster Index:",
        "label_first_index_max_char": "Index + ggf. Status (max. 6 Zeichen):",
        "label_index": "Index:",
        "label_name": "Plannummer/Codierung:",
        "label_name_long": "<strong>Plannummer / Codierung</strong> (ohne Index, Status und Datum):",
        "placeholder_content": "Planinhalt",
        "placeholder_index": "Index",
        "placeholder_name": "Plannummer/Codierung",
        "validation_not_available": "Ein Plan mit dieser Nummer wurde bereits angelegt!",
        "validation_required": "Tragen Sie eine Plannummer/Codierung ein.",
        "validation_update_existing_item": "Aktualisieren Sie den vorhandenen Plan {itemName}"
      },
      "plan_not_available": "Plan nicht verfügbar",
      "planfred_permissionsystem": "Berechtigungssystem kurz erklärt",
      "revision": {
        "activity_log": {
          "changed_tags": "Tags geändert von {participant}: {diff}",
          "deleted_from": "{itemType} GELÖSCHT von {participant}",
          "exported_to": "Index ins Projekt {projectTitle} exportiert von {participant}",
          "index_imported_from": "Index aus Projekt {projectTitle} importiert",
          "item_imported_from": "{itemType} aus Projekt {projectTitle} importiert",
          "restored_from": "{itemType} WIEDERHERGESTELLT von {participant}",
          "changed_top_category": "{participant} hat die Obergruppe von {oldCategory} auf {newCategory} geändert.",
          "plans": {
            "changed_name": "{participant} hat den Plan von „{oldName}“ auf „{newName}“ umbenannt.",
            "changed_phase": "{participant} hat den Planordner von {oldPhasetag} auf {newPhasetag} geändert.",
            "changed_author": "{participant} hat den Planverfasser von {authorParticipantOld} auf {authorParticipantNew} geändert."
          },
          "documents": {
            "changed_name": "{participant} hat das Dokument von „{oldName}“ auf „{newName}“ umbenannt.",
            "changed_phase": "{participant} hat den Dokumentenordner von {oldPhasetag} auf {newPhasetag} geändert.",
            "changed_author": "{participant} hat den Verfasser von {authorParticipantOld} auf {authorParticipantNew} geändert."
          }
        },
        "add_approval": "Prüfung anfordern",
        "add_correction": "Weiteren Kommentar anhängen",
        "approval_attachment_label": "Dateianhang als Freigabebestätigung",
        "approval_attachment_warning_text": "Dieser Anhang dient ausschließlich zur Übermittlung der Datei (Planindex/Dokumentenversion) mit Freigabestempel ohne Korrekturanmerkungen.",
        "approval_attachment_warning_title": "Achtung:",
        "approval_cancelled_by": "Prüfung entzogen von {participant}",
        "approval_comment_message": "Anmerkung zur Prüfung:",
        "approval_date_label": "Prüffrist:",
        "approval_done": "Prüfung abgeschlossen.",
        "approval_edit_server_error": "Beim Speichern der Prüfung ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "approval_leave_review_dates_unchanged": "Prüffrist unverändert belassen",
        "approval_message_warning_will_only_be_applied_to_new_approvals": "Die Nachricht wird nur zu neuen Prüfanfragen hinzugefügt.",
        "approval_mode_and": "ALLEN Ausgewählten",
        "approval_mode_or": "EINEM der Ausgewählten",
        "approval_not_finished": "Diese Prüfung wurde nicht abgeschlossen.",
        "approval_remove_due_date_label": "Keine Prüffrist",
        "approval_remove_due_date_warning": "Es werden die Prüffristen entfernt.",
        "approval_request": "Anfrage zur Prüfung:",
        "approval_request_message": "Nachricht bei Prüfungsanfrage:",
        "approval_requested_by": "Angefordert von {participant}",
        "approval_required": "Diese Planrevision erfordert meine Prüfung!",
        "approval_required_by": "Prüfung erforderlich von:",
        "approval_required_from_all_participants": "Die Prüfung ist von {bold} aufgelisteten Beteiligten erforderlich.",
        "approval_required_from_all_participants_bold": "ALLEN",
        "approval_required_from_one_participant": "Die Prüfung ist von {bold} der aufgelisteten Beteiligten erforderlich.",
        "approval_required_from_one_participant_bold": "EINEM",
        "approval_required_from_this_participant": "Die Prüfung ist nur von diesem Beteiligten erforderlich.",
        "approval_required_hint": "{participant} hat von mir eine Prüfung angefordert.",
        "approval_required_hint_due_date_hint": "Die Prüffrist ist seit {date} überfällig!",
        "approval_set_review_date_to": "Prüffrist ändern auf…",
        "approval_status_approval": "Freigabe",
        "approval_status_correction": "Kommentar",
        "approval_with_remarks": "Freigabe mit Anmerkungen",
        "approve_or_reject_index": "Direkt freigeben/kommentieren ...",
        "approve_or_reject_version": "Diese Version von MIR freigeben/kommentieren ...",
        "approver_label": "Prüfer:",
        "cad_file_missing": "CAD-Datei fehlt",
        "choose_approval_status": "Auswählen:",
        "choose_participants_for_approval": "Beteiligte für die Prüfung auswählen.",
        "comment": "Kommentar:",
        "comment_for_approval": "Anmerkung zur Freigabe:",
        "comment_for_index": "Anmerkung zum Index:",
        "comment_for_rejection": "Kommentar zur angeforderten Prüfung:",
        "comment_for_review": "Anmerkung:",
        "comment_for_version": "Anmerkung zur Version:",
        "consider_the_corrections": "Beachten Sie den Kommentar zur Prüfung!",
        "consider_the_corrections_plural": "Beachten Sie die Kommentare zur Prüfung!",
        "correction_attachment": "Anhang:",
        "corrections_for_document_revision": "Zu dieser Dokumentenversion gibt es Kommentare.",
        "corrections_for_plan_revision": "Zu diesem Planindex gibt es Kommentare.",
        "current_index": "Aktueller Index",
        "current_version": "Aktuelle Version",
        "didnt_got_downloaded_yet": "wurde noch von keiner Person geladen",
        "didnt_got_sent_yet": "wurde noch an keine Person versendet",
        "document_approval_got_revoked": "Diese Dokumentenprüfung wurde zurückgezogen.",
        "document_comment": "Anmerkung zur Version:",
        "document_revision_got_approved": "Diese Dokumentenversion wurde freigegeben.",
        "document_revision_waiting_for_my_approval": "Diese Dokumentenversion erfordert meine Prüfung!",
        "download_file": "Datei herunterladen",
        "download_plan": {
          "unauthorized_approved_hint": "Nach abgeschlossener Prüfung kann keine Datei ergänzt werden.",
          "unauthorized_pending_approval_hint": "Während einer Prüfung kann keine Datei ergänzt werden."
        },
        "download_server_error": "Beim Laden der Datei ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "downloaded_by": "von {participant}",
        "downloaded_by_label": "Geladen von",
        "downloaded_by_one_person": "1 Person",
        "downloaded_by_x_persons": "{count} Personen",
        "edit_approval": "Prüfung bearbeiten",
        "edit_group": "Prüfer-Vorauswahl bearbeiten",
        "error_download": "Beim Heruntergeladen der Datei ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "imported_item_approved": "Die Freigabe wurde beim Import übernommen",
        "index_history": "Indexhistorie",
        "index_requires_approval_from": "Prüfung erforderlich von …",
        "item_copy_and_edit": "{itemType} kopieren & bearbeiten",
        "label_index": "Index",
        "label_version": "Version",
        "last_index": "Letzter Index: {lastIndex}",
        "last_version": "Letzte Version: {lastIndex}",
        "link_add_approval": "Prüfung anfordern",
        "link_edit_approval": "Prüfung bearbeiten",
        "message_from": "Nachricht von {participant}:",
        "my_review": "Mein Prüfergebnis",
        "new_group": "Prüfer-Vorauswahl erstellen",
        "no_approval_request": "Keine Nachricht zur Prüfung vorhanden",
        "no_approval_required": "Keine Prüfung erforderlich",
        "no_approvers_in_project": "Es sind noch keine Freigeber im Projekt definiert.",
        "no_reworked_index": "Noch kein überholter Index",
        "no_reworked_version": "Noch keine überholte Version",
        "not_downloaded_yet": "wurde noch von keiner Person geladen",
        "one_participant_required_for_approval": "Für die Prüfung muss mindestens ein Beteiligter ausgewählt werden!",
        "only_first_download_listed": "Pro Person wird nur das erst- und letztmalige Laden aufgelistet",
        "only_print_file_sent": "nur DRUCK-DATEI versendet",
        "open_file": "Datei öffnen",
        "plan_approval_got_revoked": "Diese Planprüfung wurde zurückgezogen.",
        "plan_comment": "Anmerkung zum Index:",
        "plan_revision_create_server_error": "Beim Erstellen der Revision ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "plan_revision_got_approved": "Dieser Planindex wurde freigegeben.",
        "plan_revision_waiting_for_my_approval": "Dieser Planindex erfordert meine Prüfung!",
        "please_enter_a_plan_index": "Tragen Sie einen Planindex ein.",
        "please_select_a_review_result": "Bitte wählen Sie ein Prüfergebnis.",
        "print_file_missing": "DRUCK-Datei fehlt",
        "revision_is_approved_by_myself": "Diese Revision ist von mir freigegeben",
        "save_and_approve_by_myself_immediately": "Version direkt freigeben",
        "save_and_comment_by_myself_immediately": "Version direkt ablehnen",
        "save_and_finish_approval": "Speichern und Prüfung abschließen",
        "save_and_request_approval": "Speichern und Prüfung anfordern",
        "save_and_revoke_approval": "Speichern und Prüfung zurückziehen",
        "save_approval_server_error": "Es ist ein Fehler aufgetreten. Der Prüfungsstatus konnte nicht gespeichert werden.",
        "save_approval_server_error_date_must_be_in_future": "Das Prüfdatum muss in der Zukunft liegen.",
        "save_correction": "Kommentar speichern",
        "save_correction_server_error": "Beim Speichern des Kommentars ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_correction_validation_error": "Fügen Sie entweder eine Datei oder ein Kommentar hinzu",
        "save_index": "Index speichern",
        "save_index_and_back_to_list": "Index speichern und zurück zur Liste",
        "save_index_and_close": "Index speichern und Tab schließen",
        "save_index_approval": "Index-Freigabe absenden",
        "save_version": "Version speichern",
        "save_version_and_back_to_list": "Version speichern und zurück zur Liste",
        "save_version_and_close": "Version speichern und Tab schließen",
        "sent_to_label": "Versendet an",
        "sent_to_one_person": "1 Beteiligten",
        "sent_to_x_persons": "{count} Beteiligte",
        "submit_review": "Prüfergebnis eintragen",
        "to_be_reviewed_by_me": "… von mir zu prüfen",
        "to_groups": "Prüfer-Vorauswahl",
        "uploaded_by": "{fromNow} hochgeladen von {participant}",
        "version_history": "Versionshistorie",
        "version_requires_approval_from": "Diese Version erfordert eine Prüfung von …"
      },
      "role": {
        "item_edit_server_error": "Es gab einen Fehler beim Speichern der Rolle.",
        "label_role": "Rolle:",
        "new_role_placeholder": "Neue Rolle",
        "no_role_assigned_yet": "Noch keine Rolle vergeben",
        "role": "Rolle",
        "unsaved_role_warning": "Rolle „{role}“ vor dem Speichern hinzufügen."
      },
      "save_edit_top_category_error": "Beim Speichern der Obergruppe ist ein Fehler aufgetreten.",
      "select_top_category": "Wählen Sie eine Obergruppe aus.",
      "tags": {
        "item_edit_server_error": "Es gab einen Fehler beim Speichern der Tag-Auswahl.",
        "label_tags": "Tags:",
        "new_tag_placeholder": "Neues Tag",
        "no_tags_assigned": "Keine Tags zugewiesen",
        "no_tags_defined_yet": "Noch keine Tags angelegt",
        "only_use_existing_tags": "In diesem Projekt dürfen nur vordefinierte Tags verwendet werden.",
        "unsaved_tag_warning": "Tag „{tag}“ vor dem Speichern hinzufügen."
      },
      "task_mailer": {
        "delivery_failed_for_participant": "Der Versand an folgenden Beteiligten ist fehlgeschlagen:",
        "delivery_failed_for_participants": "Der Versand an folgende Beteiligte ist fehlgeschlagen:",
        "modal_title": "Erinnerung senden",
        "participants_locked": "Dieser Beteiligte wurde deaktiviert:",
        "recipient": "Empfänger:",
        "reminder": "Task-Erinnerung",
        "send_success_message": "Versendet an:",
        "server_error_send": "Es gab einen Fehler beim Versand.",
        "subject": "Betreff:",
        "subject_prefix": "{projectTitle} - #{consecutiveNumber} {taskTitle}",
        "task_successfully_sent_to": "Task erfolgreich versendet an:",
        "tasks_successfully_sent_to": "Tasks versendet an:"
      },
      "top_category": "Obergruppe:",
      "upload_new_index": "Neuen Index hochladen",
      "upload_new_version": "Neue Version hochladen",
      "your_role_is_not_allowed_to_update_document": "In Ihrer Rolle {userRole} können Sie keine Dokumente anderer Rollen aktualisieren.",
      "your_role_is_not_allowed_to_update_plan": "In Ihrer Rolle {userRole} können Sie keine Pläne anderer Rollen aktualisieren."
    },
    "item_list": {
      "available_offline": "Offline",
      "cad_file_label": "CAD",
      "change_properties": {
        "approval": {
          "approval_date": "Prüffrist",
          "approval_of_selected_document": "Prüfung des ausgewählten Dokuments",
          "approval_of_selected_documents": "Prüfung der ausgewählten Dokumente",
          "approval_of_selected_plan": "Prüfung des ausgewählten Plans",
          "approval_of_selected_plans": "Prüfung der ausgewählten Pläne",
          "cannot_update_approval_of_document": "Bei diesem Dokument kann die Prüfung nicht bearbeitet werden",
          "cannot_update_approval_of_documents": "Bei {filteredCount} von {totalCount} Dokumenten kann die Prüfung nicht bearbeitet werden",
          "cannot_update_approval_of_plan": "Bei diesem Plan kann die Prüfung nicht bearbeitet werden",
          "cannot_update_approval_of_plans": "Bei {filteredCount} von {totalCount} Plänen kann die Prüfung nicht bearbeitet werden",
          "edit_approval_date": "Prüffrist ändern",
          "edit_approval_of_selected_document": "Prüfungs-Anforderung des ausgewählten Dokuments ändern",
          "edit_approval_of_selected_documents": "Prüfungs-Anforderung der ausgewählten Dokumente ändern",
          "edit_approval_of_selected_plan": "Prüfungs-Anforderung des ausgewählten Plans ändern",
          "edit_approval_of_selected_plans": "Prüfungs-Anforderung der ausgewählten Pläne ändern",
          "edit_review_date_of_selected_document": "Prüffrist des ausgewählten Dokuments ändern auf…",
          "edit_review_date_of_selected_documents": "Prüffrist der ausgewählten Dokumente ändern auf…",
          "edit_review_date_of_selected_plan": "Prüffrist des ausgewählten Plans ändern auf…",
          "edit_review_date_of_selected_plans": "Prüffrist der ausgewählten Pläne ändern auf…",
          "hint_approver_required_documents": "Ihre Auswahl enthält Dokumente, für die aktuell keine Prüfung erforderlich ist. Um die Änderungen zu übernehmen, wählen Sie bitte mindestens einen Prüfer aus, der für alle Dokumente gilt.",
          "hint_approver_required_plans": "Ihre Auswahl enthält Pläne, für die aktuell keine Prüfung erforderlich ist. Um die Änderungen zu übernehmen, wählen Sie bitte mindestens einen Prüfer aus, der für alle Pläne gilt.",
          "label": "Prüfung",
          "no_documents_to_update": "Keine Dokumente zur Auswahl",
          "no_plans_to_update": "Keine Pläne zur Auswahl"
        },
        "author": {
          "label": {
            "documents": "Verfasser",
            "plans": "Verfasser"
          },
          "labels": {
            "documents": "Verfasser",
            "plans": "Verfasser"
          },
          "merge_warning": "Mehrere Verfasser werden unwiderruflich zusammengeführt.",
          "property_details_header": "Verfasser {selectedItems} ändern:",
          "property_editor_header_document": "Verfasser des ausgewählten Dokuments ändern:",
          "property_editor_header_documents": "Verfasser der ausgewählten Dokumente ändern:",
          "property_editor_header_plan": "Verfasser des ausgewählten Plans ändern:",
          "property_editor_header_plans": "Verfasser der ausgewählten Pläne ändern:",
          "property_preview_header_document": "Verfasser des ausgewählten Dokuments:",
          "property_preview_header_documents": "Verfasser der ausgewählten Dokumente:",
          "property_preview_header_plan": "Verfasser des ausgewählten Plans:",
          "property_preview_header_plans": "Verfasser der ausgewählten Pläne:"
        },
        "cancel_btn": "abbrechen",
        "cannot_update_document": "Dieses Dokument kann nicht bearbeitet werden",
        "cannot_update_documents": "{filteredCount} von {totalCount} Dokumente können nicht bearbeitet werden",
        "cannot_update_plan": "Dieser Plan kann nicht bearbeitet werden",
        "cannot_update_plans": "{filteredCount} von {totalCount} Pläne können nicht bearbeitet werden",
        "details_title": "{currentProperties} {selectedItems}",
        "irreversibleActionMessage": "Mehrere {items} werden unwiderruflich zusammengeführt.",
        "irreversibleActionMessageTags": "Diese Tag-Änderungen sind unwiderruflich.",
        "makeDocumentsPublicWarningMessage": "Möchten Sie wirklich alle ausgewählten Dokumente öffentlich machen?",
        "make_offline": {
          "already_offline_count_one_file": "{cached} von 1 Datei bereits offline verfügbar",
          "already_offline_count_x_files": "{cached} von {total} Dateien bereits offline verfügbar",
          "download_log_hint_documents": "Für jedes geladene Dokument wird ein Download protokolliert.",
          "download_log_hint_plans": "Für jeden geladenen Plan wird ein Download protokolliert.",
          "download_size": "{size} zu laden",
          "downloaded_size": "{size} / {total} heruntergeladen",
          "label": "Offline verfügbar machen",
          "modal_title": "Auf Gerät laden",
          "no_file_to_download_document": "Dieses Dokument hat keine Datei zum Herunterladen",
          "no_file_to_download_documents": "Bei {filteredCount} von {totalCount} Dokumenten gibt es keine Datei zum Herunterladen",
          "no_file_to_download_plan": "Dieser Plan hat keine Datei zum Herunterladen",
          "no_file_to_download_plans": "Bei {filteredCount} von {totalCount} Plänen gibt es keine Datei zum Herunterladen",
          "offline_required": "Für das Offline-Verfügbarmachen ist eine Internetverbindung erforderlich.",
          "property_preview_header": "Offline-Verfügbarkeit",
          "retry_failed": "Fehlgeschlagene wiederholen",
          "status_already_offline": "Bereits offline",
          "status_downloaded": "Geladen",
          "status_downloading": "Wird geladen …",
          "status_failed": "Fehlgeschlagen",
          "status_pending": "Wartet",
          "status_too_large": "Zu groß"
        },
        "modal_title": "Eigenschaft ändern",
        "permission": {
          "property_editor_header_document": "Zugriffsberechtigung des ausgewählten Dokuments ändern auf:",
          "property_editor_header_documents": "Zugriffsberechtigung der ausgewählten Dokumente ändern auf:",
          "property_preview_header_document": "Zugriffsberechtigung des ausgewählten Dokuments:",
          "property_preview_header_documents": "Zugriffsberechtigung der ausgewählten Dokumente:"
        },
        "permission_only_editable_by_admins_or_document_authors": "Zugriffsberechtigung kann nur von Administratoren oder dem Dokumentenverfasser geändert werden",
        "phase": {
          "label": {
            "documents": "Dokumentenordner",
            "plans": "Planordner"
          },
          "labels": {
            "documents": "Dokumentenordner",
            "plans": "Planordner"
          },
          "property_details_header": {
            "documents": "Dokumentenordner {selectedItems} ändern:",
            "plans": "Planordner {selectedItems} ändern:"
          }
        },
        "phasetag": {
          "merge_warning_documents": "Mehrere Dokumentenordner werden unwiderruflich zusammengeführt.",
          "merge_warning_plans": "Mehrere Planordner werden unwiderruflich zusammengeführt.",
          "property_editor_header_document": "Dokumentenordner des ausgewählten Dokuments ändern:",
          "property_editor_header_documents": "Dokumentenordner der ausgewählten Dokumente ändern:",
          "property_editor_header_plan": "Planordner des ausgewählten Plans ändern:",
          "property_editor_header_plans": "Planordner der ausgewählten Pläne ändern:",
          "property_preview_header_document": "Dokumentenordner des ausgewählten Dokuments:",
          "property_preview_header_documents": "Dokumentenordner der ausgewählten Dokumente:",
          "property_preview_header_plan": "Planordner des ausgewählten Plans:",
          "property_preview_header_plans": "Planordner der ausgewählten Pläne:"
        },
        "property_list_title": {
          "documents": "Dokumenteneigenschaft auswählen:",
          "participants": "Eigenschaft des Beteiligten auswählen:",
          "plans": "Planeigenschaft auswählen:"
        },
        "review_already_got_answered_by_reviewers": "Die Prüfanfrage wurde bereits von Prüfern beantwortet",
        "review_is_already_done": "Die Prüfung ist bereits abgeschlossen",
        "save_btn": {
          "default": "{count} {itemLabel} ändern",
          "trashed": "{count} {itemLabel} löschen"
        },
        "selected_item": "des ausgewählten {item}",
        "selected_items": "der ausgewählten {item}",
        "tags": {
          "label": {
            "documents": "Tag",
            "plans": "Tag",
            "tasks": "Tag"
          },
          "labels": {
            "documents": "Tags",
            "plans": "Tags",
            "tasks": "Tags"
          },
          "no_tags_message": {
            "plural": {
              "documents": "Den ausgewählten Dokumenten sind keine Tags zugeordnet",
              "plans": "Den ausgewählten Plänen sind keine Tags zugeordnet"
            },
            "singular": {
              "documents": "Dem ausgewählten Dokument sind keine Tags zugeordnet",
              "plans": "Dem ausgewählten Plan sind keine Tags zugeordnet"
            }
          },
          "property_details_header": "Tags {selectedItems} ändern:",
          "property_editor_header_document": "Tags des ausgewählten Dokuments ändern:",
          "property_editor_header_documents": "Tags der ausgewählten Dokumente ändern:",
          "property_editor_header_plan": "Tags des ausgewählten Plans ändern:",
          "property_editor_header_plans": "Tags der ausgewählten Pläne ändern:",
          "property_preview_header_document": "Tags des ausgewählten Dokuments:",
          "property_preview_header_documents": "Tags der ausgewählten Dokumente:",
          "property_preview_header_plan": "Tags des ausgewählten Plans:",
          "property_preview_header_plans": "Tags der ausgewählten Pläne:",
          "used_on_all_documents": "Bei allen Dokumenten zugewiesen:",
          "used_on_all_plans": "Bei allen Plänen zugewiesen:",
          "used_on_some_documents": "Bei einigen Dokumenten zugewiesen:",
          "used_on_some_plans": "Bei einigen Plänen zugewiesen:"
        },
        "top_category": {
          "label": {
            "documents": "Obergruppe",
            "plans": "Obergruppe"
          },
          "labels": {
            "documents": "Obergruppen",
            "plans": "Obergruppen"
          },
          "merge_warning": "Mehrere Obergruppen werden unwiderruflich zusammengeführt.",
          "property_editor_header_document": "Obergruppe des ausgewählten Dokuments ändern:",
          "property_editor_header_documents": "Obergruppe der ausgewählten Dokumente ändern:",
          "property_editor_header_plan": "Obergruppe des ausgewählten Plans ändern:",
          "property_editor_header_plans": "Obergruppe der ausgewählten Pläne ändern:",
          "property_preview_header_document": "Obergruppe des ausgewählten Dokuments:",
          "property_preview_header_documents": "Obergruppen der ausgewählten Dokumente:",
          "property_preview_header_plan": "Obergruppe des ausgewählten Plans:",
          "property_preview_header_plans": "Obergruppen der ausgewählten Pläne:"
        },
        "trashed": {
          "delete_server_error": "Beim Löschen ist ein Fehler aufgetreten – versuchen Sie es erneut.",
          "label": {
            "documents": "Dokumente löschen",
            "plans": "Pläne löschen"
          },
          "label_selected": {
            "documents": "Ausgewähltes Dokument in Papierkorb verschieben",
            "plans": "Ausgewählten Plan in Papierkorb verschieben"
          },
          "label_selected_plural": {
            "documents": "Ausgewählte Dokumente in Papierkorb verschieben",
            "plans": "Ausgewählte Pläne in Papierkorb verschieben"
          },
          "property_preview_header_document": "Ausgewähltes Dokument in Papierkorb verschieben",
          "property_preview_header_documents": "Ausgewählte Dokumente in Papierkorb verschieben",
          "property_preview_header_plan": "Ausgewählten Plan in Papierkorb verschieben",
          "property_preview_header_plans": "Ausgewählte Pläne in Papierkorb verschieben"
        },
        "x_of_y_already_updated": {
          "default": "{counter} von {total} {itemsLabel} geändert",
          "trashed": "{counter} von {total} {itemsLabel} gelöscht"
        }
      },
      "documents": {
        "1_item_approval_due": "1 Dokumentenprüfung fällig",
        "accessible_for_administrators": "Administratoren",
        "accessible_for_creators": "Verfasser",
        "accessible_for_role": "Rolle",
        "approval": {
          "index_approved": "Version wurde FREIGEGEBEN",
          "index_corrections_available": "Zu dieser Version gibt es KOMMENTARE",
          "index_waiting_for_approval": "Version WARTET auf Prüfung"
        },
        "click_on_link_to_create_item": "Klicken Sie auf „Neues Dokument anlegen“ um ein Dokument hochzuladen.",
        "context_menu": {
          "add_approval": "Prüfung anfordern",
          "download_file": "<strong>{fileType}</strong> herunterladen",
          "download_with_attachments": "Herunterladen …",
          "edit_approval": "Prüfung bearbeiten",
          "edit_author": "Verfasser",
          "edit_category": "Obergruppe",
          "edit_name_content": "Nummer/Inhalt",
          "edit_permission": "Zugriffsberechtigung",
          "edit_phasetag": "Dokumentenordner",
          "edit_tags": "Tags",
          "new_and_prefill": "Als Vorlage",
          "open_file": "<strong>{fileType}</strong> öffnen",
          "open_in_new_window": "In neuem Fenster öffnen",
          "trash": "Löschen",
          "un_trash": "Wiederherstellen",
          "update_item": "Aktualisieren",
          "update_item_in_new_window": "In neuem Fenster aktualisieren"
        },
        "create_document": "Dokument anlegen",
        "create_item": "Neues Dokument anlegen",
        "delete_item_error": "Beim Löschen des Dokuments ist ein Fehler aufgetreten - versuchen Sie es erneut.",
        "delete_item_message": "Dokument wird in den Papierkorb verschoben.",
        "delete_item_question": "Dokument löschen?",
        "delete_one_item": "1 Dokument löschen",
        "delete_x_items": "{counter} Dokumente löschen",
        "download_item": "Dokument herunterladen",
        "download_items": "{count} Dokumente herunterladen",
        "download_one_item": "1 Dokument herunterladen",
        "download_x_items": "{counter} Dokumente herunterladen",
        "filter_categories": {
          "permission": "Zugriffsberechtigung",
          "phases": "Dokumentenordner",
          "preset_items_from_me": "Dokumente von mir",
          "roles_creator": "Rollen / Verfasser",
          "top_categories": "Obergruppen"
        },
        "group_import": {
          "back_to_selection": "zurück zur Dokumentenauswahl",
          "create_new_item": "Als neues Dokument anlegen (Dokumentennummer/Codierung muss geändert werden)",
          "create_new_revision": "Dokument aktualisieren (folgendes Dokument im Zielprojekt aktualisieren)",
          "how_should_item_get_imported": "Wie soll dieses Dokument ins Zielprojekt importiert werden?",
          "import_from_other_project": "Dokumente importieren",
          "import_item": "1 Dokument importieren",
          "import_items": "{count} Dokumente importieren",
          "import_more_items": "Weitere Dokumente importieren",
          "import_multiple_items": "Mehrere Dokumente importieren",
          "item_already_imported": "Dokument bereits importiert!",
          "item_name_already_exists": "Diese Dokumentennummer/Codierung existiert bereits im Zielprojekt (Projekt „{projectTitle}“)!",
          "item_trashed_in_target_project": "Das Dokument im Zielprojekt befindet sich im Papierkorb.",
          "keep_selected_items_in_list": "Ausgewählte Dokumente bei Filteränderung behalten",
          "list_of_imported_items": "Liste der neu angelegten Dokumente",
          "list_of_imported_revisions": "Liste der aktualisierten Dokumente",
          "multiple_approved_items_get_imported": "{itemCounter} freigegebene Dokumente",
          "multiple_items_get_created": "{itemCounter} Dokumente werden neu angelegt",
          "multiple_items_get_imported": "{itemCounter} Dokumente werden importiert",
          "multiple_items_get_updated": "{itemCounter} Dokumente werden aktualisiert",
          "multiple_restricted_items_get_imported": "{itemCounter} Dokumente mit Zugriffsberechtigung",
          "multiple_selected_items_exists": "{conflictCounter} ausgewählte Dokumente existieren bereits im Zielprojekt",
          "no_items_with_open_approval_importable": "Dokumente die sich in Prüfung befinden können nicht importiert werden",
          "one_approved_item_gets_imported": "1 freigegebenes Dokument",
          "one_item_gets_created": "1 Dokument wird neu angelegt",
          "one_item_gets_imported": "1 Dokument wird importiert",
          "one_item_gets_updated": "1 Dokument wird aktualisiert",
          "one_restricted_item_gets_imported": "1 Dokument mit Zugriffsberechtigung",
          "one_selected_item_exists": "1 ausgewähltes Dokument existiert bereits im Zielprojekt",
          "only_last_revisions_will_get_imported": "Es wird nur die aktuelle Dokumenten-Version importiert. Die Versions-Historie wird nicht übernommen.",
          "please_change_item_number": "Ändern Sie für die gewählte Option die Dokumentennummer/Codierung!",
          "running_import_leave_anyways": "Aktuell werden Dokumente importiert. Beim Verlassen der Import unterbrochen.",
          "select_one_or_more_items": "Wählen Sie ein oder mehrere Dokumente aus",
          "selected_multiple_items": "{itemCounter} Dokumente selektiert",
          "selected_one_item": "1 Dokument selektiert",
          "successfully_imported": "erfolgreich importiert",
          "visible_for_admins": "nur für Administratoren sichtbar",
          "visible_for_everyone": "für alle sichtbar"
        },
        "items_loading": "Dokumente werden geladen ...",
        "list_header": {
          "author": "Verfasser",
          "content": "Inhalt",
          "file": "Datei",
          "index": "Vers.",
          "name": "Nummer/Codierung",
          "phase": "Ordner",
          "top_category": "Obergruppe"
        },
        "modus": {
          "delete": {
            "headline_deleted_items": "Papierkorb – gelöschte Dokumente",
            "trash_icon_label": "Gelöschte Dokumente"
          },
          "edit": {
            "only_added_items_of_your_role": "Sie können nur Dokumente bearbeiten bei denen Sie oder Ihre Rolle {role} Verfasser ist."
          },
          "print": {
            "export_list": "Exportieren der gefilterten Dokumentenliste",
            "filter_none": "Alle Dokumente",
            "filter_phasetags": "Dokumentenordner: {phasetags}",
            "group_by_none": "Keine",
            "group_by_phasetags": "Gruppierung nach Dokumentenordner",
            "group_by_roles": "Gruppierung nach Rollen",
            "group_by_top_categories": "Gruppierung nach Obergruppen",
            "items_count": "Dokumentenanzahl:",
            "items_list": "Dokumente",
            "overlay_print_is_being_prepared": "Ihr Dokumentenliste wird vorbereitet … {renderedItemsLength} von {allItemsLength}",
            "print_list": "Drucken der gefilterten Dokumentenliste",
            "show_comments": "Anmerkung zur Version anzeigen",
            "show_item_url": "Dokumenten-URL anzeigen",
            "show_permission_list_names": "Zugriffsberechtigung Namen anzeigen"
          },
          "update": {
            "choose_item_to_update": "Wählen Sie ein Dokument aus!",
            "headline_update_item": "Dokument aktualisieren",
            "no_item_create_a_new_item": "Sie können jedoch ein neues Dokument anlegen",
            "no_items_to_update": "Es gibt aktuell keine Dokumente Ihrer Rolle {role} {link}",
            "only_added_items_of_your_role": "Sie können nur Dokumente aktualisieren bei denen Sie oder Ihre Rolle {role} Verfasser ist.",
            "update_current_item": "Dokument aktualisieren"
          }
        },
        "my_items": "Meine Dokumente",
        "no_items_available": "Keine Dokumente vorhanden",
        "one_item": "1 Dokument",
        "only_accessible_for": "Nur sichtbar für:",
        "permission_pill_author": "Verfasser:",
        "restore_item_error": "Beim Wiederherstellen des Dokuments ist ein Fehler aufgetreten - versuchen Sie es erneut.",
        "restricted_document": "Öffentliches Dokument",
        "save_item_error": "Beim Speichern des Dokuments ist ein Fehler aufgetreten.",
        "show_all_name_pills": "Namen anzeigen",
        "show_items_list": "Dokumentenliste anzeigen",
        "show_pill_summary": "Reduzierte Ansicht",
        "too_large_to_download_one_item": "1 Dokument überschreitet die maximale Download-Größe von {size}",
        "too_large_to_download_x_items": "{counter} Dokumente überschreiten die maximale Download-Größe von {size}",
        "update_one_item": "1 Dokument ändern",
        "update_x_items": "{counter} Dokumente ändern",
        "vault_access_restricted": "Eingeschränkt",
        "x_item_approvals_due": "{counter} Dokumentenprüfungen fällig",
        "x_items": "{counter} Dokumente",
        "x_of_y_items": "{filteredCounter} von {unfilteredCounter} Dokumenten",
        "you_need_help_creating_item": "Sie brauchen Hilfe beim Dokument anlegen?"
      },
      "download": "laden",
      "group_import": {
        "all_items_already_imported": "Es wurden bereits alle {itemType} importiert",
        "approved_by_myself": "Von mir im Zielprojekt freigegeben",
        "approved_green": "Freigegeben (grün)",
        "cannot_import_items_in_approval_process": "{itemType} die sich in Prüfung befinden können nicht importiert werden",
        "cannot_import_items_with_open_approval_or_already_imported": "{itemType} die bereits importiert wurden oder sich in Prüfung befinden, können nicht importiert werden!",
        "import_failed": "Beim Importieren ist ein Fehler aufgetreten – versuchen Sie es erneut oder kontaktieren Sie unseren Support.",
        "import_individual_error": "Der Import konnte nicht durchgeführt werden. Kontaktieren Sie unseren Support.",
        "import_settings": "Import-Einstellungen",
        "index_placeholder": "Aa",
        "next_step": "Weiter",
        "no_approval": "Keine Prüfungsanforderung",
        "no_items_to_import": "In diesem Projekt sind keine {itemType} vorhanden",
        "take_over_with_approval": "mit Freigabe übernehmen",
        "take_over_without_approval": "ohne Freigabe übernehmen",
        "top_categories_deactivated_but_still_imported": "Die Obergruppen der importierten {itemType} werden im Zielprojekt erst angezeigt wenn die Funktion „Obergruppen“ in den Einstellungen aktiviert wird!",
        "update_all": "alle aktualisieren"
      },
      "hint_shift_select": "Mehrfachauswahl mit gedrückter SHIFT-Taste (⇧)",
      "items": {
        "all_approvals_completed": "Sie haben alle Prüfungen abgeschlossen.",
        "approval": {
          "last_approval": "Letzte Freigabe:",
          "with_annotations": "mit Anmerkungen"
        },
        "filter_categories": {
          "approval_date": "Filter „Prüffrist“",
          "approvals": "Prüfungen / Freigaben",
          "approver": "Prüfer",
          "filter_approver": "Filter „Prüfer“",
          "filter_author": "Filter „Verfasser“",
          "filter_participant": "Filter „Beteiligte“",
          "preset_my_approvals": "Meine Prüfungen",
          "tags": "Tags"
        },
        "list_header": {
          "approval_process": "Prüffrist",
          "last_approval": "Letzte Prüfaktivität",
          "last_upload": "Letzter Upload",
          "tags": "Tags"
        },
        "modus": {
          "approval": {
            "close_approval_list": "Liste meiner Prüfungen schließen",
            "headline_my_approval_list": "Liste meiner Prüfungen:"
          },
          "delete": {
            "close_recycling_bin": "Papierkorb schließen"
          },
          "print": {
            "content": "Inhalt:",
            "csv_export": "CSV-Export",
            "error_download": "Beim Herunterladen ist ein Fehler aufgetreten – versuchen Sie es erneut.",
            "filter_approvals": "Prüfungen: {approvals}",
            "filter_roles": "Rollen: {roles}",
            "filter_tags": "Tags: {tags}",
            "filter_text_search": "Textsuche: {searchString}",
            "filtering": "Filterung:",
            "project": "Projekt:",
            "show_comments": "Kommentar anzeigen",
            "state": "Stand:",
            "vcf_export": "VCF-Export",
            "xlsx_export": "XLSX-Export"
          }
        },
        "with_annotations": "mit Anmerkungen",
        "you_want_to_adapt_folder_role_tags": "Sie möchten die Planordner, Rollen und Tags an Ihre Projektstruktur anpassen?"
      },
      "multi_action_labels": {
        "adjust_selection_label": "Auswahl anpassen",
        "change_properties": "Bearbeiten",
        "close": "schließen",
        "download": "Download",
        "list_actions": "Listenaktionen",
        "restricted_items_message": "{count} ausgewählter {itemLabel} darf NICHT von Ihnen geändert werden!",
        "select_instruction": {
          "users": "Einen oder mehrere Benutzer auswählen"
        },
        "selected_count": "{count} {itemLabel} ausgewählt",
        "send": "Versand",
        "title": {
          "documents": "Dokumente auswählen …",
          "participants": "Select participants …",
          "plans": "Pläne auswählen …",
          "users": "Benutzer auswählen …"
        }
      },
      "participants": {
        "list_header": {
          "company": "Firma",
          "email": "E-Mail",
          "name": "Name",
          "role": "Rolle",
          "telephone": "Telefon"
        }
      },
      "plans": {
        "1_item_approval_due": "1 Planprüfung fällig",
        "approval": {
          "index_approved": "Index wurde FREIGEGEBEN",
          "index_corrections_available": "Zu diesem Index gibt es KOMMENTARE",
          "index_waiting_for_approval": "Index WARTET auf Prüfung"
        },
        "click_on_link_to_create_item": "Klicken Sie auf „Neuen Plan anlegen“ um einen Plan hochzuladen.",
        "context_menu": {
          "add_approval": "Prüfung anfordern",
          "download_file": "<strong>{fileType}</strong> herunterladen",
          "download_with_attachments": "Herunterladen …",
          "edit_approval": "Prüfung bearbeiten",
          "edit_author": "Planverfasser",
          "edit_category": "Obergruppe",
          "edit_name_content": "Nummer/Inhalt",
          "edit_permission": "Zugriffsberechtigung",
          "edit_phasetag": "Planordner",
          "edit_tags": "Tags",
          "new_and_prefill": "Als Vorlage",
          "open_file": "<strong>{fileType}</strong> öffnen",
          "open_in_new_window": "In neuem Fenster öffnen",
          "trash": "Löschen",
          "un_trash": "Wiederherstellen",
          "update_item": "Aktualisieren",
          "update_item_in_new_window": "In neuem Fenster aktualisieren"
        },
        "create_item": "Neuen Plan anlegen",
        "create_plan": "Plan anlegen",
        "delete_item_error": "Beim Löschen des Plans ist ein Fehler aufgetreten - versuchen Sie es erneut.",
        "delete_item_message": "Plan wird in den Papierkorb verschoben.",
        "delete_item_question": "Plan löschen?",
        "delete_one_item": "1 Plan löschen",
        "delete_x_items": "{counter} Pläne löschen",
        "download_item": "Plan herunterladen",
        "download_items": "{count} Pläne herunterladen",
        "download_one_item": "1 Plan herunterladen",
        "download_x_items": "{counter} Pläne herunterladen",
        "filter_categories": {
          "phases": "Planordner",
          "preset_items_from_me": "Pläne von mir",
          "roles_creator": "Rollen / Planverfasser",
          "top_categories": "Obergruppen"
        },
        "group_import": {
          "back_to_selection": "zurück zur Planauswahl",
          "create_new_item": "Als neuen Plan anlegen (Plannummer/Codierung muss geändert werden)",
          "create_new_revision": "Plan aktualisieren (folgenden Plan im Zielprojekt aktualisieren)",
          "how_should_item_get_imported": "Wie soll dieser Plan ins Zielprojekt importiert werden?",
          "import_from_other_project": "Pläne importieren",
          "import_item": "1 Plan importieren",
          "import_items": "{count} Pläne importieren",
          "import_more_items": "Weitere Pläne importieren",
          "import_multiple_items": "Mehrere Pläne importieren",
          "item_already_imported": "Plan ist bereits importiert!",
          "item_name_already_exists": "Diese Plannummer/Codierung existiert bereits im Zielprojekt (Projekt „{projectTitle}“)!",
          "item_trashed_in_target_project": "Der Plan im Zielprojekt befindet sich im Papierkorb.",
          "keep_selected_items_in_list": "Ausgewählte Pläne bei Filteränderung behalten",
          "list_of_imported_items": "Liste der neu angelegten Pläne:",
          "list_of_imported_revisions": "Liste der aktualisierten Pläne:",
          "multiple_approved_items_get_imported": "{itemCounter} freigegebene Pläne",
          "multiple_items_get_created": "{itemCounter} Pläne werden neu angelegt",
          "multiple_items_get_imported": "{itemCounter} Pläne werden importiert",
          "multiple_items_get_updated": "{itemCounter} Pläne werden aktualisiert",
          "multiple_selected_items_exists": "{conflictCounter} ausgewählte Pläne existieren bereits im Zielprojekt",
          "no_items_with_open_approval_importable": "Pläne die sich in Prüfung befinden können nicht importiert werden!",
          "one_approved_item_gets_imported": "1 freigegebener Plan",
          "one_item_gets_created": "1 Plan wird neu angelegt",
          "one_item_gets_imported": "1 Plan wird importiert",
          "one_item_gets_updated": "1 Plan wird aktualisiert",
          "one_selected_item_exists": "1 ausgewählter Plan existiert bereits im Zielprojekt",
          "only_last_revisions_will_get_imported": "Es wird nur der aktuelle Plan-Index importiert. Die Index-Historie wird nicht übernommen.",
          "please_change_item_number": "Ändern Sie für die gewählte Option die Plannummer/Codierung!",
          "running_import_leave_anyways": "Aktuell werden Pläne importiert. Beim Verlassen der Import unterbrochen.",
          "select_one_or_more_items": "Wählen Sie einen oder mehrere Pläne aus",
          "selected_multiple_items": "{itemCounter} Pläne selektiert",
          "selected_one_item": "1 Plan selektiert",
          "successfully_imported": "erfolgreich importiert"
        },
        "items_loading": "Pläne werden geladen ...",
        "items_loading_error": "Pläne konnten nicht geladen werden – bitte erneut versuchen.",
        "list_header": {
          "author": "Verfasser",
          "cad": "CAD",
          "content": "Inhalt",
          "index": "Index",
          "name": "Nummer/Codierung",
          "phase": "Ordner",
          "print": "Druck",
          "top_category": "Obergruppe"
        },
        "modus": {
          "delete": {
            "headline_deleted_items": "Papierkorb – gelöschte Pläne",
            "trash_icon_label": "Gelöschte Pläne"
          },
          "edit": {
            "only_added_items_of_your_role": "Sie können nur Pläne bearbeiten bei denen Sie oder Ihre Rolle {role} Planverfasser ist."
          },
          "print": {
            "export_list": "Exportieren der gefilterten Planliste",
            "filter_none": "Alle Pläne",
            "filter_phasetags": "Planphasen: {phasetags}",
            "group_by_none": "Keine",
            "group_by_phasetags": "Gruppierung nach Planordner",
            "group_by_roles": "Gruppierung nach Rollen",
            "group_by_top_categories": "Gruppierung nach Obergruppen",
            "items_count": "Plananzahl:",
            "items_list": "Pläne",
            "overlay_print_is_being_prepared": "Ihr Planlistenausdruck wird vorbereitet … {renderedItemsLength} von {allItemsLength}",
            "print_list": "Drucken der gefilterten Planliste",
            "show_comments": "Anmerkung zum Index anzeigen",
            "show_item_url": "Plan-URL anzeigen"
          },
          "update": {
            "choose_item_to_update": "Wählen Sie einen Plan aus!",
            "headline_update_item": "Plan aktualisieren",
            "no_item_create_a_new_item": "Sie können jedoch einen neuen Plan anlegen",
            "no_items_to_update": "Es gibt aktuell keine Pläne Ihrer Rolle {role} {link}",
            "only_added_items_of_your_role": "Sie können nur Pläne aktualisieren bei denen Sie oder Ihre Rolle {role} Planverfasser ist.",
            "update_current_item": "Plan aktualisieren"
          }
        },
        "my_items": "Meine Pläne",
        "no_items_available": "Keine Pläne vorhanden",
        "one_item": "1 Plan",
        "restore_item_error": "Beim Wiederherstellen des Plans ist ein Fehler aufgetreten - versuchen Sie es erneut.",
        "save_item_error": "Beim Speichern des Plans ist ein Fehler aufgetreten.",
        "show_items_list": "Planliste anzeigen",
        "too_large_to_download_one_item": "1 Plan überschreitet die maximale Download-Größe von {size}",
        "too_large_to_download_x_items": "{counter} Pläne überschreiten die maximale Download-Größe von {size}",
        "update_one_item": "1 Plan ändern",
        "update_x_items": "{counter} Pläne ändern",
        "x_item_approvals_due": "{counter} Planprüfungen fällig",
        "x_items": "{counter} Pläne",
        "x_of_y_items": "{filteredCounter} von {unfilteredCounter} Plänen",
        "you_need_help_creating_item": "Sie brauchen Hilfe beim Plan anlegen?"
      },
      "print_attention": "ACHTUNG!",
      "print_file_label": "DRUCK",
      "print_use_button": "Verwenden Sie für einen optimalen Ausdruck von Listen den „Drucken“-Button von PLANFRED! Diese Funktion steht im Papierkorb nicht zur Verfügung.",
      "printed_at": "ausgedruckt am {date}",
      "send": "senden",
      "to_be_approved_by_myself": "Von mir zu prüfen",
      "top_category": "Obergruppe"
    },
    "item_new": {
      "documents": {
        "author": {
          "placeholder": "Verfasser"
        },
        "content": {
          "placeholder": "Dokumenteninhalt"
        },
        "index": {
          "placeholder": "Version"
        },
        "name": {
          "placeholder": "Dokumentennummer/Codierung",
          "validation_not_available": "Ein Dokument mit dieser Nummer wurde bereits angelegt!",
          "validation_required": "Tragen Sie eine Dokumentennummer/Codierung ein.",
          "validation_update_existing_item": "Aktualisieren Sie das vorhandene Dokument {itemName}"
        },
        "new_document": "Neues Dokument",
        "permission": {
          "placeholder": "Zugriffsberechtigung"
        },
        "phase_tag": {
          "placeholder": "Dokumentenordner",
          "validation_required": "Wählen Sie einen Dokumentenordner aus."
        },
        "revision": {
          "comment": {
            "placeholder": "Kommentar"
          },
          "placeholder": "Neue Version",
          "placeholder_new": "Erste Version"
        },
        "save_item": "Dokument speichern",
        "step_four": "Dokumentbeschreibung",
        "step_one": "Datei auswählen",
        "step_three": "Dokumenteigenschaften auswählen",
        "step_two": "Dokumentennummer und Version",
        "tags": {
          "placeholder": "Tags"
        },
        "top_category": {
          "placeholder": "Obergruppe",
          "validation_required": "Wählen Sie eine Obergruppe aus."
        }
      },
      "plans": {
        "author": {
          "placeholder": "Planverfasser"
        },
        "content": {
          "placeholder": "Planinhalt"
        },
        "index": {
          "placeholder": "Erster Index",
          "validation_required": "Tragen Sie einen Index ein."
        },
        "name": {
          "placeholder": "Plannummer/Codierung",
          "validation_not_available": "Ein Plan mit dieser Nummer wurde bereits angelegt!",
          "validation_required": "Tragen Sie eine Plannummer/Codierung ein.",
          "validation_update_existing_item": "Aktualisieren Sie den vorhandenen Plan {itemName}"
        },
        "new_plan": "Neuer Plan",
        "phase_tag": {
          "placeholder": "Planordner",
          "validation_required": "Wählen Sie einen Planordner aus."
        },
        "revision": {
          "comment": {
            "placeholder": "Kommentar"
          },
          "placeholder": "Neuer Index",
          "placeholder_new": "Erster Index"
        },
        "save_item": "Plan speichern",
        "step_four": "Planbeschreibung",
        "step_one": "Datei(en) auswählen",
        "step_three": "Planeigenschaften auswählen",
        "step_two": "Plannummer und Index trennen",
        "tags": {
          "placeholder": "Tags"
        },
        "top_category": {
          "placeholder": "Obergruppe",
          "validation_required": "Wählen Sie eine Obergruppe aus."
        }
      }
    },
    "live_update": {
      "banner": {
        "dismiss": "Schließen",
        "install": "Jetzt installieren",
        "message_critical": "Wichtiges Update wird beim nächsten Seitenwechsel installiert",
        "title": "App-Update verfügbar"
      },
      "critical_reload": {
        "header": "App wird aktualisiert",
        "message": "Die App wird jetzt aktualisiert und neu gestartet."
      },
      "header": "Update verfügbar",
      "install_now": "Jetzt installieren",
      "later": "Später",
      "message": "Die App startet neu, um das Update zu installieren."
    },
    "location_maps": {
      "add_location": "Verortung hinzufügen",
      "add_location_layer": "Verortungsplan hinzufügen",
      "append_pin_to_task": "Pin an Task zuweisen",
      "assign_pin_to_photo": "Pin an Foto zuweisen",
      "assign_pin_to_task": "Pin an Task zuweisen",
      "back_to_location_layer_selection": "zurück zur Verortungsplan-Auswahl",
      "click_on_create_button_to_enable_pinning": "Um die Verortung von Tasks am Plan zu ermöglichen, muss zumindest ein Verortungsplan erstellt werden!",
      "confirm_delete_location_layer": "Wollen Sie den Verortungsplan endgültig löschen?",
      "change_location_layer": "Verortungsplan wechseln",
      "create_location_layer": "Neuen Verortungsplan erstellen",
      "delete_existing_pins": "Vorhandene Pins löschen",
      "delete_location_layer": "Verortungsplan löschen",
      "delete_location_layer_pending_version": "Der Verortungsplan kann nicht gelöscht werden, solange eine Version noch verarbeitet wird.",
      "did_not_find_location_layer": "Verortungsplan nicht gefunden",
      "edit_location_layer": "Verortungsplan ändern",
      "edit_pin": "Pin ändern",
      "enter_location_layer_title": "Vergeben Sie einen Titel für diesen Verortungsplan.",
      "error_generating_map": "Der Verortungsplan konnte nicht generiert werden.",
      "error_image_too_small": "Die Höhe und Breite des Bildes muss mindestens 512 Pixel betragen.",
      "error_invalid_extensions": "Invalide Dateiendung. Folgende Endungen sind erlaubt: {extensions}",
      "error_location_update_not_possible_because_its_inactive": "Verortung nicht möglich, da dieser Verortungsplan deaktiviert wurde.",
      "error_multiple_file_upload": "Es können nur {maxFiles} Dateien hochgeladen werden.",
      "error_on_save": "Beim Speichern des Verortungsplans ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "existing_photo": "Bestehendes Foto",
      "existing_pins_will_be_deleted": "Vorhandene Pins werden unwiderruflich gelöscht",
      "existing_task": "Bestehender Task",
      "found_x_location_plans": "{x} mögliche Verortungspläne mit dieser Verortung gefunden.",
      "go_to_location_map_settings": "Zu den Verortungseinstellungen",
      "label_not_set": "\"{label}\" nicht gesetzt",
      "location_layer_properties_info": "Nur die hier ausgewählten Verortungs-Eigenschaften sind beim Anlegen oder Bearbeiten eines Tasks / Fotos auswählbar.",
      "location_layer_title": "Titel:",
      "location_layers": "Verortungspläne",
      "location_map_could_not_be_loaded": "Der Verortungsplan konnte nicht geladen werden.",
      "location_map_is_generating": "Der Verortungsplan wird am Server generiert – dies kann mehrere Minuten dauern.<br><br>Sie können jetzt mit Planfred weiterarbeiten.",
      "location_map_is_generating_with_link": "Der Verortungsplan wird am Server generiert – dies kann mehrere Minuten dauern. Wenn Sie auf abbrechen klicken, läuft die Planerstellung im Hintergrund weiter.<br><br>Mehrere Verortungspläne erstellen, bearbeiten und verwalten? ",
      "location_plan_already_exists": "Ein Verortungsplan mit dieser Verortung ist bereits vorhanden.",
      "location_property_inherited_from_layer": "\"{locationProperty}\" wurde vom Verortungsplan übernommen und kann nicht geändert werden.",
      "location_tags": "Verortungstags",
      "location_tags_will_be_merged": "Verschiedene Verortungs-Tags werden unwiderruflich zusammengeführt.",
      "location_tags_will_be_resetted": "Die Verortungstags werden beim Ändern des Verortungsplans zurückgesetzt!",
      "new_pin": "Neuer Pin",
      "new_pin_photo": "Neuer Pin (Foto)",
      "new_pin_photo_short": "Pin (Foto)",
      "new_pin_task": "Neuer Pin (Task)",
      "new_pin_task_short": "Pin (Task)",
      "no_location_layer": "Kein Verortungsplan",
      "no_location_layer_selected": "Kein Verortungsplan ausgewählt",
      "no_location_layers_available": "Noch keine Verortungspläne angelegt",
      "no_location_set": "Keine Verortung",
      "no_restriction": "Keine Einschränkung",
      "not_assigned_to_any_location_layer": "Keinem Verortungsplan zugewiesen",
      "open_in_location_layer": "in Verortungsplan öffnen",
      "open_location_layer": "Verortungsplan öffnen",
      "plan_selection": "Planauswahl",
      "save_location_layer_error": "Beim Löschen des Verortungsplans ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "select_location_layer": "Verortungsplan auswählen",
      "select_location_layer_x": "Verortungsplan „{title}“ auswählen",
      "selectable_on_location_edit": "Bei Verortung auswählbar",
      "show_location_plans": "Verortungspläne anzeigen",
      "status": "Status",
      "take_over_pins": "Pins übernehmen",
      "title_already_in_use": "Dieser Titel wird bereits in einem Verortungsplan verwendet.",
      "title_of_location_layer": "Titel des Verortungsplans",
      "transfer_pins_to_new_layer": "Vorhandene Pins auf neuen Verortungsplan übernehmen",
      "update_location_failed": "Verortung fehlgeschlagen",
      "upload_file": "Laden Sie eine Datei hoch.",
      "select_from_plans": "Pläne",
      "select_plan": "Plan auswählen",
      "versions": "Versionen",
      "version_tiling": "Wird verarbeitet…",
      "version_error": "Verarbeitung fehlgeschlagen",
      "new_version_available": "Neue Version verfügbar",
      "location_layer_version": "Version des Verortungsplans",
      "version_tiling_error": "Fehler bei der Verarbeitung der neuen Version.",
      "version_not_available_offline": "Diese Version ist offline nicht verfügbar.",
      "version_impact": "Beim Aktivieren wird die Verortung von {tasks} und {photos} auf die neue Version übernommen. Die Pins behalten dabei ihre Position.",
      "version_impact_prefix": "Beim Aktivieren wird die Verortung von",
      "version_impact_between_tasks_and_photos": " und ",
      "version_impact_suffix": "auf die neue Version übernommen. Die Pins behalten dabei ihre Position.",
      "version_impact_tasks_only": "Beim Aktivieren wird die Verortung von {tasks} auf die neue Version übernommen. Die Pins behalten dabei ihre Position.",
      "version_impact_photos_only": "Beim Aktivieren wird die Verortung von {photos} auf die neue Version übernommen. Die Pins behalten dabei ihre Position.",
      "version_impact_tasks_singular": "1 Task",
      "version_impact_tasks_plural": "{taskCount} Tasks",
      "version_impact_photos_singular": "1 Foto",
      "version_impact_photos_plural": "{photoCount} Fotos",
      "confirm_activate_version": "Version wirklich aktivieren?",
      "activate_version": "Version aktivieren",
      "activate_version_with_index": "Version {index} aktivieren",
      "activate_version_failed": "Version konnte nicht aktiviert werden. Bitte erneut versuchen.",
      "discard_version": "Version verwerfen",
      "discard_version_with_index": "Version {index} verwerfen",
      "discard_version_failed": "Version konnte nicht verworfen werden. Bitte erneut versuchen.",
      "confirm_discard_version": "Version wirklich verwerfen?",
      "review_version": "Prüfen & aktivieren …",
      "compare_versions": "Versionen vergleichen",
      "compare": "Vergleichen",
      "compare_version_label": "Version {index}",
      "view_version": "Version anzeigen",
      "new_version": "Neue Version",
      "edit_title": "Titel bearbeiten",
      "location_restrictions": "Verortungs-Einschränkungen"
    },
    "mailer": {
      "preview": {
        "open": "Vorschau",
        "title": "E-Mail-Vorschau",
        "loading": "Vorschau wird erstellt …",
        "error": "Die Vorschau konnte nicht erstellt werden. Bitte erneut versuchen.",
        "error_invalid_recipients": "Die Vorschau konnte nicht erstellt werden. Diese Beteiligten wurden deaktiviert:",
        "error_not_possible": "Die Vorschau ist für diese Eingaben nicht möglich:",
        "error_not_possible_unknown_reason": "Die Vorschau ist für diese Eingaben nicht möglich. Bitte Eingaben prüfen.",
        "error_participant_already_exists": "Die Vorschau ist nicht möglich: Dieser Beteiligte existiert im Projekt bereits.",
        "error_rate_limit": "Zu viele Vorschauen in kurzer Zeit. Bitte einen Moment warten und erneut versuchen.",
        "error_task_has_no_assignee": "Die Vorschau ist nicht möglich: Der Task hat keine Zuständigkeit.",
        "error_user_is_disabled": "Die Vorschau konnte nicht erstellt werden. Diese E-Mail-Adresse wurde deaktiviert:",
        "subject_label": "Betreff:",
        "links_inactive_hint": "Dies ist eine Vorschau, daher sind die Links hier nicht aktiv."
      },
      "a_and_b_for_you": "{a} und {b} für Sie",
      "a_and_b_sent_to": "{a} und {b} wurden erfolgreich versendet an:",
      "a_for_you": "{a} für Sie",
      "a_sent_to": "{a} wurde erfolgreich versendet an:",
      "add_recipients": "Empfänger hinzufügen",
      "add_to_shipment": "Zum Versand hinzufügen",
      "default_subject": "{projectTitle} - Versand:",
      "documents": {
        "add_items": "Dokumente hinzufügen",
        "add_one_item": "1 Dokument hinzufügen",
        "add_x_items": "{counter} Dokumente hinzufügen",
        "edit_selection": "Dokumentenauswahl ändern",
        "keep_selected_items_in_list": "Ausgewählte Dokumente bei Filteränderung behalten",
        "one_item": "1 Dokument",
        "x_items": "{counter} Dokumente"
      },
      "multiple_a_sent_to": "{a} wurden erfolgreich versendet an:",
      "plans": {
        "add_items": "Pläne hinzufügen",
        "add_one_item": "1 Plan hinzufügen",
        "add_x_items": "{counter} Pläne hinzufügen",
        "edit_selection": "Planauswahl ändern",
        "keep_selected_items_in_list": "Ausgewählte Pläne bei Filteränderung behalten",
        "one_item": "1 Plan",
        "restrict_access_to_print_file": "Zugriff auf DRUCK-DATEI beschränken",
        "restrict_access_to_print_files": "Zugriff auf DRUCK-DATEIEN beschränken",
        "x_items": "{counter} Pläne"
      },
      "resend_document": "Dokument erneut versenden",
      "resend_documents": "Dokumente erneut versenden",
      "resend_plan": "Plan erneut versenden",
      "resend_plans": "Pläne erneut versenden",
      "resend_plans_and_documents": "Pläne und Dokumente erneut versenden",
      "reset_selection": "Auswahl entfernen",
      "sent_to": "Erfolgreich versendet an:",
      "sent_to_one_participant": "1 Beteiligten",
      "sent_to_x_participants": "{count} Beteiligte",
      "status": {
        "plan_and_document_sent_to": "Ein Plan und ein Dokument versendet an:",
        "plan_and_documents_sent_to": "Ein Plan und mehrere Dokumente erfolgreich versendet an:",
        "plans_and_document_sent_to": "Mehrere Pläne und ein Dokument erfolgreich versendet an:",
        "plans_and_documents_sent_to": "Pläne und Dokumente erfolgreich versendet an:"
      },
      "step_1": "Pläne und/oder Dokumente auswählen",
      "step_2": "Empfänger auswählen",
      "step_3": "Betreff und Nachricht eingeben",
      "warnings": {
        "documents": {
          "or_items": "..oder Dokumente",
          "please_select_items": "Bitte wählen Sie Dokumente aus..."
        },
        "no_recipients": "Keine Empfänger ausgewählt",
        "plans": {
          "or_items": "..oder Pläne",
          "please_select_items": "Bitte wählen Sie Pläne aus..."
        }
      }
    },
    "mobile_app": {
      "breadcrumbs": {
        "detail": "Detail"
      },
      "documents": {
        "sorting": {
          "item_number": "Dokumentennummer"
        }
      },
      "help": {
        "desired_functionality": "Wunschfunktion",
        "error_description": "Fehlerbeschreibung",
        "our_developers_will_fix_the_error_soon": "Unsere Entwickler versuchen den Fehler schnellstmöglich zu beheben und kontaktieren Sie umgehend.",
        "our_support_team_will_help": "Unser Support-Team wird sich schnellstmöglich darum kümmern.",
        "question": "Frage",
        "thanks_for_your_message": "Vielen Dank für Ihre Nachricht!",
        "we_will_take_improvements_seriously": "Ihre Verbesserungsvorschläge sind ein wertvoller Bestandteil für die Weiterentwicklung von PLANFRED. Wir melden uns bei Ihnen, sobald Ihre Wunschfunktion integriert wurde."
      },
      "item": {
        "approval": {
          "approval_comment": "Anmerkung zur Prüfung",
          "correction_attachment": "Anhang"
        }
      },
      "no_internet_connection": "Keine Internetverbindung.",
      "no_internet_connection_content_may_be_outdated": "Inhalte möglicherweise nicht aktuell und unvollständig!",
      "plans": {
        "sorting": {
          "item_number": "Plannummer"
        }
      },
      "project": {
        "do_you_really_want_to_switch_project": "Möchten Sie wirklich in das Projekt \"{projectTitle}\" wechseln?",
        "switch_project": "Projekt wechseln?"
      },
      "register_to_use_app": "Um die PLANFRED-App nutzen zu können, benötigen Sie ein PLANFRED-Benutzerkonto.",
      "register_via_web_browser": "Sie können sich ganz einfach über Ihren Web-Browser dafür registrieren.",
      "troubleshooting": {
        "cache": "Cache",
        "clear_all_local_data": "Alle lokalen Daten löschen",
        "console": "Konsole",
        "content_will_be_resetted": "Inhalt wird auf die Standardwerte zurückgesetzt",
        "delete_all_local_data": "Alle lokalen Daten löschen?",
        "delete_storage_key": "Storage key {storageKey} löschen?",
        "device_storage_keys": "Gerätespeicher Keys",
        "enable_manual_upload_sync": "Manueller Upload Sync",
        "file_in_task_comment_of_task_got_edited": "Eine Datei im Task-Kommentar des Tasks {taskLink} wurde markiert.",
        "file_in_task_comment_of_unknown_task_got_annotated": "Eine Datei im Task-Kommentar eines unbekannten Tasks wurde markiert.",
        "file_in_task_got_edited": "Eine Datei im Task {taskLink} wurde markiert.",
        "file_in_unknown_task_got_edited": "Eine Datei in einem unbekannten Task wurde markiert.",
        "files_will_get_deleted_permanently": "Dateien werden unwiwderruflich gelöscht",
        "filesystem_files": "Filesystem Dateien",
        "location_layer_version_not_active_load_error": "Die aktuelle Version des Verortungsplans konnte nicht geladen werden.",
        "location_layer_version_not_active_photo": "Das Foto {photoLink} kann nicht hochgeladen werden, weil die offline verwendete Version des Verortungsplans nicht mehr aktiv ist.",
        "location_layer_version_not_active_preview": "Die Pins behalten ihre Koordinaten auf der aktuellen Planversion. Vergleichen Sie beide Karten, bevor Sie fortfahren.",
        "location_layer_version_not_active_task": "Der Task {taskLink} kann nicht hochgeladen werden, weil die offline verwendete Version des Verortungsplans nicht mehr aktiv ist.",
        "network": "Netzwerk",
        "network_sync_problem": "{itemType} wurde aufgrund von Problemen mit der Internetverbindung noch nicht synchronisiert. Die Synchronisierung wird zu einem späteren Zeitpunkt wiederholt.",
        "no_saved_files": "Keine Dateien gespeichert",
        "no_saved_keys": "Keine Keys gespeichert",
        "no_vuex_store_available": "Keine VUEX Stores verfügbar",
        "one_or_more_files_could_not_be_added": "Eine oder mehrere Dateien konnten nicht hinzugefügt werden.",
        "one_or_more_files_were_added_to_task": "Eine oder mehrere Dateien wurden zum Task {taskLink} hinzugefügt.",
        "one_or_more_files_were_added_to_task_comment_in_task": "Eine oder mehrere Dateien wurden zu einem Task-Kommentar im Task {taskLink} hinzugefügt.",
        "one_or_more_files_were_added_to_task_comment_of_unknown_task": "Eine oder mehrere Dateien wurde zu einem Task-Kommentar eines unbekannten Tasks hinzugefügt.",
        "one_or_more_files_were_added_to_unknown_task": "Eine oder mehrere Dateien wurden zu einem unbekannten Task hinzugefügt.",
        "only_files_on_the_device_will_be_deleted": "Nur auf dem Gerät befindliche Daten der PLANFRED-App werden gelöscht. Inklusive eventuell noch nicht hochgeladener Tasks. Daten am Server bleiben erhalten.",
        "photo_already_exists": "Das Foto {photoLink} existiert bereits und kann nicht erneut hochgeladen werden.",
        "photo_already_exists_with_different_file": "Das Foto {photoLink} existiert bereits, die Datei ist aber nicht identisch.",
        "photo_cannot_be_uploaded": "Das Foto {photoLink} kann nicht hochgeladen werden.",
        "photo_cannot_be_uploaded_invalid_location_values": "Das Foto {photoLink} kann nicht hochgeladen werden, weil die Verortung unvollständig oder ungültig ist. Öffnen Sie das Foto und korrigieren Sie die Verortung, um es hochzuladen.",
        "photo_got_annotated": "Das Foto {photoLink} wurde markiert.",
        "photo_is_not_available_on_the_server_and_cannot_get_updated": "Das Foto ist jedoch noch nicht auf dem Server vorhanden und kann daher nicht aktualisiert werden.",
        "remove_local_version": "Lokale Version verwerfen",
        "remove_local_version_description": "Die lokale Version wird verworfen und nicht mehr synchronisiert.",
        "reset_vuex_store": "VUEX store {storeName} zurücksetzen?",
        "retry_upload": "Erneut versuchen",
        "should_we_delete_the_files": "Sollen die Dateien wirklich gelöscht werden?",
        "show_files": "Dateien anzeigen",
        "show_logs": "Logs anzeigen",
        "simulate_bad_network": "Fehlerhafte Netzwerkverbindung simulieren",
        "storage_content_will_be_deleted": "Storage Inhalt wird unwiderruflich gelöscht",
        "task_already_exists": "Der Task {taskLink} existiert bereits und kann nicht erneut hochgeladen werden.",
        "task_already_exists_with_different_files": "Der Task {taskLink} existiert bereits, die Datei ist aber nicht identisch.",
        "task_cannot_be_uploaded": "Der Task {taskLink} konnte nicht hochgeladen werden.",
        "task_cannot_be_uploaded_invalid_location_values": "Der Task {taskLink} kann nicht hochgeladen werden, weil die Verortung unvollständig oder ungültig ist. Öffnen Sie den Task und korrigieren Sie die Verortung, um ihn hochzuladen.",
        "task_comment_where_file_got_added_is_not_available_anymore": "Der Task-Kommentar zu dem die Datei hinzugefügt wurde ist nicht mehr vorhanden und kann daher nicht aktualisiert werden.",
        "task_comment_where_file_got_edited_is_not_available": "Der Task-Kommentar in dem die Datei bearbeitet wurde ist nicht mehr vorhanden und kann daher nicht aktualisiert werden.",
        "task_is_not_available_on_server_and_cannot_be_updated": "Der Task ist jedoch noch nicht auf dem Server vorhanden und kann daher nicht aktualisiert werden.",
        "trigger_sync": "Trigger Upload Sync",
        "unknown_photo_got_edited": "Ein unbekanntes Foto wurde markiert.",
        "unknown_sync_problem": "Unbekanntes Problem. Bitte kontaktieren Sie unseren Support oder verwerfen Sie die lokale Version.",
        "use_current_location_layer_version": "Verortung aktualisieren",
        "vuex": "VUEX",
        "when_discarding_local_version_added_files_in_task_comment_will_be_lost": "Beim Verwerfen der lokalen Version werden die hinzugefügten Dateien im Task-Kommentar nicht hinzugefügt und die Änderungen somit verworfen.",
        "when_discarding_local_version_added_files_in_task_will_be_deleted": "Beim Verwerfen der lokalen Version werden die hinzugefügten Dateien zum Task nicht hinzugefügt und die Änderungen somit verworfen.",
        "when_discarding_local_version_data_may_get_lost": "Beim Verwerfen der lokalen Version gehen möglicherweise Daten verloren.",
        "when_discarding_local_version_edited_file_in_task_comment_will_be_lost": "Beim Verwerfen der lokalen Version wird die Datei im Task-Kommentar nicht ersetzt und die Änderungen somit verworfen.",
        "when_discarding_local_version_edits_may_get_lost": "Beim Verwerfen der lokalen Version können lokal gespeicherte Änderungen verloren gehen.",
        "when_discarding_local_version_file_gets_lost": "Beim Verwerfen der lokalen Version wird die Datei im Task nicht ersetzt und somit verworfen.",
        "when_discarding_local_version_nothing_gets_lost": "Beim Verwerfen der lokalen Version gehen keine Daten verloren.",
        "when_discarding_local_version_photo_will_be_lost": "Beim Verwerfen der lokalen Version wird das Foto nicht hochgeladen und somit verworfen.",
        "when_discarding_local_version_task_will_be_lost": "Beim Verwerfen der lokalen Version wird der Task nicht hochgeladen und somit verworfen.",
        "x_system_files": "{fileCounter} Systemdateien"
      },
      "update_app_to_continue": "Aktualisieren Sie die App, um fortzufahren.",
      "update_now": "Jetzt aktualisieren"
    },
    "notification_settings": {
      "could_not_load_notification_settings": "Der Benachrichtigungs-Einstellungen konnten nicht geladen werden. Möglicherweise ist der Link veraltet.",
      "due_date_report": {
        "approval_date": "E-Mail Prüffristen",
        "description": "Fällige Fristen bei Tasks sowie Plan- & Dokumentenprüfungen",
        "headline": "Erinnerung an Fristen",
        "reminder_on_due_dates": "Erinnerung an Fristen (täglich)"
      },
      "notification_settings": "Benachrichtigungs-Einstellungen",
      "plan_doc_report": {
        "description": "Von mir zu prüfende Pläne oder Dokumente; Änderungen zu Prüfungen; Statusänderungen",
        "headline": "Bericht – Plan- & Dokumentenprüfungen",
        "report_for_plan_and_document_reviews": "Bericht – Plan- & Dokumentenprüfungen (stündlich)"
      },
      "task_report": {
        "description": "Neue Tasks die mir zugewiesen sind; Änderungen bei mir zugewiesener Tasks; Statusänderungen und Rückfragen",
        "headline": "Bericht – Tasks",
        "report_for_tasks": "Bericht – Tasks (stündlich)"
      },
      "upload_alert": {
        "description": "Alle neu hochgeldadenen Pläne oder Dokumente",
        "headline": "Upload-Meldung – Pläne & Dokumente",
        "upload_alert_with_plans_and_documents": "Upload-Meldung – Pläne & Dokumente"
      },
      "week_start_report": {
        "description": "Pläne und Dokumente von mir zu prüfen; Tasks von mir (oder meiner Rolle) zu erledigen oder abzuklären",
        "headline": "Wöchentliche Erinnerung",
        "reminder_for_document_reviews": "Erinnerung bei unerledigten Dokumentenprüfungen (wöchentlich)",
        "reminder_for_plan_reviews": "Erinnerung bei unerledigten Planprüfungen (wöchentlich)",
        "reminder_for_tasks_to_be_done": "Erinnerung bei unerledigten Tasks (wöchentlich)",
        "will_be_sent_between_x_and_y": "Das E-Mail wird am Montag zwischen 0:00 und 6:00 Uhr verschickt"
      }
    },
    "participants": {
      "cannot_update_approval_of_participant": "Die Rolle dieses Beteiligten kann nicht geändert werden",
      "cannot_update_approval_of_participants": "Die Rollen von {filteredCount} von {totalCount} Beteiligten können nicht geändert werden",
      "cannot_update_participant": "Dieser Beteiligte kann nicht geändert werden",
      "cannot_update_participants": "{filteredCount} von {totalCount} Beteiligte können nicht geändert werden",
      "contact_details": {
        "add_optional_contact_data": "optionale Kontaktdaten hinzufügen",
        "change_optional_contact_data": "optionale Kontaktdaten ändern",
        "change_phone_and_address": "Telefonnummer/Adresse ändern",
        "company_label": "Firma:",
        "company_placeholder": "Firma",
        "company_validation_required": "Geben Sie eine Firma ein.",
        "email_label": "E-Mail:",
        "email_label_account": "E-Mail (Benutzerkonto):",
        "first_name_label": "Vorname:",
        "first_name_last_name_validation_required": "Geben Sie einen Namen ein.",
        "first_name_placeholder": "Vorname",
        "first_name_validation_required": "Geben Sie einen Vornamen ein.",
        "label_address_optional": "Adresse:",
        "label_city": "Ort/Stadt:",
        "label_country": "Land:",
        "label_street": "Straße:",
        "label_zip": "PLZ:",
        "last_name_label": "Nachname:",
        "last_name_placeholder": "Nachname",
        "last_name_validation_required": "Geben Sie einen Nachnamen ein.",
        "note_label": "Notiz:",
        "optional_contact_data": "Optionale Kontaktdaten",
        "role_label": "Rolle:",
        "select_country": "Land auswählen…",
        "telephone_label": "Telefon:",
        "telephone_placeholder": "Telefonnummer"
      },
      "context_menu": {
        "contact": "Kontakt",
        "disable_participant": "Beteiligten löschen",
        "edit_contact_data": "Kontaktdaten",
        "edit_email_notification_settings": "E-Mail Melder",
        "edit_permission": "Berechtigung",
        "edit_role": "Rolle",
        "enable_participant": "Beteiligten wiederherstellen",
        "export_contact": "Kontakt exportieren",
        "grant_approval_permission": "Plan-Prüfberechtigung erteilen",
        "revoke_approval_permission": "Plan-Prüfberechtigung entziehen",
        "upload_alert_headline": "Uploadmelder"
      },
      "delete_one_participant": "1 Beteiligten löschen",
      "delete_x_participants": "{counter} Beteiligte löschen",
      "detail": {
        "activities_link": "Aktivitäten dieses Beteiligten anzeigen",
        "activities_of_external_participant": "Aktivitäten dieses externen Beteiligten",
        "activities_of_participant": "Aktivitäten dieses Beteiligten",
        "address": "Adresse:",
        "company": "Firma:",
        "edit": {
          "email_notifications_header": "E-Mail Melder für dieses Projekt",
          "error_save_contact_data": "Beim Speichern ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
          "unauthorized_to_edit_hint": "Sie sind nicht berechtigt andere Benachrichtigungseinstellungen zu ändern."
        },
        "edit_address": "Adresse ändern",
        "edit_address_server_error": "Beim speichern der Adresse ist ein Fehler aufgetreten.",
        "edit_company": "Firma ändern",
        "edit_company_server_error": "Beim Speichern der Firma ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "edit_name": "Name ändern",
        "edit_name_server_error": "Beim Speichern des Namens ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "edit_permission_server_error": "Beim Speichern der Berechtigungen ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "edit_phone_address_server_error": "Beim speichern ist ein Fehler aufgetreten - versuchen Sie es erneut.",
        "edit_telephone": "Telefonnummer ändern",
        "edit_telephone_server_error": "Beim Speichern der Telefonnummer ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "email": "E-Mail:",
        "got_added_by_unknown": "Wurde zum Projekt hinzugefügt",
        "got_added_to_project_by": "Wurde zum Projekt hinzugefügt von {userName}",
        "got_added_via_mail_by": "Per Versand hinzugefügt von {userName}",
        "got_invited_by_unknown": "Projekteinladung erhalten",
        "has_created_project": "{userName} hat dieses Projekt erstellt",
        "has_no_project_access": "KEIN Login",
        "has_project_access": "hat Projektzugang",
        "insert_address": "Adresse eingeben",
        "insert_company": "Firma eingeben",
        "insert_name": "Name eingeben",
        "insert_telephone": "Telefonnummer eingeben",
        "invite_and_back_to_list": "einladen & zurück zur Liste",
        "invitation_email_bounced": "Die Projekt-Einladungs-E-Mail wurde vom Server des Empfängers abgewiesen.",
        "invitation_email_delivered": "Projekt-Einladungs-E-Mail erfolgreich zugestellt.",
        "invitation_email_processing": "Projekt-Einladungs-E-Mail unterwegs - die Zustellbestätigung kann einige Zeit dauern.",
        "invitation_email_send_failed": "Der Versand der Projekt-Einladungs-E-Mail ist fehlgeschlagen.",
        "invitation_email_unknown": "Für die Projekt-Einladungs-E-Mail liegt keine Zustellbestätigung vor. Ob sie zugestellt wurde, ist unbekannt.",
        "last_planfred_login": "Letzter PLANFRED-Login:",
        "last_project_login": "Letzter Projekt-Login:",
        "login_data": "Login-Informationen:",
        "name": "Name:",
        "never_logged_in_into_planfred": "Noch nie in PLANFRED eingeloggt.",
        "never_logged_in_into_project": "Noch nie in diesem Projekt eingeloggt.",
        "new_invitation_got_sent": "Eine neue Projekt-Einladung wurde erfolgreich an „{email}“ gesendet.",
        "new_invitation_got_sent_server_error": "Beim Versand der Projekt-Einladung ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "not_authorized_to_edit_owner": "Sie sind nicht berechtigt den Projekteigentümer zu editieren.",
        "not_authorized_to_edit_participant": "Sie sind nicht berechtigt andere Beteiligte zu editieren.",
        "note": "Notiz:",
        "participant_activities_message_box": "Die Aktivitätenseite wurde überarbeitet!",
        "phone": "Telefon:",
        "project_access": "Projektzugang:",
        "project_access_got_granted_by": "Projektzugang wurde erteilt von {userName}",
        "project_access_got_revoked_by": "Projektzugang wurde entzogen von {userName}",
        "project_invitation_from": "Projekteinladung von {userName}",
        "reinvite_participant": "Beteiligten erneut einladen",
        "save_and_back_to_list": "speichern & zurück zur Liste",
        "save_and_invite": "speichern & zum Projekt einladen"
      },
      "edit": {
        "back_to_list": "zurück zur Beteiligtenliste",
        "can_approve_revisions": {
          "heading": "Plan-Prüfberechtigung Einstellungen der ausgewählten Beteiligten",
          "heading_prop_editor_pl": "Plan-Prüfberechtigungng der ausgewählten Beteiligten auf folgende Einstellung ändern:",
          "heading_prop_editor_sg": "Plan-Prüfberechtigung des ausgewählten Beteiligten auf folgende Einstellung ändern:",
          "off": "Plan-Prüfberechtigung entzogen",
          "on": "Plan-Prüfberechtigung erteilt",
          "save_error_can_approve_revisions_error": "Beim Speichern der Plan-Prüfberechtigung Einstellungen ist ein Fehler aufgetreten.",
          "title": "Plan-Prüfberechtigung"
        },
        "contact_details": "Kontaktdaten:",
        "delete_participant": "Beteiligten löschen",
        "disable_participant_info": "Um diesen Beteiligten zu deaktivieren/sperren klicken Sie auf den untenstehenden roten Button „Beteiligten löschen“.",
        "edit_contact_data": "Kontaktdaten ändern",
        "edit_participant": "Beteiligten bearbeiten",
        "edit_participant_role": "Beteiligten-Rolle bearbeiten",
        "email_already_invited_to_project": "Diese E-Mail-Adresse ist im Projekt bereits vorhanden – überprüfen Sie auch den Papierkorb.",
        "email_cannot_be_changed": "Die E-Mail-Adresse kann nachträglich nicht geändert werden.",
        "email_does_not_exist": "Diese E-Mail-Adresse existiert nicht. Prüfen Sie auf eventuelle Tippfehler.",
        "email_not_deliverable": "Bei dieser E-Mail-Adresse gibt es Probleme mit der Zustellbarkeit. Kontrollieren sie die korrekte Schreibweise oder kontaktieren Sie unseren Support.",
        "email_notifier": "E-Mail Melder",
        "email_notifier_myself": "Mein E-Mail Melder",
        "email_placeholder": "E-Mail-Adresse",
        "error_email_is_invalid": "Diese E-Mail-Adresse ist nicht erreichbar – kontaktieren Sie den E-Mail-Verwalter.",
        "error_general": "Es ist ein Fehler aufgetreten. Der Beteiligte konnte nicht eingeladen werden.",
        "error_participant_already_exists": "Dieser Beteiligte existiert bereits.",
        "error_select_or_add_role": "Wählen Sie eine Rolle aus oder fügen Sie eine neue passende Rolle hinzu.",
        "import_participant_from_other_project": "Beteiligten aus Projekt importieren",
        "invite": "zum Projekt einladen",
        "invite_and_create_new": "einladen + weiteren Beteiligten anlegen",
        "label_email_can_not_be_changed": "E-Mail kann nicht geändert werden!",
        "modal": {
          "permission": {
            "header": "Berechtigung ändern"
          },
          "role": {
            "header": "Rolle ändern"
          }
        },
        "permission": {
          "admin_feature_access_to_settings": "Zugriff auf Einstellungen und Backup-Funktion",
          "admin_feature_edit_all_project_data": "Bearbeiten der Projektstruktur und aller Projektdaten",
          "admin_feature_insight_to_project_data": "Einblick in alle Projektdaten",
          "admin_feature_login_for_project": "Login für dieses Projekt",
          "admin_feature_participant_management": "Beteiligten-Management (Einladen, Berechtigungen, Deaktivieren)",
          "admin_feature_short_description": "Hat Zugriff auf alle Daten und Einstellungen",
          "cant_activate_participant_with_invalid_email": "Die E-Mail-Adresse dieses Beteiligten ist nicht valide und kann somit nicht aktiviert werden – kontaktieren Sie unseren Support!",
          "changing_plan_approval_permission_is_unauthorized_hint": "Sie dürfen keine Plan-Prüfberechtigung ändern.",
          "disabled_participant_has_no_project_access": "Der Beteiligte hat auf dieses Projekt KEINEN Zugriff!",
          "edit_permission": "Berechtigung ändern",
          "error_validation": "Vervollständigen Sie die Daten des Beteiligten, bevor Sie die Berechtigung ändern.",
          "notifications": "Benachrichtigungen",
          "owner_feature_create_or_delete_projects": "Weitere Projekte anlegen oder bestehende löschen",
          "owner_feature_legal_owner": "Rechtlicher Besitzer des Projekts",
          "participant_disabled": "deaktiviert",
          "participant_enabled": "aktiviert",
          "participant_feature_insight_to_project_data": "Einblick in alle Projektdaten außer Dokumente mit Zugriffsberechtigung und Tasks anderer Rollen",
          "participant_feature_login_for_project": "Login für dieses Projekt",
          "participant_feature_short_description": "Kann Pläne und Dokumente hochladen",
          "participant_feature_upload_and_edit_in_assigned_role": "Hochladen und Bearbeiten nur in der zugewiesenen Rolle",
          "participant_only_allowed_to_invite_silent_participants": "Sie dürfen nur Beteiligte ohne Login einladen.",
          "plan_approval_permission": "Plan-Prüfberechtigung",
          "plan_approval_permission_revoked": "Plan-Prüfberechtigung wurde entzogen.",
          "revoking_plan_approval_permission_affects_future_approvals": "Entzug der Plan-Prüfberechtigung betrifft nur zukünftige Prüfungen.",
          "silent_feature_no_login": "KEIN Zugang zu diesem Projekt",
          "silent_feature_receive_download_links": "Erhalt von Daten via Downloadlink per E-Mail-Versand",
          "silent_feature_short_description": "Kein Zugang. Erhalt von Daten via E-Mail",
          "time_in_timezone": "({time} in Projektzeitzone {timezone})",
          "title_permission": "Berechtigung",
          "upload_alert": "Upload-Melder für Pläne & Dokumente",
          "upload_alert_will_be_sent_at": "Das E-Mail wird täglich um {time} versendet.",
          "you_want_to_transfer_ownership": "Sie möchten den Projektbesitz auf einen anderen Beteiligten übertragen? Gehen Sie zu {link}"
        },
        "personal_message_to_new_participant": "Persönliche Nachricht:",
        "previous_participant_invited": "Projekteinladung an „{email}“ gesendet.",
        "previous_participant_without_login_invited": "„{email}“ wurde als Beteiligter ohne Login hinzugefügt.",
        "restore_participant": "wiederherstellen",
        "role_details": "Rolle:",
        "save_and_create_new": "speichern + weiteren Beteiligten anlegen",
        "show_participant": "Beteiligten anzeigen",
        "upload_alert": {
          "daily": "Täglich",
          "heading": "Upload-Melder Einstellungen der ausgewählten Beteiligten",
          "heading_prop_editor_pl": "Upload-Melder der ausgewählten Beteiligten auf folgende Einstellung ändern:",
          "heading_prop_editor_sg": "Upload-Melder des ausgewählten Beteiligten auf folgende Einstellung ändern:",
          "hourly": "Stündlich",
          "off": "Aus",
          "save_error_upload_alert_error": "Beim Speichern der Upload-Melder Einstellungen ist ein Fehler aufgetreten.",
          "title": "Upload-Melder - Plan & Dokumente"
        }
      },
      "export_contact": {
        "address_city": "Ort/Stadt:",
        "address_street": "Straße:",
        "address_zip": "PLZ:",
        "company": "Firma:",
        "email": "E-Mail:",
        "export_contact": "Kontakt exportieren",
        "export_contact_to_phone": "Kontakt am Gerät anlegen",
        "export_contact_to_phone_short": "Am Gerät anlegen",
        "export_contact_via_qr_code": "QR Code anzeigen",
        "export_contact_via_qr_code_short": "QR Code",
        "name": "Name:",
        "note": "Notiz:",
        "phone": "Telefon:",
        "scan_with_smartphone": "QR-Code mit Smartphone scannen",
        "vcf_export": "VCF-Export"
      },
      "filter_categories": {
        "access_permission": "Zugriffsberechtigung",
        "roles": "Rollen"
      },
      "keep_selected_participants_in_list": "Ausgewählte Beteiligte bei Filteränderung behalten",
      "list": {
        "add_first_participant": "Klicken Sie auf „Neuer Beteiligter“ um den ersten Beteiligten zu Ihrem Projekt hinzuzufügen.",
        "city": "Ort/Stadt:",
        "country": "Land:",
        "create_new_participant": "Neuer Beteiligter",
        "do_you_need_help_to_create_participant": "Sie brauchen Hilfe beim Beteiligten anlegen?",
        "headline_deleted_participants": "Papierkorb – gelöschte Beteiligte",
        "its_me": "Ich",
        "not_authorized_to_create_participant": "Sie sind nicht berechtigt neue Beteiligte einzuladen!",
        "permission": "Berechtigung",
        "server_error_can_approve_revisions": "Die Plan-Prüfberechtigung konnte nicht gespeichert werden – versuchen Sie es erneut.",
        "server_error_enabled": "Der Beteiligte konnte nicht gelöscht/wiederhergestellt werden – versuchen Sie es erneut.",
        "server_error_invitation_email_does_not_exist": "Die Einladung konnte nicht versendet werden. Die E-Mail-Adresse existiert nicht.",
        "server_error_upload_alert_status": "Der Upload-Melder Status des Beteiligten konnte nicht gespeichert werden – versuchen Sie es erneut.",
        "street": "Straße:",
        "trash_icon_label": "Gelöschte Beteiligte",
        "without_role": "Ohne Rolle",
        "zip": "PLZ:"
      },
      "modus": {
        "print": {
          "additional_infos": "Zusatzinformationen:",
          "export_list": "Exportieren der Beteiligtenliste",
          "filter_none": "Alle Beteiligten",
          "filter_permissions": "Zugriffsberechtigungen: {permissions}",
          "filter_roles": "Rollen: {roles}",
          "filter_text_search": "Textsuche: {searchString}",
          "filtering": "Filterung:",
          "group_by": "Gruppieren nach:",
          "group_by_none": "Keine",
          "group_by_permissions": "Berechtigungen",
          "group_by_roles": "Rollen",
          "participants_count": "Anzahl:",
          "participants_list": "Beteiligte",
          "print_list": "Drucken der gefilterten Beteiligtenliste",
          "project": "Projekt:",
          "state": "Stand:"
        },
        "trash": {
          "close_recycling_bin": "Papierkorb schließen"
        }
      },
      "one_item": "1 Beteiligter",
      "only_added_participants_of_your_role": "You can only edit participants for which you or your role {role} is the participant creator.",
      "overlay": {
        "all_participants_imported": "Es sind bereits alle Beteiligten aus diesem Projekt in Ihrem Projekt eingeladen.",
        "all_participants_imported_from_all_projects": "Es sind bereits alle Beteiligten in Ihrem Projekt eingeladen.",
        "all_plans_or_docs_imported": "Es sind bereits alle Pläne oder Dokumente aus diesem Projekt in Ihrem Projekt importiert.",
        "choose_a_participant": "Wählen Sie einen Beteiligten aus"
      },
      "participant_group_import": {
        "accept": "Beibehalten",
        "adjust_permissions": "Berechtigungen anpassen",
        "admins_become_project_participants": "Admins werden Projekt-Beteiligte",
        "admins_plural": "{counter} Administratoren",
        "admins_singular": "{counter} Administrator",
        "all_off": "Bei allen AUS",
        "all_on_daily": "Bei allen TÄGLICH",
        "all_participants_of_project_imported": "Bereits alle Beteiligten importiert",
        "approval_keep_settings": "Plan-Prüfberechtigung beibehalten",
        "approval_permission": "Plan-Prüfberechtigung",
        "close_window": "Fenster schließen",
        "deactivate": "Deaktivieren",
        "import_admins_as_participants": "Admininstratoren als Beteiligte importieren",
        "import_all_as_silent": "Alle als Beteiligte ohne Login importieren",
        "import_another_group": "Weitere Beteiligte importieren",
        "import_as_silent_info_box_text_1": "Mit dieser Einstellung werden alle ausgewählten Beteiligten als 'Beteiligte ohne Login' ins neue Projekt importiert.",
        "import_as_silent_info_box_text_2": "Dabei werden keine Einladungen per E-Mail verschickt!",
        "import_as_silent_participant": "Ohne Login importieren",
        "import_as_silent_submit_button_text": "Beteiligte ohne Login importieren",
        "import_participants": "{participantsCounter} Beteiligte importieren",
        "import_participants_from_another_project": "Beteiligte importieren",
        "import_participants_from_VCF_file": ".vcf importieren",
        "import_participants_report": "Import-Vorgang abgeschlossen",
        "import_participants_silent": "{participantsCounter} Beteiligte ohne Login importieren",
        "import_participants_single": "{participantsCounter} Beteiligten importieren",
        "import_participants_single_silent": "{participantsCounter} Beteiligten ohne Login importieren",
        "info_message_no_more_options_1": "ACHTUNG: Sie importieren alle Beteiligte als ‘Beteiligte ohne Login’!",
        "info_message_no_more_options_2": "Die importierten Beteiligten haben somit keinen Projektzugriff.",
        "info_message_no_more_options_3": "Upload-Melder und Plan-Prüfberechtigung werden deaktiviert.",
        "info_message_no_more_options_4": "Die importierten Beteiligten erhalten keine Einladungs-E-Mail.",
        "keep_settings": "Zugriffs-Berechtigung beibehalten",
        "message": "Nachricht",
        "next_step": "Weiter",
        "no_admins": "Keine Administratoren",
        "no_participants": "Keine Beteiligten",
        "no_silent": "Keine Beteiligten ohne Login",
        "participant_group_import": "Mehrere Beteiligte importieren",
        "participant_is_imported": "{counter} Beteiligter wird importiert …",
        "participant_selected": "{participantsCounter} Beteiligter selektiert",
        "participants_are_imported": "{counter} Beteiligte werden importiert …",
        "participants_plural": "{counter} Beteiligte",
        "participants_selected": "{participantsCounter} Beteiligte selektiert",
        "participants_singular": "{counter} Beteiligter",
        "permissions_in_target_project": "Berechtigungen im Zielobjekt:",
        "plan_approval_permission": "{counter} Plan-Prüfberechtigung",
        "plan_approval_permissions": "{counter} Plan-Prüfberechtigungen",
        "project_selection": "Projektauswahl",
        "result_list_header": "Liste der importierten Beteiligten:",
        "select_a_project": "Wählen Sie zuerst ein Projekt aus",
        "select_one_or_more_participants": "Wählen Sie einen oder mehrere Beteiligte aus",
        "silent_participants_no_invitation_email_info_box_text": "Beteiligte ohne Login erhalten keine Einlagung per E-Mail",
        "silent_plural": "{counter} Beteiligte ohne Login",
        "silent_singular": "{counter} Beteiligter ohne Login",
        "upload_notifier": "Upload-Melder",
        "upload_notifier_off": "{counter} Upload-Melder aus",
        "upload_notifier_on": "{counter} Upload-Melder an"
      },
      "participant_import": {
        "drop_vcf_infoscreen_headline": "Beteiligten aus .vcf-Datei importieren",
        "import_participant_button": "Beteiligten importieren aus …",
        "import_participant_from_device": "Kontakten",
        "import_participant_from_project": "anderem Projekt",
        "import_participant_from_vcf": ".vcf Datei"
      },
      "participant_import_from_device": {
        "permission_hint": "Die Berechtigung „Kontakte“ ist erforderlich, um einen Kontakt auszuwählen.",
        "permission_how_to_grant_app_access": "Sie haben diese Berechtigung zuvor verweigert. Bitte öffnen Sie die App-Einstellungen Ihres Geräts und aktivieren Sie den Zugriff auf Kontakte für diese App."
      },
      "participant_selector": {
        "external_participant_assign_role": "Nur Rolle",
        "external_participant_needs_role": "'Beteiligter ohne Login' als Verfasser benötigt eine Rolle.",
        "external_participant_no_role_assigned": "Noch keine Rolle zugewiesen",
        "external_participants": "Beteiligte ohne Login + Rolle",
        "new_external_first_name": "Vorname",
        "new_external_last_name": "Nachname",
        "new_external_mail": "E-Mail-Adresse",
        "new_external_role_empty": "Keine Rolle",
        "participants": "Beteiligte mit Login + Rolle",
        "search_label": "Suche Beteiligte nach Name, E-Mail oder Rolle",
        "select_external_without_role": "'Beteiligte ohne Login' ohne Rolle auswählen",
        "without_name": "Ohne Name",
        "without_role": "keine Rolle"
      },
      "permission_labels": {
        "owner": "Eigentümer",
        "admin": "Admin",
        "participant": "Teilnehmer",
        "silent": "Kein Login"
      },
      "permission_states": {
        "admin": "Projekt-Administrator",
        "admins": "Projekt-Administratoren",
        "owner": "Projekteigentümer",
        "participant": "Projekt-Beteiligter",
        "participants": "Projekt-Beteiligte",
        "silent": "Beteiligter ohne Login",
        "silents": "Beteiligte ohne Login"
      },
      "property_edit_revision_messages": {
        "admin_must_not_edit_his_own_permission": "Sie als Administrator dürfen Ihre eigene Berechtigung nicht ändern.",
        "owner_must_not_be_disabled": "Der Projekt-Eigentümer darf nicht gelöscht werden.",
        "owner_permission_must_not_be_changed": "Die Berechtigung des Projekt-Eigentümers darf nicht geändert werden.",
        "owners_role_must_not_be_changed": "Sie dürfen die Rolle des Projekt-Eigentümers nicht ändern.",
        "participant_must_not_disable_himself": "Sie dürfen Ihren eigenen Beteiligten-Account nicht löschen.",
        "silent_participant_missing_mandatory_fields": "Bitte füllen Sie zuerst die Pflichtfelder für den Beteiligten ohne Login aus."
      },
      "property_editor_header_participant": "Rolle des Beteiligten auf folgende Rolle ändern:",
      "property_editor_header_participant_permission": "Berechtigung des Beteiligten ändern:",
      "property_editor_header_participants": "Rolle der Beteiligten auf folgende Rolle ändern:",
      "property_editor_header_participants_permission": "Berechtigung der Beteiligten ändern:",
      "property_preview_header_participant_delete": "Beteiligten in Papierkorb verschieben",
      "property_preview_header_participants_delete": "Beteiligte in Papierkorb verschieben",
      "property_preview_header_permission": "Berechtigung der ausgewählten Beteiligten:",
      "property_preview_header_roles": "Rollen der ausgewählten Beteiligten:",
      "save_edit_permission_error": "Das Ändern der Berechtigung ist fehlgeschlagen.",
      "save_edit_role_error": "Das Ändern der Rolle ist fehlgeschlagen.",
      "save_participant_error_message": "Beim Speichern des Beteiligten ist ein Fehler aufgetreten.",
      "update_one_participant": "1 Beteiligten ändern",
      "update_x_participants": "{counter} Beteiligte ändern",
      "upload_notifier": {
        "options": {
          "daily": "Täglich",
          "hourly": "Stündlich",
          "off": "Aus",
          "on": "An",
          "select": "Auswählen"
        }
      },
      "week_start_report": {
        "options": {
          "off": "Aus",
          "on": "Ein"
        }
      },
      "x_items": "{counter} Beteiligte"
    },
    "photo": {
      "1_photo_captured": "1 Foto aufgenommen",
      "1_photo_selected": "1 Foto ausgewählt",
      "all_photos": "Alle Fotos",
      "annotate_image": "Bild markieren",
      "author_of_selected_photo": "Verfasser des ausgewählten Fotos:",
      "author_of_selected_photos": "Verfasser der ausgewählten Fotos:",
      "capture_date": "Aufnahmedatum",
      "click_on_link_to_create_photo": "Klicken Sie auf „Foto hochladen“ um ein Foto zu erstellen.",
      "context_menu": {
        "delete": "Löschen",
        "go_to_detail": "Detailansicht (mit Aktivitäten)",
        "note": "Notiz",
        "photo_album": "Album",
        "photo_author": "Verfasser",
        "restore": "Wiederherstellen",
        "share": "Teilen",
        "title": "Titel",
        "use_as_template": "Als Vorlage"
      },
      "create_new_photo": "Neues Foto erstellen",
      "delete_1_photo": "1 Foto löschen",
      "delete_photo": "Foto löschen",
      "delete_photo_question": "Foto löschen?",
      "delete_x_photos": "{x} Fotos löschen",
      "deleted_photos": "Gelöschte Fotos",
      "detail": {
        "save_title_server_error": "Beim Speichern des Titels ist ein Fehler aufgetreten – versuchen Sie es erneut."
      },
      "download": {
        "resolution": "Auflösung",
        "resolution_labels": {
          "large": "Full HD (1920 px)",
          "medium": "Kompakt (1280 px)",
          "original": "Original"
        }
      },
      "download_as": "Foto herunterladen als …",
      "download_photo": "Foto herunterladen",
      "duplicate_photo": "Foto duplizieren",
      "edit_album_of_selected_photo": "Fotoalbum des ausgewählten Fotos ändern:",
      "edit_album_of_selected_photos": "Fotoalbum der ausgewählten Fotos ändern:",
      "edit_author": "Fotoverfasser ändern",
      "edit_author_of_selected_photo": "Verfasser des ausgewählten Fotos ändern:",
      "edit_author_of_selected_photos": "Verfasser der ausgewählten Fotos ändern:",
      "edit_note": "Notiz ändern",
      "edit_photo": "Foto bearbeiten",
      "edit_photo_album": "Fotoalbum ändern",
      "edit_photo_title": "Titel ändern",
      "edit_tags_of_selected_photo": "Tags des ausgewählten Fotos ändern:",
      "edit_tags_of_selected_photos": "Tags der ausgewählten Fotos ändern:",
      "edit_location_of_selected_photo": "Verortung des ausgewählten Fotos ändern auf:",
      "edit_location_of_selected_photos": "Verortung der ausgewählten Fotos ändern auf:",
      "mixed_location_layers_warning": "Die ausgewählten Fotos befinden sich auf unterschiedlichen Verortungsplänen. Sie können alle ausgewählten Fotos auf einem gemeinsamen Verortungsplan zusammenführen.",
      "current_location_of_selected_photo": "Aktuelle Verortung des ausgewählten Fotos:",
      "current_locations_of_selected_photos": "Aktuelle Verortungen der ausgewählten Fotos:",
      "server_error_save_photo_location": "Beim Speichern der Foto-Verortung ist ein Fehler aufgetreten.",
      "filter_capture_date": "Filter „Aufnahmedatum“",
      "further_properties": "Weitere Eigenschaften",
      "group_by_album": "Gruppierung nach Fotoalbum",
      "group_by_location_layer": "Gruppierung nach Verortungsplan",
      "group_by_none": "Keine",
      "not_assigned_to_any_album": "Keinem Fotoalbum zugewiesen",
      "hide_1_selected_photo": "1 ausgewähltes Foto ausblenden",
      "hide_x_selected_photos": "{x} ausgewählte Fotos ausblenden",
      "keep_selected_items_in_list": "Ausgewählte Fotos bei Filteränderung behalten",
      "list": {
        "modus": {
          "print": {
            "as_of": "Stand:",
            "create_print_job_error": "Fehler beim Erstellen des Druckauftrags.",
            "description": "Beschreibung:",
            "file_name": "Dateiname:",
            "generate_pdf": "PDF generieren",
            "grouping": "Gruppierung:",
            "image_quality": "Bildqualität",
            "image_quality_high": "Hoch",
            "image_quality_low": "Niedrig",
            "image_quality_medium": "Mittel",
            "last_modified": "zuletzt geändert",
            "loading_error": "Es ist ein Fehler beim Laden aufgetreten",
            "location": "Verortung:",
            "max_one_photo_per_page": "Max. 1 Foto pro Seite",
            "no_photos_to_print": "Keine Fotos zum Drucken gefunden.",
            "none": "keine",
            "number_and_title": "Nr. + Titel:",
            "overlay_print_is_being_prepared": "Ihr Fotolistenausdruck wird vorbereitet … {renderedItemsLength} von {allItemsLength}",
            "pdf_generation_limit_exceeded": "Es können maximal {maxPhotos} Fotos als PDF generiert werden. Bitte reduziere deine Auswahl. Das Drucken über den Browser ist weiterhin möglich.",
            "pdf_generation_pending": "Das Generieren kann einige Minuten dauern …",
            "photo_print_settings": "Druckeinstellungen Fotos ({count})",
            "photos_count": "Fotos:",
            "preview_load_error": "Die Druckvorschau konnte nicht geladen werden. Du kannst das PDF trotzdem herunterladen.",
            "preview_title": "Foto-Druckvorschau",
            "print_menu_button": "Druckmenü",
            "print_photos": "Fotos drucken",
            "print_preview_button": "Druckvorschau",
            "selection": "Auswahl",
            "share_pdf": "PDF herunterladen",
            "tags": "Tags:"
          }
        },
        "no_photos_available": "Keine Fotos vorhanden"
      },
      "maybe_photo_got_trashed_or_is_not_available": "Möglicherweise wurde das Foto gelöscht oder ist nicht mehr verfügbar.",
      "move_selected_photo_into_trash": "Ausgewähltes Foto in Papierkorb verschieben",
      "move_selected_photos_into_trash": "Ausgewählte Fotos in Papierkorb verschieben",
      "multiple_photo_albums_will_be_merged": "Mehrere Fotoalben werden unwiderruflich zusammengeführt.",
      "new_photo": "Neues Foto",
      "new_photos": "Neue Fotos",
      "add_photos": "Fotos hinzufügen",
      "new_photo_album": "Neues Fotoalbum",
      "no_note_available": "Keine Notiz verfügbar",
      "no_photo_create_a_new_photo": "Sie können jedoch ein neues Foto anlegen.",
      "no_photos_in_this_view_available": "In dieser Ansicht sind keine Fotos verfügbar.",
      "no_photos_to_edit": "Es gibt aktuell keine Fotos in Ihrer Rolle {role} {link}",
      "only_added_photos_of_your_role": "Sie können nur Fotos aktualisieren bei denen Sie oder Ihre Rolle {role} Verfasser des Fotos ist.",
      "open_photo": "Foto öffnen",
      "photo_activities": "Foto Aktivitäten",
      "photo_album_of_selected_photo": "Fotoalbum des ausgewählten Fotos:",
      "photo_albums": "Fotoalben",
      "photo_albums_of_selected_photos": "Fotoalben der ausgewählten Fotos:",
      "photo_author": "Verfasser",
      "photo_authors": "Rollen / Fotoverfasser",
      "photo_can_be_selected_after_upload": "Foto kann ausgewählt werden, sobald der Upload abgeschlossen ist.",
      "photo_getting_uploaded": "Foto wird gerade hochgeladen",
      "photo_not_available": "Foto nicht verfügbar",
      "photo_not_uploaded_yet": "Foto wurde noch nicht hochgeladen.",
      "photo_size": "Foto Größe",
      "photo_tag": "Foto-Tag",
      "photo_title_placeholder": "Foto Titel",
      "photo_will_be_moved_to_trash": "Foto wird in den Papierkorb verschoben",
      "photo_will_be_permanently_deleted": "Foto wird unwiederruflich gelöscht",
      "photos_count": "Fotoanzahl",
      "processing_photo": "Foto wird verarbeitet …",
      "restore_photo": "Foto wiederherstellen",
      "save_and_add_another_photo": "speichern + weiteres Foto hinzufügen",
      "save_photo": "Foto speichern",
      "save_title_server_error": "Beim Speichern des Titels ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "save_x_photos": "{x} Fotos speichern",
      "select_photos": "Fotos auswählen ...",
      "selected_photo_has_no_tags_assigned": "Dem ausgewählten Foto sind keine Tags zugeordnet",
      "selected_photos_have_no_tags_assigned": "Den ausgewählten Fotos sind keine Tags zugewiesen",
      "server_error_lost_access_to_photo": "Bitte laden Sie die Seite neu. Sie haben keinen Zugriff mehr auf dieses Foto.",
      "server_error_photo_currently_uploading": "Das Foto wird gerade hochgeladen – versuchen Sie es später erneut.",
      "server_error_photo_delete": "Das Foto konnte nicht gelöscht werden – versuchen Sie es erneut.",
      "server_error_photo_restore": "Das Foto konnte nicht wiederhergestellt werden – versuchen Sie es erneut.",
      "server_error_save_note": "Beim Speichern der Notiz ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "server_error_save_photo": "Beim Speichern des Fotos ist ein Fehler aufgetreten. Versuchen Sie es erneut.",
      "server_error_save_photo_album": "Beim Speichern des Fotoalbums ist ein Fehler aufgetreten.",
      "show_1_selected_photo": "1 ausgewähltes Foto anzeigen",
      "show_details": "Details anzeigen",
      "show_photo_infos": "Detailansicht (mit Aktivitäten)",
      "show_x_selected_photos": "{x} ausgewählte Fotos anzeigen",
      "sort_by": "Sortiere nach",
      "tags_of_selected_photo": "Tags des ausgewählten Fotos:",
      "tags_of_selected_photos": "Tags der ausgewählten Fotos:",
      "trashbin_trashed_photos": "Papierkorb - gelöschte Fotos",
      "unsaved_album_warning": "Album „{album}“ vor dem Speichern hinzufügen.",
      "upload_photos": "Fotos hochladen",
      "use_inputs_from_latest_photo": "Eingaben vom letzten Foto",
      "use_photo_as_template": "Als Vorlage",
      "create_task_with_photo": "Task mit Foto erstellen",
      "used_in_all_photos": "Bei allen Fotos zugewiesen:",
      "used_in_some_photos": "Bei einigen Fotos zugewiesen:",
      "warning_add_photos": "Fügen Sie Fotos hinzu",
      "warning_select_photo_album": "Wählen Sie ein Fotoalbum aus.",
      "x_of_y_photos": "{filteredCounter} von {unfilteredCounter} Fotos",
      "x_photo_captured": "{x} Fotos aufgenommen",
      "x_photos_selected": "{x} Fotos ausgewählt"
    },
    "photo_properties": "Fotoeigenschaften",
    "project": {
      "dashboard": {
        "heading_administration": "Administration",
        "heading_content": "Inhalte",
        "heading_my_project_profile": "Mein Projekt-Profil",
        "link_backup": "Projekt-Backup",
        "link_contact_data": "Kontaktdaten",
        "link_settings": "Einstellungen"
      },
      "go_to_account_settings": "Zum Benutzerkonto",
      "go_to_project_list": "Zur Projektliste",
      "maybe_you_have_no_project_access": "Möglicherweise besitzen Sie keinen Projektzugang mehr.",
      "project_not_available": "Projekt nicht verfügbar",
      "switch_project": "Projekt wechseln",
      "two_factor_auth_required_message": "Bitte aktivieren Sie die 2-Faktor-Authentifizierung in Ihrem Benutzerkonto um auf dieses Projekt zugreifen zu können.",
      "two_factor_auth_required_title": "Projektzugriff erfordert 2-Faktor-Authentifizierung"
    },
    "project_header": {
      "clipboard": {
        "all_files": "Alle Dateien",
        "assign_files_from_clipboard": "{badge} aus Zwischenablage zuweisen",
        "assigned": "zugewiesen",
        "button": {
          "multiple_uploads_running": "{count} Uploads laufen …",
          "my_clipboard": "Meine Zwischenablage",
          "one_upload_running": "1 Upload läuft …"
        },
        "drag_files_here": "Dateien hier ablegen …",
        "drag_files_to_clipboard": "Hier ablegen, um den Upload zu starten",
        "file_assigned": "zugewiesen",
        "file_name": "Dateiname",
        "file_not_visible_in_project": "noch nicht im Projekt sichtbar!",
        "file_status": "Status",
        "file_type": "Typ",
        "info_box": {
          "click_or_drag": "Klicken Sie auf „Dateien auswählen“ oder Sie ziehen die Dateien direkt in die Zwischenablage.",
          "how_clipboard_makes_pf_easier": "Wie die Zwischenablage das Arbeiten mit PLANFRED erleichtert"
        },
        "manage_my_clipboard": "Meine Zwischenablage verwalten",
        "no_files_in_clipboard": "Es befinden sich derzeit keine Dateien in der Zwischenablage, welche zugewiesen werden können",
        "no_running_uploads": "Keine laufenden Uploads",
        "not_assigned": "Nicht zugewiesen",
        "or_drop_files_here": "oder einfach hierher ziehen!",
        "remove_all_files": "angezeigte Liste leeren",
        "remove_files": "Liste leeren",
        "running_uploads": "Laufende Uploads …",
        "running_uploads_leave_anyways": "Aktuell werden Dokumente hochgeladen. Beim Verlassen der Seite wird der Upload abgebrochen.",
        "running_uploads_logout_anyways": "Ausloggen und alle laufenden Uploads abbrechen?",
        "select_files": "Dateien auswählen",
        "select_files_from_pc": "Dateien von Ihrem Computer auswählen"
      },
      "flap": {
        "currently_no_uploads": "Noch keine Pläne oder Dokumente hochgeladen",
        "document_upload": "Dokumente",
        "last_upload": "Letzte Uploads",
        "my_upload_notifier": "Mein Upload-Melder",
        "plan_upload": "Pläne",
        "week_start_report": "Wochenstart Report"
      },
      "settings_link": "Einstellungen",
      "tab_nav_bar": {
        "activities": "Aktivitäten",
        "documents": "Dokumente",
        "general": "Allgemein",
        "mailer": "Multi-Versand",
        "notifications": "E-Mail Melder",
        "participants": "Beteiligte",
        "photodoc": "FotoDok",
        "photodoc_trashed": "FotoDok Papierkorb",
        "plans": "Pläne",
        "project_transfer_ownership": "Projektübertragung",
        "settings": "Einstellungen",
        "tasks": "Tasks",
        "to_be_approved_by_me": "… von mir<br>zu prüfen"
      }
    },
    "project_list": {
      "create_first_new_project": "Erstes eigenes Projekt anlegen",
      "create_new_demo_project": "Neues Demo-Projekt anlegen",
      "create_new_project": "Eigenes Projekt anlegen",
      "need_help_with_project_organization": "Sie brauchen Hilfe bei der Projektorganisation?",
      "new_revision_available_notification_documents": "Neue Dokumente verfügbar!",
      "new_revision_available_notification_link": "Liste aktualisieren",
      "new_revision_available_notification_plans": "Neue Pläne verfügbar!",
      "no_project_participations": "Bei keinem Projekt beteiligt",
      "no_uploads_yet": "Noch keine Pläne oder Dokumente hochgeladen",
      "own_projects": "Eigene Projekte",
      "project_favorites": "Favoriten",
      "project_list": "Projektliste",
      "project_participations": "Projektbeteiligungen",
      "project_updated_at": "letzter Plan-/Dok.-Upload {updatedAt}",
      "projects": "Projekte",
      "reorder_server_error": "Reihenfolge konnte nicht geändert werden – versuchen Sie es erneut.",
      "sort_created_at": "Neueste zuerst",
      "sort_label": "Sortierung:",
      "sort_lastrevisionupload": "Letzte Änderung",
      "sort_title_asc": "Titel aufsteigend (A-Z)",
      "sort_title_desc": "Titel absteigend (Z-A)",
      "update_server_error": "Favorit konnte nicht geändert werden – versuchen Sie es erneut.",
      "welcome_account_is_active": "Ihr Benutzerkonto ist nun aktiviert.",
      "welcome_congratulations": "Glückwunsch!"
    },
    "project_new": {
      "button_create_project": "Projekt anlegen",
      "button_create_project_pending": "Projekt wird angelegt",
      "error_submit_server": "Es ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "free_without_obligation": "Dabei fallen für Sie keine Kosten an und ist garantiert unverbindlich!",
      "how_to_change_settings": "Projekteinstellungen können nach Anlegen des Projekts unter „Einstellungen“ angepasst werden",
      "how_to_change_settings_in_app": "Projekteinstellungen können nach Anlegen des Projekts in der Web-App (app.planfred.com) unter „Einstellungen“ angepasst werden",
      "import": "Import",
      "import_overlay": {
        "select_project": "Wählen Sie ein Projekt aus"
      },
      "import_project_settings": "Aus anderem Projekt übernehmen",
      "import_settings": "Einstellungen übernehmen",
      "import_settings_preview": "Einstellungen Vorschau",
      "international_project": "Internationales Projekt",
      "my_project": "Mein Projekt:",
      "my_role": "Meine Rolle im Projekt",
      "my_role_error_required": "Wählen Sie Ihre Rolle im Projekt aus oder fügen Sie eine für Sie passende Rolle hinzu.",
      "policy_consent_needed": "Sie entscheiden selbst nach Ablauf der {trialPeriodDays}-tägigen Testphase, ob Sie für PLANFRED zahlen möchten oder nicht. Wir benötigen lediglich Ihre Zustimmung zur Datenschutzerklärung und zu unseren AGBs:",
      "project_language": "Projektsprache",
      "project_settings": "Projekteinstellungen",
      "project_timezone": "Projektzeitzone",
      "project_timezone_error_required": "Wählen Sie die Projektzeitzone aus",
      "project_title_error_required": "Geben Sie einen Projekttitel ein.",
      "project_title_placeholder": "Projekttitel eingeben",
      "settings_preview": {
        "document_phase": "Dokumentenordner",
        "document_phases": "Dokumentenordner",
        "document_tag": "Dokumenten-Tag",
        "document_tags": "Dokumenten-Tags",
        "document_top_categories": "Dokumenten-Obergruppen",
        "document_top_category": "Dokumenten-Obergruppe",
        "documents_tagging_restricted_for_users": "Beteiligte dürfen keine neuen Dokumenten-Tags erstellen",
        "documents_tagging_restricted_for_users_toggle_label": "Beteiligte dürfen Dokumenten-Tags erstellen",
        "edit_project_settings": "Edit Project",
        "location_tag": "Location tag",
        "location_tags": "Location tags",
        "no_tags_available": "Keine Tags vorhanden.",
        "photo_tags": "Foto-Tags",
        "plan_phases": "Planordner",
        "plan_tag": "Plan-Tag",
        "plan_tags": "Plan-Tags",
        "plan_top_categories": "Plan-Obergruppen",
        "plans_tagging_restricted_for_users": "Beteiligte dürfen keine neuen Plan-Tags erstellen",
        "plans_tagging_restricted_for_users_toggle_label": "Beteiligte dürfen Plan-Tags erstellen",
        "role_of_participant": "Beteiligten-Rolle",
        "roles_of_participants": "Rollen der Beteiligten",
        "show_document_top_categories": "Dokumenten-Obergruppen anzeigen",
        "show_plan_top_categories": "Plan-Obergruppen anzeigen",
        "task_tag": "Task-Tag",
        "task_tags": "Task-Tags"
      },
      "show_details": "Details",
      "your_first_project": "Sie legen zum ersten Mal ein eigenes Projekt an"
    },
    "project_settings": {
      "backup": {
        "and_open_locally": "und lokal auf Ihrem Computer öffnen!",
        "backup_size": "~{size} komprimiert",
        "click_download_button": "Klicken Sie auf den Button „Backup herunterladen“",
        "click_on_open_backup": "Öffnen Sie im entpackten Projektordner die Datei „Projekt öffnen“ per Doppelklick.",
        "complete_copy_will_be_downloaded": "Beim Projekt-Backup wird eine vollständige Kopie Ihres Projekts als ausführbare Web-App erstellt und heruntergeladen.\nDiese Projektkopie kann lokal in jedem gängigen Browser geöffnet und unabhängig von den PLANFRED-Servern genutzt werden – keine Internetverbindung erforderlich.",
        "download_project": "Projekt herunterladen",
        "how_backup_works": "Wie funktioniert das Projekt-Backup?",
        "manual": "Anleitung:",
        "open_project_locally": "Projekt lokal öffnen",
        "project_backup": "Projekt-Backup",
        "project_size_on_server": "Projektgröße am Server:",
        "project_backup_size_estimated": "Geschätzte Backupgröße:",
        "project_backup_size": "Die Größe des Projekt-Backups hängt von den konkreten Inhalten und deren Meta-Daten ab.",
        "save_project_locally": "Projekt lokal speichern",
        "stuffit_expander": "StuffIt Expander",
        "unzip_file": "Entpacken Sie die heruntergeladene Datei.",
        "unzip_file_headline": "ZIP-Datei entpacken"
      },
      "banner_ownership_transfer": {
        "accept_project": "Projekt annehmen",
        "confirm_agb_to_accept": "Die Projektübertragung kann erst durchgeführt werden, sobald Sie unseren AGBs und der Datenschutzerklärung zugestimmt haben.",
        "decline_project": "Projekt ablehnen",
        "project_transfer": "Projektübertragung „{projectTitle}“",
        "project_transfer_successful": "Die Projektübertragung wurde erfolgreich abgeschlossen.",
        "server_error": "Beim Speichern ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "wants_to_transfer_project": "{participantLink} möchte Ihnen das Projekt „{projectTitle}“ übertragen und Sie zum neuen Projekteigentümer machen.",
        "what_happens_during_project_transfer": "Was geschieht bei einer Projektübertragung?",
        "you_are_now_owner_of_project": "Sie sind nun der neue Eigentümer des Projekts "
      },
      "base_error": "Ein Fehler ist aufgetreten – versuchen Sie es erneut.",
      "delete": {
        "confirm_delete_by_enter_word": "Bestätigen Sie den Löschvorgang durch Eingabe des Wortes „{deleteWord}“",
        "create_backup_before_delete": "Erstellen Sie vor dem Löschen ein Projekt-Backup",
        "delete_project": "Projekt löschen",
        "delete_project_forever": "Projekt unwiderruflich löschen!",
        "delete_server_error": "Beim Löschen des Projekts ist ein Fehler aufgetreten.",
        "demo_cant_get_deleted": "Das Demo-Projekt kann nicht gelöscht werden.",
        "hint": "Tipp:"
      },
      "delete_item": "Delete item?",
      "delete_label": "{label} löschen",
      "delete_message": "'{value}' wird gelöscht",
      "edit_project_title": "Projekttitel ändern",
      "project_title": "Projekttitel",
      "email_notifier": "E-Mail Melder",
      "email_notifier_extended": "Mein E-Mail Melder für dieses Projekt",
      "email_notifier_headline": "Mein E-Mail Melder",
      "error_could_not_save_project_title": "Der Projekttitel konnte nicht gespeichert werden.",
      "import": {
        "already_imported_message": "Es wurden bereits alle Tags „{property}“ importiert.",
        "import_all_button_label": "Alle importieren",
        "import_all_from_button_label": "Alle aus „{property}“ importieren",
        "import_from_project": "Aus Projekt importieren",
        "import_properties_from_another_project": "„{property}“ importieren",
        "no_items_available_message": "Es sind keine Tags „{property}“ in diesem Projekt vorhanden."
      },
      "my_project": "Mein Projekt:",
      "nav": {
        "documents": "Dokumente",
        "general": "Allgemein",
        "locations": "Verortung",
        "participants": "Beteiligte",
        "photos": "FotoDok",
        "plans": "Pläne",
        "tasks": "Tasks"
      },
      "not_allowed_to_edit": "Sie sind nicht berechtigt die Projekteinstellungen zu ändern",
      "ownership_transfer": {
        "1_description": "Der neue Projekteigentümer muss Beteiligter im Projekt sein und ein PLANFRED-Paket besitzen (ggf. zum Projekt einladen und Benutzerkonto mit Paket versehen).",
        "1_title": "Vorbereitung",
        "2_title": "Übertragung einleiten",
        "3_description": "Die Projektübertragung erfolgt, sobald der neue Eigentümer die Annahme des Projekts bestätigt (Anfrage per E-Mail). Der bisherige Eigentümer wird anschließend automatisch zum Projekt-Administrator.",
        "3_title": "Bestätigung durch neuen Eigentümer",
        "abort_transfer": "Projektübertragung abbrechen",
        "abort_transfer_server_error": "Die Projektübertragung konnte nicht abgebrochen werden – versuchen Sie es erneut.",
        "choose_new_owner": "Wählen Sie den neuen Projekteigentümer:",
        "current_owner": "Aktueller Projekteigentümer:",
        "manual_link_text": "Zur Anleitung „S2 Projektübertragung – Projekteigentümer ändern“",
        "not_allowed_to_transfer": "Sie sind nicht berechtigt dieses Projekt zu übertragen, weil Sie nicht oder nicht mehr der Projekteigentümer sind.",
        "owner_becomes_admin_after_transfer": "Ein Projekteigentümer kann sein Projekt jederzeit an einen Beteiligten übertragen. Dabei bleiben sämtliche Projektdaten vollständig erhalten – lediglich der Projekteigentümer wird geändert. Sobald ein Benutzerkonto nicht mehr als Projekteigentümer geführt wird, endet auch die Testphase bzw. die Zahlungspflicht (das Paket kann auf\n„FREE“ umgestellt werden).",
        "project_transfer": "Projektübertragung",
        "start_transfer": "Übertragung einleiten",
        "transfer_only_to_participants_with_plan": "Das Projekt kann nur an einen Beteiligten mit beauftragtem Paket übertragen werden.",
        "transfer_pending": "Die Projektübertragung wurde eingeleitet und wartet nun auf die Bestätigung durch den neuen Eigentümer",
        "transfer_project_to": "Projekt übertragen an …",
        "transfer_server_error": "Die Projektübertragung konnte nicht durchgeführt werden – versuchen Sie es erneut."
      },
      "plan_tags": {
        "edit_plan_tag": "Plan-Tag editieren"
      },
      "project_language": {
        "language_for_participants_individually": "Jeder Beteiligte kann die Sprache seiner Benutzeroberfläche individuell einstellen (siehe Fußzeile).",
        "no_translation_for_tags_etc": "Beim Ändern der Projektsprache werden die Einstellungen (Planordner, Rollen, Tags usw.) nicht übersetzt – alle E-Mails werden jedoch in der gewählten Projektsprache versendet.",
        "phasetag_tag_roles_dont_get_translated": "Planordner, Rollen und Tags werden nicht übersetzt.",
        "please_check_if_necessary": "Prüfen und übersetzen Sie diese bei Bedarf.",
        "server_error": "Beim Speichern der Sprache ist ein Fehler aufgetreten – versuchen Sie es erneut."
      },
      "project_owner_label": "Projekteigentümer:",
      "project_timezone": {
        "edit_timezone": "Zeitzone ändern",
        "no_timezone_selected": "Keine Zeitzone ausgewählt",
        "server_error": "Beim Speichern der Zeitzone ist ein Fehler aufgetreten – versuchen Sie es erneut."
      },
      "project_transfer": "Projektübertragung",
      "settings_and_backup": "Projekteinstellungen",
      "two_factor_auth_required_headline": "Projektzugriff",
      "two_factor_auth_required_toggle_label": "2FA für Projektzugriff erforderlich",
      "two_factor_auth_required_description": "Projektbeteiligte müssen die 2-Faktor-Authentifizierung (2FA) aktiviert haben, um auf dieses Projekt zugreifen zu können.",
      "two_factor_auth_required_not_enabled_title": "2FA ist für Ihr Benutzerkonto nicht aktiviert.",
      "two_factor_auth_required_enable_first": "Aktivieren Sie die 2-Faktor-Authentifizierung in Ihrem Benutzerkonto, um diese Einstellung verwenden zu können.",
      "two_factor_auth_required_go_to_settings": "Zum Benutzerkonto",
      "two_factor_auth_required_go_to_2fa": "Zur 2-Faktor-Authentifizierung",
      "two_factor_auth_required_server_error": "Beim Speichern der Einstellung ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "tag_manager": {
        "add_server_error": "„{label}“ konnte nicht hinzugefügt werden – versuchen Sie es erneut.",
        "delete_server_error": "„{label}“ konnte nicht gelöscht werden – versuchen Sie es erneut.",
        "edit_server_error": "„{label}“ konnte nicht geändert werden – versuchen Sie es erneut.",
        "minimum_one_document_phasetag": "Der letzte Dokumentenordner kann nicht gelöscht werden.",
        "minimum_one_document_top_category": "Die letzte Dokumenten-Obergruppe kann nicht gelöscht werden.",
        "minimum_one_plan_phasetag": "Der letzte Planordner kann nicht gelöscht werden.",
        "minimum_one_plan_top_category": "Die letzte Plan-Obergruppe kann nicht gelöscht werden.",
        "new_document_phase": "Neuer Dokumentenordner",
        "new_plan_phase": "Neuer Planordner",
        "new_role": "Neue Rolle",
        "new_tag": "Neues Tag",
        "new_top_category_documents": "Neue Dokumenten-Obergruppe",
        "new_top_category_plans": "Neue Plan-Obergruppe",
        "no_document_tags_defined": "Noch keine Dokumenten-Tags angelegt",
        "no_photo_tags_defined": "Noch keine Foto-Tags angelegt",
        "no_plan_tags_defined": "Noch keine Plan-Tags angelegt",
        "no_task_tags_defined": "Noch keine Task-Tags angelegt",
        "reorder_server_error": "Die Reihenfolge konnte nicht geändert werden – versuchen Sie es erneut."
      },
      "tasks": {
        "activate_location_property": "Verortungskategorie „{locationProperty}“",
        "cannot_delete_last_location_property": "Die letzte Verortung kann nicht gelöscht werden",
        "edit_task_location": "Edit Task locations",
        "enable_tasks_tab": "Tasks für dieses Projekt aktivieren",
        "enable_tasks_tab_cannot_be_disabled_hint": "Tasks kann in diesem Projekt nachdem es aktiviert wurde nicht mehr deaktiviert werden.",
        "location_tags": "Verortungstags",
        "new_task_type": "Neue Task Kategorie",
        "save_task_location_label_server_error": "Die Verortung konnte nicht gespeichert werden – versuchen Sie es erneut.",
        "task_location": "Task-Verortung",
        "task_location_info": "Die Einstellungen finden Sie unter „Verortung“ (siehe oben!).",
        "task_type": "Task-Kategorie",
        "task_types": "Task-Kategorien"
      },
      "permission_owner": "Eigentümer",
      "permission_admin": "Admin"
    },
    "revision_compare": {
      "compare_indexes": "Indizes vergleichen",
      "compare_indexes_hint": "NEU: Vergleichen Sie zwei Indizes dieses Plans und erkennen Sie Unterschiede auf einen Blick.",
      "loading": "Pläne werden geladen …",
      "revision_load_error": "Der Index konnte nicht geladen werden.",
      "unsupported_file": "Diese PDF-Datei konnte nicht gelesen werden.",
      "unsupported_file_type": "{type}-Dateien können nicht verglichen werden. Der Vergleich unterstützt nur PDFs.",
      "unsupported_file_format": "Dieses Dateiformat kann nicht verglichen werden. Der Vergleich unterstützt nur PDFs.",
      "no_print_file": "Dieser Index hat keine Druck-Datei zum Vergleichen.",
      "password_protected": "Dieser Index ist passwortgeschützt und kann nicht verglichen werden.",
      "not_comparable": "Dieser Index kann nicht verglichen werden.",
      "page_position": "Seite {current} von {total}",
      "too_many_changes": "Auf dieser Seite wurden zu viele Unterschiede gefunden, um sie einzeln zu markieren.",
      "changes_detection_error": "Diese Seite konnte nicht auf Unterschiede geprüft werden.",
      "changes_dimension_mismatch": "Die Seitenformate weichen ab – Unterschiede können nicht markiert werden.",
      "page_added_short": "neu",
      "page_removed_short": "entf.",
      "page_not_in_revision": "Diese Seite existiert in diesem Index nicht.",
      "overlay_single_page_title": "Kein Überlagern möglich",
      "overlay_single_page": "Diese Seite existiert nur in einem der beiden Indizes. Zum Überlagern muss sie in beiden vorhanden sein.",
      "current_revision": "Aktueller Index",
      "swap_indexes": "Tauscht die beiden Indizes",
      "change_detection_notice_title": "Hinweis zu den automatischen Unterschiedsmarkierungen",
      "change_detection_notice_title_short": "Hinweis",
      "change_detection_notice_text": "Die Unterschiedsmarkierungen werden automatisch durch einen Bildvergleich der beiden Indizes erstellt und dienen nur zur Orientierung. Sehr kleine Abweichungen werden nicht markiert, und die Erkennung kann Unterschiede übersehen oder Stellen markieren, an denen sich nichts geändert hat. <strong>Die Unterschiedsmarkierungen ersetzen daher nicht Ihre eigene sorgfältige Prüfung der Pläne.</strong>",
      "change_detection_notice_sensitivity_label": "Empfindlichkeit der Erkennung:",
      "change_detection_notice_sensitivity_text": "Eine höhere Empfindlichkeit markiert auch mehr Stellen, an denen sich nichts geändert hat. Die Einstellung gilt, bis Sie den Vergleich schließen.",
      "change_detection_notice_sensitivity_coarse": "Grob",
      "change_detection_notice_sensitivity_coarse_description": "Markiert nur deutliche Unterschiede",
      "change_detection_notice_sensitivity_medium": "Mittel",
      "change_detection_notice_sensitivity_medium_description": "Standard – markiert auch kleinere Unterschiede",
      "change_detection_notice_sensitivity_fine": "Fein",
      "change_detection_notice_sensitivity_fine_description": "Untersucht große Pläne genauer, dauert länger",
      "change_detection_notice_details": "So funktioniert die Unterschiedserkennung",
      "change_detection_notice_details_method_title": "So entstehen die Unterschiedsmarkierungen",
      "change_detection_notice_details_threshold_title": "Warum nicht jeder Unterschied markiert wird",
      "change_detection_notice_details_limits_title": "Was das für Sie bedeutet",
      "change_detection_notice_details_method": "Beide Indizes werden seitenweise in derselben Auflösung als Bild dargestellt und Bildpunkt für Bildpunkt verglichen. Nahe beieinanderliegende Abweichungen werden zu einer gemeinsamen Unterschiedsmarkierung zusammengefasst, die somit mehrere Unterschiede umfassen kann. Verglichen wird nur, was auf der Seite sichtbar dargestellt wird – ausgeblendete Ebenen oder Dateieigenschaften bleiben unberücksichtigt. Die Erkennung beurteilt nicht, ob ein Unterschied inhaltlich von Bedeutung ist.",
      "change_detection_notice_details_threshold": "Wird eine PDF-Datei neu erzeugt, weicht ihre Darstellung häufig geringfügig ab, obwohl sich am Planinhalt nichts geändert hat – etwa bei Schraffuren, Linienstärken, Farbtönen oder minimal versetzten Linien und Schriften. Würden all diese Abweichungen markiert, wäre der Plan großflächig mit Unterschiedsmarkierungen überzogen und sie verlören ihren Nutzen als Orientierungshilfe. Die Erkennung blendet deshalb Abweichungen unterhalb festgelegter Schwellenwerte bewusst aus, insbesondere sehr kleine, vereinzelte oder farblich schwache Abweichungen.",
      "change_detection_notice_details_limits": "Es werden daher nicht alle Unterschiede zwischen den beiden Indizes markiert. Insbesondere kleine Unterschiede – etwa einzelne Zeichen in Beschriftungen oder Maßangaben, kurze dünne Linien oder kleine Symbole – können unmarkiert bleiben. Werden auf einer Seite sehr viele Unterschiede gefunden oder weichen die Seitenformate voneinander ab, werden keine Unterschiedsmarkierungen angezeigt. Werden keine Unterschiede gefunden, bedeutet das nicht, dass die beiden Indizes übereinstimmen.",
      "change_detection_notice_sketch_old": "Älterer Index",
      "change_detection_notice_sketch_new": "Neuerer Index",
      "change_detection_notice_sketch_marked": "Unterschieds­markierung",
      "change_detection_notice_sketch_unfiltered": "Ohne Schwellenwert",
      "change_detection_notice_sketch_filtered": "Mit Schwellenwert",
      "change_detection_notice_sketch_missed": "Abweichende Maßzahl bleibt unmarkiert",
      "change_detection_notice_sketch_note": "Schematische Darstellung",
      "change_detection_notice_confirm": "Verstanden, Unterschiede markieren",
      "change_detection_notice_error": "Ihre Bestätigung konnte nicht gespeichert werden. Prüfen Sie die Internetverbindung und versuchen Sie es erneut.",
      "change_detection_notice_contact_support": "Bei fehlerhafter Erkennung Support kontaktieren",
      "report_problem": "Problem melden",
      "report_problem_title": "Problem beim Indexvergleich melden",
      "report_problem_question": "Welches Problem ist aufgetreten?",
      "report_problem_debug_data_hint": "Daten zur Problembehebung werden an PLANFRED mit übermittelt."
    },
    "sharing": {
      "no_permission_to_open_view": "Keine Berechtigung zum Öffnen dieser Ansicht.",
      "sharing_auth_token_missing": "Diese Ansicht benötigt einen Sharing Token"
    },
    "sheet_compare": {
      "load_error": "Die Ansicht konnte nicht geladen werden.",
      "render_error": "Die Ansicht konnte nicht vollständig dargestellt werden. Möglicherweise ist sie für dieses Gerät zu groß.",
      "dimension_mismatch": "Unterschiedliche Formate – die Überlagerung ist möglicherweise nicht deckungsgleich.",
      "mode_split": "Geteilt",
      "mode_overlay": "Überlagert",
      "highlight_changes": "Automatisch gefundene Unterschiede markieren",
      "changes": "Unterschiede markieren",
      "changes_none": "Keine Unterschiede gefunden",
      "previous_change": "Vorherige Unterschiedsmarkierung",
      "next_change": "Nächste Unterschiedsmarkierung",
      "play": "Abspielen",
      "pause": "Pause"
    },
    "support_bar": {
      "email_topics": {
        "defect": "Mir ist ein Fehler aufgefallen",
        "new_function": "Ich hätte gerne eine neue Funktion",
        "question": "Ich habe eine andere Frage"
      },
      "prime_links": "<sup>*)</sup> Support via Screensharing nur für <a href=\"https://www.planfred.com/de/preise\" target=\"_blank\">PRIME</a>-Kunden. <a href=\"https://planfred.whereby.com/schulung\" target=\"_blank\">Prime Online-Raum öffnen</a>",
      "send_another_support_mail": "Weitere Anfrage senden",
      "send_email": "E-Mail schreiben",
      "subject": "Anfrage",
      "support_box": {
        "links": {
          "faq": "FAQ (oft gefragt)",
          "features": "Neue Funktionen",
          "in_app_support": "InApp-Support (Termin buchen)*",
          "manuals": "Anleitungen & Tipps",
          "support": "Persönlicher Support"
        },
        "title": "Sie haben Fragen zu PLANFRED? Wir beantworten sie gerne."
      },
      "support_form": {
        "browser_outdated": "Ihre veraltete Browserversion ist möglicherweise die Ursache für den Fehler. Bitte aktualisieren Sie Ihren Browser. Danke!",
        "message_required": "Eine Nachricht ist erforderlich.",
        "submit_error": "Es gab einen Fehler beim Versand Ihrer Supportanfrage.",
        "submit_success": "Danke für Ihre Anfrage!",
        "title": "… oder Sie schreiben uns einfach.",
        "topics": {
          "defect": "Beschreiben Sie den aufgetretenen Fehler",
          "new_feature": "Beschreiben Sie Ihre Wunschfunktion",
          "question": "Ihre Frage zu PLANFRED"
        }
      },
      "support_message": "Bitte schreiben sie uns eine Nachricht"
    },
    "task": {
      "detail": {
        "add_photo_or_file": "Foto/Datei hinzufügen",
        "answer_question": "Abklärung beantworten",
        "assign_task_before_publish": "Weisen Sie den Task jemanden zu, bevor Sie den Task veröffentlichen.",
        "assign_task_to_another_participant": "Task einem anderen Beteiligten zuweisen",
        "assigned_to": "Zuständigkeit:",
        "attachments": "Fotos/Anhänge:",
        "can_only_delete_files_from_latest_comment": "Es können nur Dateien des aktuellsten Kommentars gelöscht werden. Es existiert bereits ein neueres Kommentar.",
        "cannot_edit_files_from_clipboard": "Bilder aus der Zwischenablage können erst nach dem Speichern editiert werden.",
        "change_history": "Änderungsverlauf",
        "change_history_is_loading": "Änderungsverlauf wird geladen …",
        "change_task_state_to": "Status ändern auf „{stateNew}“",
        "click_icon_to_reorder": "Zum Umsortieren das Icon {icon} ziehen!",
        "comment_change_log_could_not_be_loaded_server_error": "Der Änderungsverlauf konnte nicht geladen werden – versuchen Sie es erneut.",
        "comment_history": "Kommentar-Historie",
        "confirm_delete_task_draft": "Wollen Sie den Entwurf endgültig löschen?",
        "could_not_complete_upload_of_file_x": "Die Datei \"{fileName}\" konnte nicht hochgeladen werden.",
        "create_location_value_and_assign": "{locationValue} anlegen und zuweisen",
        "creator": "Ersteller:",
        "current_comment_version": "Aktuelle Version",
        "delete_description_empty_error": "Die Beschreibung kann nicht entfernt werden, da der Inhalt des Tasks ansonsten leer wäre.",
        "delete_draft": "Verwerfen",
        "delete_file_server_error": "Beim Löschen der Datei ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "delete_file_task_empty_error": "Es muss mindestens 1 Datei vorhanden sein, ansonsten wäre der Inhalt des Tasks leer.",
        "delete_item_message": "Task wird in den Papierkorb verschoben.",
        "delete_task": "Task löschen",
        "delete_task_draft_question": "Entwurf verwerfen?",
        "delete_task_question": "Task löschen?",
        "delete_task_server_error": "Der Task konnte nicht gelöscht werden – versuchen Sie es erneut.",
        "delete_title_server_error": "Der Titel kann nicht gelöscht werden, da der Inhalt des Tasks ansonsten leer wäre.",
        "description": "Beschreibung:",
        "download_file_server_error": "Beim Download der Datei ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "due_date": "Frist:",
        "due_date_short": "Frist:",
        "duplicate_task": "Task duplizieren",
        "edit_assignee": "Zuständigkeit ändern",
        "edit_attachments": "Anhänge ändern",
        "edit_comment": "Kommentar ändern",
        "edit_description": "Beschreibung ändern",
        "edit_due_date": "Frist ändern",
        "edit_image": "Bild markieren",
        "edit_location": "Verortung ändern",
        "edit_message": "Nachricht ändern",
        "edit_tags": "Tags ändern",
        "edit_task": "Task bearbeiten",
        "edit_text": "Text ändern",
        "edit_title": "Titel",
        "edit_type": "Kategorie ändern",
        "enter_done_message": "Fertigstellung melden …",
        "enter_done_message_add_comment": "Anmerkung hinzufügen…",
        "enter_message": "Nachricht eingeben …",
        "enter_question": "Frage stellen …",
        "file_gets_deleted_and_is_not_visible_anymore": "Datei wird gelöscht und ist somit nicht mehr für andere sichtbar.",
        "files_currently_uploading": "Dateien werden hochgeladen …",
        "files_not_uploaded_yet": "Dateien wurden noch nicht hochgeladen.",
        "image": "Bild",
        "is_edited": "Task wurde editiert.",
        "location": "Verortung",
        "location_label": "Verortung:",
        "location_pin_label": "Verortungs-Pin:",
        "location_pins_label": "Verortungs-Pins:",
        "maybe_no_permission_to_view_task": "Möglicherweise besitzen Sie keine Berechtigung mehr um den Task einzusehen.",
        "missing_permission_to_add_location_values": "Möglicherweise fehlt Ihnen die erforderliche Berechtigung. Nur Admins und Projektbesitzer können Verortungen anlegen.",
        "new_message": "Neue Nachricht",
        "new_task": "Neuer Task",
        "new_version": "Neue Version",
        "no_assignee": "Keine Zuständigkeit",
        "no_description": "Keine Beschreibung verfügbar",
        "no_due_date_set": "Keine Frist",
        "no_location_layer": "Keine Verortungsplan",
        "no_location_set": "Keine Verortung",
        "no_location_tags_assigned": "Keine Verortungstags",
        "no_location_values_defined_yet": "Noch keine Einträge definiert",
        "no_message_available": "Kein Text vorhanden",
        "no_messages_yet": "Noch keine Nachrichten",
        "no_photos": "Keine Fotos/Anhänge",
        "no_task_title": "Kein Titel",
        "no_type_set": "Keine Kategorie",
        "not_assigned": "Nicht zugewiesen",
        "old_state_does_not_match_server_error": "Der Task Status wurde in der Zwischenzeit geändert.",
        "old_version": "Alte Version",
        "please_select_an_assignee_to_publish": "Wählen sie im nächsten Schritt einen Beteiligten aus um den Task zu veröffentlichen.",
        "publish_now": "Jetzt veröffentlichen",
        "publish_task": "Task veröffentlichen",
        "published_label": "Erstellt (veröffentlicht):",
        "put_to_trash": "Löschen",
        "really_delete_file": "Datei unwiederruflich löschen?",
        "remove_assignee": "Zuständigkeit entfernen",
        "remove_due_date": "Frist entfernen",
        "reorder_attachments": "Anhänge umsortieren",
        "restore_task": "Task wiederherstellen",
        "restore_task_server_error": "Der Task konnte nicht wiederhergestellt werden – versuchen Sie es erneut.",
        "save_assignee_server_error": "Beim Speichern ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_attachments_server_error": "Beim Speichern der Anhänge ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_author_server_error": "Beim Speichern des Verfassers ist ein Fehler aufgetreten. Verfasser konnte nicht geändert werden.",
        "save_comment_server_error": "Beim Speichern des Kommentars ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_description_server_error": "Beim Speichern der Beschreibung ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_document_folder_server_error": "Beim Speichern des Dokumentenordners ist ein Fehler aufgetreten. Der Dokumentenordner konnte nicht geändert werden.",
        "save_due_date_server_error": "Beim Speichern der Frist ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_location_server_error": "Beim Speichern der Verortung ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_plan_folder_server_error": "Beim Speichern des Planordners ist ein Fehler aufgetreten. Planordner konnte nicht geändert werden.",
        "save_status_update_server_error": "Beim Speichern des Statusupdates ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_tags_server_error": "Beim Speichern der Tags ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_title_server_error": "Beim Speichern des Titels ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "save_type_server_error": "Beim Speichern der Kategorie ist ein Fehler aufgetreten.",
        "send_task_reminder_header": "Erinnerung senden",
        "state": "Status:",
        "status_update_server_error": "Das Statusupdate konnte nicht gespeichert werden – versuchen Sie es erneut.",
        "task_activities": "Task-Verlauf",
        "task_assignee_missing": "Zuständigkeit festlegen",
        "task_assignee_missing_please_assign": "Vor Veröffentlichung müssen Sie die Zuständigkeit festlegen. Zuständigkeit jetzt festlegen?",
        "task_currently_uploading": "Wird gerade hochgeladen …",
        "task_currently_uploading_error": "Der Task wird gerade hochgeladen – versuchen Sie es später erneut.",
        "task_detail": "Task Detail",
        "task_draft_will_get_deleted_permanently": "Task Enwurf wird unwiederruflich gelöscht.",
        "task_messages": "Task Nachrichten",
        "task_not_available": "Task nicht verfügbar",
        "task_not_uploaded_yet": "Task wurde noch nicht hochgeladen.",
        "task_publish_server_error": "Task konnte nicht veröffentlicht werden – versuchen Sie es erneut.",
        "task_sync_server_error": "Beim Upload ist ein Fehler aufgetreten. Zum erneuten Starten der Synchronisierung, starten Sie die App neu.",
        "task_title_placeholder": "Task Titel",
        "task_type_task_state": "Kategorie / Status",
        "tasks_currently_syncing_delete_afterwards": "Der Task wird gerade hochgeladen. Löschen Sie die Datei nach dem Upload.",
        "there_is_a_newer_comment_server_error": "Dieses Kommentar kann nicht mehr aktualisiert werden. Es existiert ein Neueres.",
        "title_image": "Titelbild",
        "title_label": "Titel:",
        "type": "Kategorie:",
        "update_state": "Status ändern",
        "upload_file_server_error": "Die Datei konnte nicht hochgeladen werden – versuchen Sie es erneut.",
        "validation_enter_message_or_add_file": "Geben Sie eine Nachricht ein oder fügen Sie eine Datei hinzu."
      },
      "download_table_cols_definitions": {
        "assignee": "Zuständigkeit",
        "assignee_email": "Zuständigkeit E-Mail",
        "assignee_name": "Zuständigkeit Name",
        "assignee_role": "Zuständigkeit Rolle",
        "chats": "Chatnachrichten",
        "consecutive_number": "Nr.",
        "created_at": "Erstellungsdatum",
        "creator": "Ersteller",
        "creator_email": "Ersteller E-Mail",
        "creator_name": "Ersteller Name",
        "creator_role": "Ersteller Rolle",
        "description": "Beschreibung",
        "due_date": "Fälligkeit",
        "images": "Fotos/Anhänge",
        "location": "Verortung",
        "state": "Status",
        "tags": "Tags",
        "task_url": "Task-URL",
        "title": "Titel",
        "type": "Kategorie",
        "updated_at": "Letzte Änderung"
      },
      "export": {
        "task_list": "Task-Liste"
      },
      "list": {
        "can_select_task_after_upload": "Task kann ausgewählt werden, sobald der Upload abgeschlossen ist.",
        "click_on_link_to_create_task": "Klicken Sie auf „Neuer Task“ um einen Task zu erstellen.",
        "context_menu": {
          "delete_task": "Löschen",
          "duplicate_task": "Duplizieren",
          "edit_assignee": "Zuständigkeit",
          "edit_description": "Beschreibung",
          "edit_due_date": "Frist",
          "edit_location": "Verortung",
          "edit_tags": "Tags",
          "edit_title": "Titel",
          "edit_type": "Kategorie",
          "new_and_prefill": "Als Vorlage",
          "open_in_new_window": "In neuem Fenster öffnen",
          "restore_task": "Wiederherstellen",
          "send_task_reminder": "Erinnerung senden",
          "update_task_in_new_window": "In neuem Fenster aktualisieren"
        },
        "could_not_load_list_server_error": "Projektliste konnte nicht geladen werden.",
        "create_item": "Neuer Task",
        "document_mailer": {
          "send_task_to": "Task senden an …",
          "send_tasks_to": "{count} Tasks senden an …"
        },
        "done_tasks": "Erledigte Tasks",
        "drafts": "Entwürfe",
        "filter": {
          "1_task_due": "1 Task fällig",
          "assignee": "Zuständigkeit",
          "creator": "Ersteller",
          "currently_no_tasks": "Aktuell gibt es keine Tasks nach denen Sie filtern können.",
          "currently_no_tasks_with_assignees": "Aktuell gibt es keine Tasks die Beteiligten zugeordnet sind.",
          "due_date": "Fälligkeit",
          "filter": "Filter",
          "filter_assignee": "Filter „Zuständigkeit“",
          "filter_creator": "Filter „Ersteller“",
          "filter_due_date": "Filter „Fälligkeit“",
          "filter_location_layers": "Filter „Verortungspläne“",
          "filter_location_tags": "Filter „Verortungstags“",
          "location": "Verortung",
          "preset_question": "Abklärung",
          "preset_tasks_for_me": "Tasks für mich",
          "preset_tasks_from_me": "Tasks von mir",
          "reset": "Alle Filter zurücksetzen",
          "select_due_date_range": "Zeitraum auswählen",
          "state": "Status",
          "task_state": "Task Status",
          "type": "Kategorie",
          "x_hits": "{x} Treffer",
          "x_tasks_due": "{counter} Tasks fällig",
          "zero_hits": "0 Treffer"
        },
        "hide_1_more_attachment": "1 weiteren Anhang ausgeblendet",
        "hide_x_more_attachments": "{x} weitere Anhänge ausgeblendet",
        "keep_selected_items_in_list": "Ausgewählte Tasks bei Filteränderung behalten",
        "list_header": {
          "assignee": "Zuständigkeit",
          "consecutive_number": "Nummer",
          "creator": "Ersteller",
          "description": "Beschreibung",
          "due_date": "Frist",
          "last_update": "Letzte Änderung",
          "location": "Verortung",
          "number_short": "Nr.",
          "status": "Status",
          "title": "Titel",
          "type": "Kategorie"
        },
        "load_and_search_one_old_done_task": "1 erledigten Task, älter als 60 Tage, laden und durchsuchen",
        "load_multiple_old_done_tasks": "{counter} ältere Tasks, älter als 60 Tage, laden und durchsuchen",
        "load_one_old_done_task": "1 erledigten Task, älter als 60 Tage, nachladen",
        "modus": {
          "delete": {
            "headline_deleted_items": "Papierkorb - Gelöschte Tasks",
            "trash_icon_label": "Gelöschte Tasks"
          },
          "print": {
            "card_view": "Groß (Detaildruck)",
            "export_list": "Exportieren der gefilterten Taskliste",
            "filter_locations": "Verortung: {locations}",
            "filter_none": "Alle Tasks",
            "filter_states": "Status: {states}",
            "filter_types": "Kategorien: {types}",
            "group_by_location_layer": "Gruppierung nach Verortungsplan",
            "group_by_none": "Keine",
            "group_by_type": "Gruppierung nach Kategorie",
            "list_view": "Klein (Listendarstellung)",
            "one_task_per_page": "Max. 1 Task pro Seite",
            "overlay_print_is_being_prepared": "Ihr Tasklistenausdruck wird vorbereitet … {renderedItemsLength} von {allItemsLength}",
            "print_list": "Drucken der gefilterten Taskliste",
            "show_all_task_images": "Alle Bilder/Anhänge anzeigen",
            "show_task_description": "Task-Beschreibung anzeigen",
            "show_task_log": "Task-Verlauf (mit Anhängen) anzeigen",
            "show_task_url": "Task-URL anzeigen",
            "task_list": "Tasks",
            "tasks_count": "Taskanzahl:"
          },
          "send": {
            "mark_tasks_to_send": "… markieren Sie die gewünschten Tasks in der Liste!",
            "send_or_download_multiple_tasks": "Mehrere Tasks senden oder herunterladen"
          },
          "update": {
            "choose_task_to_update": "Wählen Sie einen Task aus!",
            "headline_update_item": "Task aktualisieren",
            "no_task_create_a_new_task": "Sie können jedoch einen neuen Task anlegen",
            "only_added_tasks_of_your_role": "Sie können nur Tasks aktualisieren bei denen Sie oder Ihre Rolle {role} Ersteller des Tasks ist.",
            "update_current_task": "Task aktualisieren"
          }
        },
        "my_drafts": "Meine Entwürfe",
        "newest_first": "Neueste zuerst",
        "no_tasks_available": "Keine Tasks vorhanden",
        "no_tasks_in_this_view_available": "In dieser Ansicht sind noch keine Tasks angelegt.",
        "oldest_first": "Älteste zuerst",
        "one_task": "1 Task",
        "print_task_list": "Drucken",
        "published_tasks": "Öffentliche Tasks",
        "search_by_task_number": "Nach Tasknummer suchen",
        "search_hits_in_comments": "Treffer in Kommentaren:",
        "search_hits_in_description": "Treffer in Beschreibung:",
        "search_picker_no_results": "Kein Task mit dieser Nummer gefunden",
        "select_due_date_range": "Zeitraum auswählen ...",
        "state_update": "Statusupdate",
        "tasks_loading": "Tasks werden geladen ...",
        "tasks_to_be_done": "Tasks zu erledigen",
        "update_list": "Liste aktualisieren",
        "x_of_y_tasks": "{filteredCounter} von {unfilteredCounter} Tasks",
        "x_tasks": "{counter} Tasks"
      },
      "multi_edit": {
        "1_task_selected": "1 Task ausgewählt",
        "assignee_of_selected_task": "Zuständigkeit des ausgewählten Tasks:",
        "assignee_of_selected_tasks": "Zuständigkeit der ausgewählten Tasks:",
        "cannot_restore_deleted_drafts": "Gelöschte Entwürfe können nicht wiederhergestellt werden",
        "category_of_selected_task": "Kategorie des ausgewählten Tasks",
        "category_of_selected_tasks": "Kategorien der ausgewählten Tasks",
        "delete_drafts_permanently": "Entwürfe entgültig löschen",
        "delete_one_task": "1 Task löschen",
        "delete_selected_task_draft": "Ausgewählten Task Entwurf entgültig löschen",
        "delete_selected_task_drafts": "Ausgewählte Task Entwürfe entgültig löschen",
        "delete_x_tasks": "{counter} Tasks löschen",
        "discard": "Verwerfen",
        "discard_1_draft": "1 Entwurf verwerfen",
        "discard_x_drafts": "{counter} Entwürfe verwerfen",
        "current_location_of_selected_task": "Aktuelle Verortung des ausgewählten Tasks:",
        "current_locations_of_selected_tasks": "Aktuelle Verortungen der ausgewählten Tasks:",
        "dueDate_of_selected_task": "Frist des ausgewählten Tasks:",
        "dueDate_of_selected_tasks": "Frist der ausgewählten Tasks:",
        "edit_due_date_of_selected_task": "Frist des ausgewählten Tasks ändern:",
        "edit_due_date_of_selected_tasks": "Frist der ausgewählten Tasks ändern:",
        "edit_location_of_selected_task": "Verortung des ausgewählten Tasks ändern auf:",
        "edit_location_of_selected_tasks": "Verortung der ausgewählten Tasks ändern auf:",
        "mixed_location_layers_warning": "Die ausgewählten Tasks befinden sich auf unterschiedlichen Verortungsplänen. Sie können alle ausgewählten Tasks auf einem gemeinsamen Verortungsplan zusammenführen.",
        "hide_1_selected_task": "1 ausgewählten Task ausblenden",
        "hide_x_selected_tasks": "{count} ausgewählte Tasks ausblenden",
        "move_selected_task_to_trash": "Ausgewählten Task in Papierkorb verschieben",
        "move_selected_tasks_to_trash": "Ausgewählte Tasks in Papierkorb verschieben",
        "no_tasks_to_edit": "Es gibt aktuell keine Tasks in Ihrer Rolle {role} {link}",
        "publish": "Veröffentlichen",
        "publish_1_task": "1 Task veröffentlichen",
        "publish_selected_draft": "Ausgewählten Task Entwurf veröffentlichen",
        "publish_selected_drafts": "Ausgewählte Task Entwürfe veröffentlichen",
        "publish_x_tasks": "{counter} Tasks veröffentlichen",
        "removes_existing_due_dates": "Fristen werden entfernt.",
        "select_task_property": "Taskeigenschaft auswählen:",
        "select_tasks": "Tasks auswählen ...",
        "selected_task_have_no_tags_attached": "Dem ausgewählten Task sind keine Tags zugeordnet",
        "selected_tasks_have_no_tags_attached": "Den ausgewählten Tasks sind keine Tags zugeordnet",
        "server_error_publish_tasks": "Beim Veröffentlichen ist ein Fehler aufgetreten - versuchen Sie es erneut.",
        "server_error_save_task_location": "Beim Speichern der Task-Verortung ist ein Fehler aufgetreten.",
        "server_error_update_assignee": "Es gab einen Fehler beim Speichern der Zuständigkeit. Zuständigkeit konnte nicht geändert werden.",
        "server_error_update_category": "Es gab einen Fehler beim Speichern der Task Kategorie. Kategorie konnte nicht geändert werden.",
        "server_error_update_dueDate": "An error occurred while saving the due-date. Due-date could not be changed.",
        "set_assignee_of_selected_task_to": "Zuständigkeit des ausgewählten Tasks ändern:",
        "set_assignee_of_selected_tasks_to": "Zuständigkeit der ausgewählten Tasks ändern:",
        "set_tags_of_selected_task": "Tags des ausgewählten Tasks ändern:",
        "set_tags_of_selected_tasks": "Tags der ausgewählten Tasks ändern:",
        "set_task_category_of_selected_task": "Task Kategorie des ausgewählten Tasks ändern:",
        "set_task_category_of_selected_tasks": "Task Kategorie der ausgewählten Tasks ändern:",
        "set_tasks_due_date_to": "Frist setzen …",
        "show_1_selected_task": "1 ausgewählten Task anzeigen",
        "show_x_selected_tasks": "{count} ausgewählte Tasks anzeigen",
        "tags_of_selected_task": "Tags des ausgewählten Tasks:",
        "tags_of_selected_tasks": "Tags der ausgewählten Tasks:",
        "task_already_published": "Der Task ist bereits veröffentlicht",
        "task_assignees_will_be_merged": "Mehrere Zuständige werden unwiderruflich zusammengeführt.",
        "task_categories_will_be_merged": "Mehrere Task Kategorien werden unwiderruflich zusammengeführt.",
        "task_leave_due_dates_remove": "Frist entfernen",
        "task_not_assigned_to_anyone": "Der Task ist noch keinem Beteiligten zugewiesen",
        "tasks_cannot_be_published": "{filteredCount} von {totalCount} Tasks können nicht veröffentlicht werden weil sie noch keinen Zuständigen zugewiesen sind",
        "tasks_cannot_be_updated": "{filteredCount} von {totalCount} Tasks können nicht bearbeitet werden",
        "this_task_cannot_be_published": "Dieser Task kann nicht veröffentlicht werden weil er noch keinem Zuständigen zugewiesen ist",
        "this_task_cannot_be_updated": "Dieser Task kann nicht bearbeitet werden",
        "update_1_task": "1 Task ändern",
        "update_x_tasks": "{counter} Tasks ändern",
        "used_on_all_tasks": "Bei allen Tasks zugewiesen:",
        "used_on_some_tasks": "Bei einigen Tasks zugewiesen:",
        "x_of_y_drafts_discarded": "{counter} von {total} Entwürfen verworfen",
        "x_of_y_tasks_published": "{counter} von {total} Tasks veröffentlicht",
        "x_task_selected": "{count} Tasks ausgewählt"
      },
      "new": {
        "add_location": "Neues Verortungstag",
        "add_title_or_description_or_attachment": "Vergeben Sie einen Titel oder eine Beschreibung oder fügen Sie einen Anhang hinzu.",
        "create_new_task": "Neuen Task erstellen",
        "create_server_error": "Beim Speichern des Tasks ist ein Fehler aufgetreten – versuchen Sie es erneut.",
        "error_could_not_load_attachments": "Einige Anhänge konnten nicht geladen werden und wurden dem Task nicht hinzugefügt.",
        "no_assignment": "Keine",
        "no_due_date": "Keine",
        "no_type": "Keine",
        "or_a_description": "… oder eine Beschreibung …",
        "or_an_attachment": "… oder fügen Sie einen Anhang hinzu.",
        "please_enter_a_title": "Vergeben Sie einen Titel …",
        "publish": "Veröffentlichen",
        "publish_directly": "Direkt veröffentlichen",
        "publish_visibility_info": "Dieser Task wird beim Veröffentlichen für den Zuständigen und dessen Rolle sowie für alle Projekt-Administratoren sichtbar!",
        "save_draft": "Entwurf speichern",
        "save_draft_and_close_tab": "Entwurf speichern und Tab schließen",
        "save_draft_and_create_new": "Entwurf speichern + weiteren Task anlegen",
        "save_publish_and_close_tab": "Veröffentlichen und Tab schließen",
        "save_publish_and_create_new": "Veröffentlichen + weiteren Task anlegen",
        "search_or_add_location": "Suche / {locationProperty} hinzufügen",
        "step_one": "Titel / Beschreibung / Fotos",
        "step_three": "Task-Zusatzinfos",
        "step_two": "Taskeigenschaften auswählen"
      },
      "open_task": "Task öffnen",
      "state_changes": {
        "button_labels": {
          "answer": "Antworten",
          "clarification": "Abklärung",
          "comment": "Kommentar",
          "comment_verb": "Kommentieren",
          "complete": "Erledigen"
        },
        "comment_done": "Anmerkung zu erledigtem Task",
        "comment_new": "Kommentar zum Task",
        "comment_reopen": "Task erneut öffnen",
        "done": "Task erledigen",
        "question_add_question": "Kommentar zur Abklärung",
        "question_answer_question": "Abklärung beantworten",
        "question_new": "Abklärung zum Task starten",
        "question_reopen": "Task öffnen und Abklärung starten"
      }
    },
    "unsaved_changes": {
      "confirmation_question": "Möchten Sie die Änderungen verwerfen?",
      "title": "Nicht gespeicherte Änderungen"
    },
    "upload_alert": {
      "continue_in_project": "weiter zum Projekt",
      "go_to_participant_detail": "Gehen Sie zur Beteiligten-Detailansicht",
      "participant": "Beteiligter:",
      "personal_responsibility_notice": "Hinweis: Die Abmeldung von automatischen E-Mail-Benachrichtigungen erfolgt in eigener Verantwortung!",
      "project": "Projekt:",
      "successfully_disabled": "Upload-Melder erfolgreich deaktiviert",
      "successfully_enabled": "Upload-Melder erfolgreich aktiviert",
      "update_server_error": "Der Upload-Melder-Status konnte nicht aktualisiert werden – versuchen Sie es erneut.",
      "user_account": "Benutzerkonto:",
      "want_to_deactivate": "Upload-Melder deaktivieren?",
      "want_to_reactivate": "Upload-Melder wieder aktivieren?"
    },
    "uploader": {
      "cad_file": "CAD-Datei",
      "clipboard": "Zwischenablage",
      "drop_file_here": "Datei hier reinziehen oder …",
      "error_dropped_file": "Die Datei ist ungültig.",
      "error_file_could_not_be_added": "1 Datei konnte nicht hinzugefügt werden",
      "error_file_empty": "{fileName} - Diese Datei ist leer.",
      "error_file_is_no_image": "Die Datei konnte nicht hochgeladen werden, da es sich nicht um ein Bild handelt.",
      "error_no_extension": "{fileName} - Diese Datei hat keine Dateiendung",
      "error_no_files_selected": "Es wurden keine Dateien selektiert – versuchen Sie es erneut.",
      "error_only_one_file_allowed": "Es kann nur 1 Datei hochgeladen werden.",
      "error_reason_could_not_open": "Konnte nicht geöffnet werden",
      "error_reason_empty": "Leer",
      "error_reason_too_large": "Größer als 20 MB",
      "error_x_files_could_not_be_added": "{counter} Dateien konnten nicht hinzugefügt werden",
      "file": "Datei",
      "file_system": "Dateisystem",
      "file_system_mobile": "Foto oder Datei",
      "from_clipboard": "aus Zwischenablage",
      "from_file_system": "aus Dateisystem",
      "modal_multiple_files": {
        "drag_files_into_doc_drop_area": "Sie können jedoch ein Datei-Paket (.zip Archiv) erstellen um mehrere Dateien in einem Dokument hochzuladen.",
        "drag_files_into_drop_area": "Ziehen Sie je <strong>eine</strong> Datei in das zugehörige Feld für DRUCK und CAD.",
        "here_is_the_clipboard_manual": "Hier geht's zur Anleitung „Multi-Upload mit Zwischenablage“",
        "only_one_file_allowed": "Mehrere Dateien können nicht auf einmal in ein Feld gezogen werden."
      },
      "or_drop_here": "oder einfach hierher ziehen!",
      "photo_attachment": "Foto / Anhang",
      "photo_picker_load_error": "Die Fotos konnten nicht geladen werden. Bitte versuche es erneut.",
      "print_file": "Druck-Datei",
      "ready_to_save": "bereit zum Speichern",
      "reset_upload": "Upload zurücksetzen",
      "select_from_photodoc": "aus FotoDok",
      "select_photos": "Fotos auswählen",
      "select_photos_from_photodoc": "Fotos aus FotoDok auswählen",
      "select_x_photo": "{count} Foto auswählen",
      "select_x_photos": "{count} Fotos auswählen",
      "server_error_upload_failed": "Der Upload ist fehlgeschlagen.",
      "upload_in_progress": "Upload läuft …",
      "upload_retry": "Nochmal hochladen",
      "validation_error_general": "Der Dateiname enthält nicht erlaubte Sonderzeichen.",
      "validation_error_minimum_one_file": "Laden Sie mindestens eine Datei hoch.",
      "validation_error_no_special_character": "Der Dateiname darf keine Sonderzeichen (;,/?:{'@'}&=+$) enthalten!",
      "validation_error_one_file": "Laden Sie eine Datei hoch.",
      "validation_error_same_extension": "Die Dateien dürfen nicht die selbe Dateiendung haben.",
      "validation_error_same_name": "Die Dateien dürfen nicht den selben Dateinamen haben.",
      "warning_cad_file_in_print": "Achtung: Es befindet sich eine CAD-Datei im DRUCK-Feld",
      "warning_print_file_in_cad": "Achtung: Es befindet sich eine DRUCK-Datei im CAD-Feld",
      "you_want_to_upload_multiple_documents": "Sie möchten mehrere Dokumente hochladen?",
      "you_want_to_upload_multiple_plans": "Sie möchten mehrere Pläne hochladen?"
    }
  },
  "layout": {
    "1_photo": "1 Foto",
    "1_pin": "1 Pin",
    "1_task": "1 Task",
    "add": "hinzufügen",
    "all_conflicts_resolved": "Alle Konflikte behoben",
    "and": "UND",
    "apply": "übernehmen",
    "approval_date": "Prüffrist",
    "approve_until": "zu prüfen bis",
    "attachments": "Foto/Anhang:",
    "author": "Verfasser",
    "back": "zurück",
    "back_to_overview": "zurück zur Übersicht",
    "beta": "Beta",
    "big": "Groß",
    "cancel": "abbrechen",
    "cancel_and_close": "abbrechen und Tab schließen",
    "change": "wechseln",
    "choose": "auswählen",
    "close": "schließen",
    "confirm": "bestätigen",
    "content_and_settings": "Inhalte & Eigenschaften",
    "copy": "kopieren",
    "copy_url": "URL kopieren",
    "copied_to_clipboard": "In Zwischenablage kopiert",
    "country_codes": {
      "at": "Österreich",
      "au": "Australien",
      "be": "Belgien",
      "bg": "Bulgarien",
      "br": "Brasilien",
      "ca": "Kanada",
      "ch": "Schweiz",
      "cy": "Zypern",
      "cz": "Tschechien",
      "de": "Deutschland",
      "dk": "Dänemark",
      "ee": "Estland",
      "es": "Spanien",
      "fi": "Finnland",
      "fr": "Frankreich",
      "gb": "Vereinigtes Königreich",
      "gr": "Griechenland",
      "hk": "Hong Kong",
      "hr": "Kroatien",
      "hu": "Ungarn",
      "ie": "Irland",
      "in": "Indien",
      "it": "Italien",
      "jp": "Japan",
      "li": "Liechtenstein",
      "lt": "Litauen",
      "lu": "Luxemburg",
      "lv": "Lettland",
      "mt": "Malta",
      "mx": "Mexiko ",
      "my": "Malaysia",
      "nl": "Niederlande",
      "no": "Norwegen",
      "nz": "Neuseeland",
      "pl": "Polen",
      "pt": "Portugal",
      "ro": "Rumänien",
      "se": "Schweden",
      "sg": "Singapur",
      "si": "Slowenien",
      "sk": "Slowakei",
      "us": "Vereinigte Staaten"
    },
    "country_reset": "Keine Auswahl",
    "created": "Erstellt",
    "date_shortcuts": {
      "7days": "In 7 Tagen",
      "end_of_next_week": "Ende nächster Woche",
      "end_of_this_week": "Ende dieser Woche",
      "last_week": "Letzte Woche",
      "next_monday": "Nächsten Montag",
      "next_week": "Nächste Woche",
      "this_week": "Diese Woche",
      "today": "Heute",
      "tomorrow": "Morgen",
      "yesterday": "Gestern"
    },
    "deactivate": "deaktivieren",
    "delete": "Löschen",
    "delete_lowercased": "löschen",
    "dictation_insert": "Text einfügen",
    "dictation_mode_for_ipad": "Diktiermodus",
    "dictation_placeholder": "Tippe auf das Mikrofon deiner Tastatur und beginne zu diktieren …",
    "discard_changes": "Eingaben verwerfen",
    "document_reviews": "Dokumentenprüfungen",
    "done": "Fertig",
    "download": "Download",
    "download_as": "Herunterladen als …",
    "duplicate": "Duplikat",
    "edit": "ändern",
    "edit_multiple_props": "Bearbeiten",
    "edited": "Bearbeitet",
    "email_label": "E-Mail:",
    "error": {
      "could_not_download_file": "Die Datei konnte nicht heruntergeladen werden – versuchen Sie es erneut.",
      "could_not_open_file": "Die Datei konnte nicht geöffnet werden.",
      "could_not_open_file_unauthorized": "Sie haben keine Zugriffsberechtigung auf diese Datei.",
      "could_not_load_data_server_error": "Die Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "could_not_save_settings": "Die Einstellung konnte nicht gespeichert werden. Kontaktieren Sie unseren Support.",
      "delete_data_error_try_again": "Beim Löschen der Daten ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "delete_error": "Fehler beim Löschen",
      "delete_file_error_try_again": "Beim Löschen der Datei ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "download_error": "Fehler beim Download",
      "email_required": "Geben Sie eine E-Mail-Adresse ein.",
      "email_validation": "Geben Sie eine gültige E-Mail-Adresse ein.",
      "error": "FEHLER",
      "file_could_not_get_replaced": "Die Datei konnte nicht ersetzt werden.",
      "file_not_available_offline": "Diese Datei wurde nicht für die Offline-Nutzung gespeichert. Dafür benötigen Sie eine Internet-Verbindung.",
      "general": "Es ist ein Fehler aufgetreten! Versuchen Sie es erneut.",
      "live_update_check_error": "Update-Prüfung fehlgeschlagen",
      "load_error": "Fehler beim Laden",
      "max_upload_file_size_20mb": "Die Datei darf maximal 20 MB groß sein",
      "offline_check_your_connection": "Sie sind aktuell offline. Prüfen Sie Ihre Internet-Verbindung.",
      "open_error": "Fehler beim Öffnen",
      "restore_error": "Fehler beim Wiederherstellen",
      "save_error": "Fehler beim Speichern",
      "send_error": "Fehler beim Versand",
      "share_error": "Fehler beim Sharing",
      "sharing_only_in_app_possible": "Sharing ist nur in der App möglich.",
      "sync_error": "Fehler beim Synchronisieren",
      "there_was_an_error_reordering_files": "Beim Ordnen der Dateien ist ein Fehler aufgetreten – versuchen Sie es erneut.",
      "unauthenticated_error": "Zugriff nicht erlaubt",
      "upload_error": "Fehler beim Hochladen",
      "upload_is_already_done": "Der Upload ist bereits abgeschlossen.",
      "view_360_not_supported": "Die 360°-Ansicht wird auf diesem Gerät nicht unterstützt.",
      "wait_until_file_got_downloaded": "Warten Sie bis die Datei heruntergeladen wurde."
    },
    "error_on_upload": "Fehler beim Upload.",
    "export": "Exportieren",
    "file_loading": "Lädt …",
    "file_not_found": "Datei nicht gefunden",
    "filter_by_text": "Nach Suchbegriff filtern …",
    "footer": {
      "any_questions": "Sie haben Fragen?",
      "our_support_team_is_available_for_you": "Unser Support-Team steht Ihnen gerne zur Verfügung.",
      "planfred_email": "E-Mail: {email}",
      "planfred_hotline": "PLANFRED-Hotline: {number}",
      "visit_us_at": "Besuchen Sie uns auf {domain}"
    },
    "from_to_to": "bis",
    "fullscreen": "Vollbild",
    "go_to_top": "Nach OBEN",
    "go_to_website": "zur Website",
    "go_to_website_url": "https://{hostname}",
    "group_by": "Gruppiere nach",
    "header": {
      "nav": {
        "check_for_updates": "Auf Updates prüfen",
        "company_list": "Unternehmen",
        "help": "Hilfe",
        "logout": "Logout",
        "profile": "Profil",
        "project_list": "Projekte",
        "troubleshooting": "Problembehebung",
        "user_account": "Benutzerkonto"
      },
      "promotion_element": {
        "apply_plan_settings": {
          "description": "Neue Pläne können jetzt mit den Eigenschaften des zuletzt hochgeladenen Plans versehen werden.",
          "title": "Einstellungen von letztem Plan übernehmen"
        },
        "compare_indexes": {
          "description": "Zwei Indizes eines Plans nebeneinander oder überlagert – Unterschiede auf einen Blick erkennen.",
          "title": "NEU: Planindexe vergleichen!"
        },
        "enhanced_manuals": {
          "description": "Online auf der Website, als PDF zum Ausdrucken oder auch als Video-Tutorial auf YouTube.",
          "title": "Noch mehr Support: PLANFRED aktualisiert die Anleitungen"
        },
        "features_2021": {
          "description": "Der Bedienkomfort von PLANFRED wurde im letzten Jahr enorm erhöht …",
          "title": "Alle neuen Features auf einen Blick"
        },
        "inline_edit": {
          "edit_items_faster": "Schneller Pläne und Dokumente bearbeiten … direkt in der Liste!",
          "edit_via_right_click": "Planordner, Tags uvm. via Rechts-Klick editieren"
        },
        "learn_more": "Mehr erfahren",
        "task_location": {
          "description": "ToDos und Mängel können jetzt mittels Pin noch genauer lokalisiert werden",
          "title": "NEU: Task-Verortung direkt am Plan!"
        },
        "tasks_is_here": {
          "description": "Ab sofort in allen PLANFRED-Paketen kostenfrei enthalten",
          "title": "Tasks – die To-Do-Liste von PLANFRED ist da!"
        },
        "top_categories": {
          "description": "Administratoren können in den Projekteinstellungen die Obergruppen für Pläne oder Dokumente einschalten.",
          "title": "Obergruppen: Projekte in Bauteile aufgliedern"
        }
      }
    },
    "hint": "TIPP:",
    "item_approval_date_presets": {
      "not_set": "Keine Frist",
      "overdue": "Überfällig"
    },
    "item_types": {
      "activities": "Aktivitäten",
      "activities_dative": "Aktivitäten",
      "activity": "Aktivität",
      "document": "Dokument",
      "document_dative": "Dokuments",
      "documents": "Dokumente",
      "documents_dative": "Dokumenten",
      "file": "Datei",
      "files": "Dateien",
      "files_dative": "Dateien",
      "locationLayer": "Verortungsplan",
      "locationLayers": "Verortungspläne",
      "locationLayers_dative": "Verortungspläne",
      "participants": "Beteiligte",
      "participants_dative": "Beteiligten",
      "permission": "Zugriffsberechtigung",
      "permissions": "Zugriffsberechtigungen",
      "photo": "Foto",
      "photos": "Fotos",
      "photos_dative": "Fotos",
      "plan": "Plan",
      "plan_dative": "Plans",
      "plans": "Pläne",
      "plans_dative": "Plänen",
      "project": "Projekt",
      "projects": "Projekte",
      "projects_dative": "Projekten",
      "role": "Rolle",
      "roles": "Rollen",
      "roles_dative": "Rollen",
      "task": "Task",
      "tasks": "Tasks",
      "tasks_dative": "Tasks",
      "users": "Benutzer",
      "users_dative": "Benutzern"
    },
    "keep_editing": "Weiter bearbeiten",
    "Label": "Bezeichnung",
    "last_update": "Letzte Änderung",
    "list": "Liste",
    "list_view": "Listenansicht",
    "location_layer": "Verortungsplan",
    "menu": "Menü",
    "message": "Nachricht:",
    "more": "Weitere",
    "newest_first": "Neueste zuerst",
    "next": "weiter",
    "next_one": "Nächster",
    "next_step": "Nächster Schritt",
    "no": "nein",
    "no_activities_yet": "Noch keine Aktivitäten",
    "no_description": "Keine Beschreibung",
    "no_files_present": "Keine Dateien vorhanden",
    "no_grouping": "Keine Gruppierung",
    "no_message": "Keine Nachricht",
    "no_note_available": "Keine Notiz vorhanden",
    "no_tags": "Keine Tags",
    "none": "Keines",
    "not_set": "Nicht gesetzt",
    "note": "Notiz",
    "note_comment": "Anmerkung",
    "ok": "Ok",
    "oldest_first": "Älteste zuerst",
    "open": "Öffnen",
    "or": "ODER",
    "photo": "Foto",
    "photo_album": "Fotoalbum",
    "pins": "Pins",
    "plan_reviews": "Planprüfungen",
    "preview": "Vorschau",
    "previous_one": "Vorheriger",
    "print": "Drucken",
    "print_being_completed": "Druckvorgang wird abgeschlossen",
    "print_capitalized": "Drucken",
    "print_click_to_close_dialog": "Klicken um Druck-Dialog zu schließen",
    "print_settings": "Druckeinstellungen:",
    "thumbnail": "Miniaturansicht",
    "detailed": "Detailansicht",
    "privacy_policy": "Datenschutz",
    "problem": "Problem",
    "package_edit_hint_text": "Einfach über Ihren Web-Browser einloggen und zum Benutzerkonto gehen.",
    "package_edit_hint_title": "Sie möchten die Paketauswahl oder die Rechnungsanschrift bearbeiten?",
    "project_title": "Projekt-Titel",
    "published": "Veröffentlicht",
    "read_more": "… mehr Informationen",
    "remove": "entfernen",
    "rename": "umbenennen",
    "reopen": "Erneut öffnen",
    "report_problem": "Bei fehlerhafter Zuordnung Support kontaktieren",
    "reset": "Reset",
    "reset_filter": "Filter zurücksetzen",
    "reset_settings": "Einstellungen zurücksetzen",
    "restore": "wiederherstellen",
    "save": "speichern",
    "save_and_close_tab": "speichern und Tab schließen",
    "save_and_submit": "speichern und abschicken",
    "search": "Suche",
    "select_all": "Alle auswählen",
    "select_all_added_participants": "Alle weiteren Beteiligten auswählen",
    "select_all_admins": "Alle Projekt-Administratoren auswählen",
    "select_all_owners": "Alle Projekt-Eigentümer auswählen",
    "select_all_participants": "Alle Projekt-Beteiligten auswählen",
    "select_all_participants_without_login": "Alle Beteiligten ohne Login auswählen",
    "select_files": "Datei(en) auswählen",
    "select_photos": "Fotos auswählen",
    "send": "senden",
    "sent_message": "Gesendete Nachricht:",
    "set_filter": "Filter setzen",
    "should_the_form_entries_be_discarded": "Sollen die Eingaben verworfen werden?",
    "show_all": "alles anzeigen",
    "show_all_activities": "Alle Aktivitäten anzeigen",
    "show_details": "Details anzeigen",
    "show_less": "weniger anzeigen",
    "show_x_hits": "{hitsCounter} Treffer anzeigen",
    "since": "seit",
    "slow_connection": "Langsame Internetverbindung.",
    "small": "Klein",
    "solve_conflict": "Konflikt lösen",
    "solve_conflicts": "Konflikte lösen",
    "sort_by": "Sortieren nach:",
    "sort_selected_first": "Ausgewählte zuerst",
    "sort_selected_last": "Ausgewählte zuletzt",
    "switch_to_list": "zur Listenansicht wechseln",
    "task_due_date_presets": {
      "not_set": "Keine Frist",
      "overdue": "Überfällig",
      "upcoming": "Bevorstehend"
    },
    "task_states": {
      "done": "Erledigt",
      "draft": "Entwurf",
      "execution": "In Bearbeitung",
      "open": "Offen",
      "question": "In Abklärung"
    },
    "task_states_reaction": {
      "done": "Erledigen",
      "draft": "Entwurf",
      "execution": "Notiz",
      "open": "Offen",
      "question": "Abklärung"
    },
    "terms_and_imprint": "AGBs & Impressum",
    "text_search": "Textsuche",
    "title": "Titel",
    "unknown_file": "Unbekannte Datei",
    "unlimited": "unbegrenzt",
    "up_to_date": "App ist aktuell",
    "update_1_photo": "1 Foto ändern",
    "update_x_photos": "{x} Fotos ändern",
    "upload": "Hochladen",
    "upload_as_soon_as_connection_is_stable": "Upload erfolgt bei stabiler Verbindung.",
    "url_copied_to_clipboard": "URL in Zwischenablage kopiert",
    "view_full_size": "Original öffnen",
    "view_fullscreen": "Vollbild",
    "view_in_browser": "Im Browser-Viewer öffnen",
    "view_in_embedpdf": "Im Standard-Viewer öffnen",
    "view_settings": "Anzeigeeinstellungen",
    "with_note": "Mit Notiz",
    "without_note": "Ohne Notiz",
    "x_of_y": "{x} von {y}",
    "x_of_y_already_imported": "{counter} von {total} importiert",
    "x_photos": "{x} Fotos",
    "x_pins": "{x} Pins",
    "x_tasks": "{x} Tasks",
    "yes": "ja",
    "zoom_in": "Vergrößern",
    "zoom_out": "Verkleinern"
  },
  "page_titles": {
    "account": "Account",
    "activities": "Aktivitäten",
    "changelog": "Änderungshistorie",
    "confirm_password": "Passwort bestätigen",
    "dashboard": "Projekt",
    "dashboard_long": "Projektübersicht",
    "dashboard_settings": "Projekt",
    "documents": "Dokumente",
    "documents_new": "Neues Dokument",
    "documents_trashed": "Dokumente Papierkorb",
    "download": "Download",
    "email_notifier": "E-Mail Melder",
    "forgot_password": "Passwort vergessen",
    "general": "Allgemein",
    "login": "Login",
    "mailer": "Multi-Versand",
    "no_account": "Noch kein Benutzerkonto?",
    "notification_settings": "Benachrichtigungseinstellungen",
    "notifications": "Benachrichtigungseinstellungen",
    "participants": "Beteiligte",
    "participants_new": "Neuer Beteiligter",
    "participants_trashed": "Beteiligte Papierkorb",
    "photodoc": "FotoDok",
    "photos_new": "Neues Foto",
    "plans": "Pläne",
    "plans_new": "Neuer Plan",
    "plans_trashed": "Pläne Papierkorb",
    "project_dashboard": "Projektzentrale",
    "project_settings": "Projekteinstellungen",
    "project_transfer": "Projektübertragung",
    "projects": "Projekte",
    "projects_new": "Projekt anlegen",
    "registration": "Registrieren",
    "settings": "Einstellungen",
    "tasks": "Tasks",
    "tasks_new": "Neuer Task",
    "tasks_trashed": "Tasks Papierkorb",
    "upload_alert": "Upload-Melder"
  },
  "project_manager": {
    "project_manager_category": "Kategorie"
  }
}
